var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function _mergeNamespaces(n, m) {
  for (var i = 0; i < m.length; i++) {
    const e = m[i];
    if (typeof e !== "string" && !Array.isArray(e)) {
      for (const k in e) {
        if (k !== "default" && !(k in n)) {
          const d = Object.getOwnPropertyDescriptor(e, k);
          if (d) {
            Object.defineProperty(n, k, d.get ? d : {
              enumerable: true,
              get: () => e[k]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var utils = {};
(function(exports) {
  var hexTable = function() {
    var array = new Array(256);
    for (var i = 0; i < 256; ++i) {
      array[i] = "%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase();
    }
    return array;
  }();
  var has2 = Object.prototype.hasOwnProperty;
  exports.arrayToObject = function(source, options) {
    var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
      if (typeof source[i] !== "undefined") {
        obj[i] = source[i];
      }
    }
    return obj;
  };
  var isArray2 = Array.isArray;
  var arrayToObject = function arrayToObject2(source, options) {
    var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
      if (typeof source[i] !== "undefined") {
        obj[i] = source[i];
      }
    }
    return obj;
  };
  exports.merge = function merge(target, source, options) {
    if (!source) {
      return target;
    }
    if (typeof source !== "object") {
      if (isArray2(target)) {
        target.push(source);
      } else if (target && typeof target === "object") {
        if (options && (options.plainObjects || options.allowPrototypes) || !has2.call(Object.prototype, source)) {
          target[source] = true;
        }
      } else {
        return [target, source];
      }
      return target;
    }
    if (!target || typeof target !== "object") {
      return [target].concat(source);
    }
    var mergeTarget = target;
    if (isArray2(target) && !isArray2(source)) {
      mergeTarget = arrayToObject(target, options);
    }
    if (isArray2(target) && isArray2(source)) {
      source.forEach(function(item, i) {
        if (has2.call(target, i)) {
          var targetItem = target[i];
          if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
            target[i] = merge(targetItem, item, options);
          } else {
            target.push(item);
          }
        } else {
          target[i] = item;
        }
      });
      return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
      var value = source[key];
      if (has2.call(acc, key)) {
        acc[key] = merge(acc[key], value, options);
      } else {
        acc[key] = value;
      }
      return acc;
    }, mergeTarget);
  };
  exports.decode = function(str) {
    try {
      return decodeURIComponent(str.replace(/\+/g, " "));
    } catch (e) {
      return str;
    }
  };
  exports.encode = function(str) {
    if (str.length === 0) {
      return str;
    }
    var string = typeof str === "string" ? str : String(str);
    var out = "";
    for (var i = 0; i < string.length; ++i) {
      var c2 = string.charCodeAt(i);
      if (c2 === 45 || c2 === 46 || c2 === 95 || c2 === 126 || c2 >= 48 && c2 <= 57 || c2 >= 65 && c2 <= 90 || c2 >= 97 && c2 <= 122) {
        out += string.charAt(i);
        continue;
      }
      if (c2 < 128) {
        out = out + hexTable[c2];
        continue;
      }
      if (c2 < 2048) {
        out = out + (hexTable[192 | c2 >> 6] + hexTable[128 | c2 & 63]);
        continue;
      }
      if (c2 < 55296 || c2 >= 57344) {
        out = out + (hexTable[224 | c2 >> 12] + hexTable[128 | c2 >> 6 & 63] + hexTable[128 | c2 & 63]);
        continue;
      }
      i += 1;
      c2 = 65536 + ((c2 & 1023) << 10 | string.charCodeAt(i) & 1023);
      out += hexTable[240 | c2 >> 18] + hexTable[128 | c2 >> 12 & 63] + hexTable[128 | c2 >> 6 & 63] + hexTable[128 | c2 & 63];
    }
    return out;
  };
  exports.compact = function(obj, references) {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }
    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
      return refs[lookup];
    }
    refs.push(obj);
    if (isArray2(obj)) {
      var compacted = [];
      for (var i = 0; i < obj.length; ++i) {
        if (obj[i] && typeof obj[i] === "object") {
          compacted.push(exports.compact(obj[i], refs));
        } else if (typeof obj[i] !== "undefined") {
          compacted.push(obj[i]);
        }
      }
      return compacted;
    }
    var keys = Object.keys(obj);
    for (var j2 = 0; j2 < keys.length; ++j2) {
      var key = keys[j2];
      obj[key] = exports.compact(obj[key], refs);
    }
    return obj;
  };
  exports.isRegExp = function(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
  };
  exports.isBuffer = function(obj) {
    if (obj === null || typeof obj === "undefined") {
      return false;
    }
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
  };
})(utils);
var Utils$1 = utils;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + "[]";
  },
  indices: function indices(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var defaults$1 = {
  delimiter: "&",
  strictNullHandling: false,
  skipNulls: false,
  encode: true,
  encoder: Utils$1.encode
};
var isArray$1 = Array.isArray;
var stringify = function stringify2(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots) {
  var obj = object;
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = obj.toISOString();
  } else if (obj === null) {
    if (strictNullHandling) {
      return encoder ? encoder(prefix) : prefix;
    }
    obj = "";
  }
  if (typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean" || Utils$1.isBuffer(obj)) {
    if (encoder) {
      return [encoder(prefix) + "=" + encoder(obj)];
    }
    return [prefix + "=" + String(obj)];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (isArray$1(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }
  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    if (skipNulls && obj[key] === null) {
      continue;
    }
    if (isArray$1(obj)) {
      values = values.concat(stringify2(
        obj[key],
        generateArrayPrefix(prefix, key),
        generateArrayPrefix,
        strictNullHandling,
        skipNulls,
        encoder,
        filter,
        sort,
        allowDots
      ));
    } else {
      values = values.concat(stringify2(
        obj[key],
        prefix + (allowDots ? "." + key : "[" + key + "]"),
        generateArrayPrefix,
        strictNullHandling,
        skipNulls,
        encoder,
        filter,
        sort,
        allowDots
      ));
    }
  }
  return values;
};
var stringify_1 = function(object, opts) {
  var obj = object;
  var options = opts || {};
  var delimiter = typeof options.delimiter === "undefined" ? defaults$1.delimiter : options.delimiter;
  var strictNullHandling = typeof options.strictNullHandling === "boolean" ? options.strictNullHandling : defaults$1.strictNullHandling;
  var skipNulls = typeof options.skipNulls === "boolean" ? options.skipNulls : defaults$1.skipNulls;
  var encode = typeof options.encode === "boolean" ? options.encode : defaults$1.encode;
  var encoder = encode ? typeof options.encoder === "function" ? options.encoder : defaults$1.encoder : null;
  var sort = typeof options.sort === "function" ? options.sort : null;
  var allowDots = typeof options.allowDots === "undefined" ? false : options.allowDots;
  var objKeys;
  var filter;
  if (options.encoder !== null && typeof options.encoder !== "undefined" && typeof options.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$1(options.filter)) {
    objKeys = options.filter;
    filter = options.filter;
  }
  var keys = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var arrayFormat;
  if (options.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = options.arrayFormat;
  } else if ("indices" in options) {
    arrayFormat = options.indices ? "indices" : "repeat";
  } else {
    arrayFormat = "indices";
  }
  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (sort) {
    objKeys.sort(sort);
  }
  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    if (skipNulls && obj[key] === null) {
      continue;
    }
    keys = keys.concat(stringify(
      obj[key],
      key,
      generateArrayPrefix,
      strictNullHandling,
      skipNulls,
      encoder,
      filter,
      sort,
      allowDots
    ));
  }
  return keys.join(delimiter);
};
var Utils = utils;
var has = Object.prototype.hasOwnProperty;
var defaults = {
  delimiter: "&",
  depth: 5,
  arrayLimit: 20,
  parameterLimit: 1e3,
  strictNullHandling: false,
  plainObjects: false,
  allowPrototypes: false,
  allowDots: false,
  decoder: Utils.decode
};
var parseValues = function parseValues2(str, options) {
  var obj = {};
  var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? void 0 : options.parameterLimit);
  for (var i = 0; i < parts.length; ++i) {
    var part = parts[i];
    var pos = part.indexOf("]=") === -1 ? part.indexOf("=") : part.indexOf("]=") + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part);
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos));
      val = options.decoder(part.slice(pos + 1));
    }
    if (has.call(obj, key)) {
      obj[key] = [].concat(obj[key]).concat(val);
    } else {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function parseObject2(chain, val, options) {
  if (!chain.length) {
    return val;
  }
  var root = chain.shift();
  var obj;
  if (root === "[]" && options.parseArrays) {
    obj = [];
    obj = obj.concat(parseObject2(chain, val, options));
  } else {
    obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
    var index = parseInt(cleanRoot, 10);
    if (!options.parseArrays && cleanRoot === "") {
      obj = { 0: val };
    } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && (options.parseArrays && index <= options.arrayLimit)) {
      obj = [];
      obj[index] = parseObject2(chain, val, options);
    } else if (cleanRoot !== "__proto__") {
      obj[cleanRoot] = parseObject2(chain, val, options);
    }
  }
  return obj;
};
var parseKeys = function parseKeys2(givenKey, val, options) {
  if (!givenKey) {
    return;
  }
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  var brackets2 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = brackets2.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys = [];
  if (parent) {
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(parent);
  }
  var i = 0;
  while ((segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;
    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(segment[1]);
  }
  if (segment) {
    keys.push("[" + key.slice(segment.index) + "]");
  }
  return parseObject(keys, val, options);
};
var parse = function(str, opts) {
  var options = opts || {};
  if (options.decoder !== null && options.decoder !== void 0 && typeof options.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  options.delimiter = typeof options.delimiter === "string" || Utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
  options.depth = typeof options.depth === "number" ? options.depth : defaults.depth;
  options.arrayLimit = typeof options.arrayLimit === "number" ? options.arrayLimit : defaults.arrayLimit;
  options.parseArrays = options.parseArrays !== false;
  options.decoder = typeof options.decoder === "function" ? options.decoder : defaults.decoder;
  options.allowDots = typeof options.allowDots === "boolean" ? options.allowDots : defaults.allowDots;
  options.plainObjects = typeof options.plainObjects === "boolean" ? options.plainObjects : defaults.plainObjects;
  options.allowPrototypes = typeof options.allowPrototypes === "boolean" ? options.allowPrototypes : defaults.allowPrototypes;
  options.parameterLimit = typeof options.parameterLimit === "number" ? options.parameterLimit : defaults.parameterLimit;
  options.strictNullHandling = typeof options.strictNullHandling === "boolean" ? options.strictNullHandling : defaults.strictNullHandling;
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  }
  var tempObj = typeof str === "string" ? parseValues(str, options) : str;
  var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  var keys = Object.keys(tempObj);
  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options);
    obj = Utils.merge(obj, newObj, options);
  }
  return Utils.compact(obj);
};
var Stringify = stringify_1;
var Parse = parse;
var lib = {
  stringify: Stringify,
  parse: Parse
};
const qs = /* @__PURE__ */ getDefaultExportFromCjs(lib);
const $schema = "http://json-schema.org/draft-07/schema#";
const definitions = {
  AppInfoResult: {
    description: "app 数据信息",
    properties: {
      app_id: {
        description: "- app id(android cn, ios cn)",
        type: "string"
      },
      app_name: {
        description: "- app name",
        type: "string"
      },
      city_code: {
        description: "- city code(android cn, android eu)",
        type: "string"
      },
      city_name: {
        description: "- city name(android cn, android eu)",
        type: "string"
      },
      env: {
        description: "- 当前环境 (eg: test)",
        type: "string"
      },
      lang: {
        description: "- lang (eg: en, zh)",
        type: "string"
      },
      language: {
        description: "- language (eg: zh-Hans, zh-CN)",
        type: "string"
      },
      pure_mode: {
        description: "- 当前是否是纯净模式(android cn, android eu)",
        type: "number"
      },
      region: {
        description: "- 地区",
        type: "string"
      },
      translate_function_status: {
        description: "- 是否开启了翻译",
        type: "number"
      },
      translate_lang: {
        description: "- 翻译目标语言",
        type: "string"
      },
      tz_offset: {
        description: "- 时间偏移量 ? (ios cn, ios eu)",
        type: "number"
      },
      version: {
        description: "- 版本号",
        type: "string"
      }
    },
    required: [
      "app_name",
      "env",
      "lang",
      "language",
      "region",
      "translate_function_status",
      "translate_lang",
      "version"
    ],
    type: "object"
  },
  BindMobileMPResult: {
    description: "获取微信绑定手机号返回格式",
    properties: {
      countryCode: {
        description: "- 国家码",
        type: "string"
      },
      mobile: {
        description: "- 手机号",
        type: "string"
      }
    },
    required: [
      "countryCode",
      "mobile"
    ],
    type: "object"
  },
  CountriesResult: {
    description: "获取国家选择器返回格式",
    properties: {
      abbrOfCountry: {
        description: "- 国家缩写 (eg: Germany)",
        type: "string"
      },
      callingCode: {
        description: "- 国家区号 (eg: 49)",
        type: "string"
      },
      fullName: {
        description: "- 国家全称 (eg: The Federal Republic of Germany)",
        type: "string"
      },
      group: {
        description: "- 国家分组 (eg: G)",
        type: "string"
      },
      lang: {
        description: "- 国家语言 (eg: en)",
        type: "string"
      },
      region: {
        description: "- 国家区域 (eg: DE)",
        type: "string"
      }
    },
    required: [
      "abbrOfCountry",
      "callingCode",
      "fullName",
      "group",
      "lang",
      "region"
    ],
    type: "object"
  },
  CurrencyFormatResult: {
    description: "原生为h5提供货币 format 返回的结果",
    properties: {
      currency_code: {
        description: '- "NOK"',
        type: "string"
      },
      currency_symbol: {
        description: '- "kr"',
        type: "string"
      },
      display_price: {
        description: '- "kr 123 456,89"',
        type: "string"
      },
      price: {
        description: "- 123456.889",
        type: "string"
      },
      price_format: {
        description: '- "123 456,89",',
        type: "string"
      }
    },
    required: [
      "currency_code",
      "currency_symbol",
      "display_price",
      "price",
      "price_format"
    ],
    type: "object"
  },
  ExecuteResult: {
    properties: {
      data: {
        $ref: "#/definitions/T",
        description: "- 业务数据"
      },
      display_message: {
        description: "- 执行结果 msg",
        type: "string"
      },
      error_type: {
        description: "- 错误类型( 暂不支持 | 未知错误)",
        "enum": [
          "unknown_error",
          "unsupported"
        ],
        type: "string"
      },
      result_code: {
        description: "- 执行结果 code",
        type: "string"
      }
    },
    required: [
      "result_code"
    ],
    type: "object"
  },
  ExecuteResultCallback: {
    type: "object"
  },
  GetVehicleInfoResult: {
    description: "getVehicleInfo 返回结果",
    items: {
      description: "车辆相关信息",
      properties: {
        account_id: {
          description: "- 当前账号 id",
          type: "string"
        },
        color: {
          description: "- 车辆颜色",
          type: "string"
        },
        display_name: {
          description: "- 车辆显示 name",
          type: "string"
        },
        first_activation_time: {
          description: "- 车辆激活时间",
          type: "number"
        },
        grant_type: {
          description: "- 车辆权限",
          type: "string"
        },
        hubs_style: {
          description: "- 轮毂样式",
          type: "string"
        },
        is_activated: {
          description: "- 车辆激活状态",
          type: "boolean"
        },
        is_checked: {
          description: "- 是否在车控页面选中",
          type: "boolean"
        },
        model_series: {
          description: "- 车系?? (android cn)",
          type: "string"
        },
        model_type: {
          description: "- 车型",
          type: "string"
        },
        profile: {
          description: "- 车辆 profile",
          properties: {
            model_type_year: {
              description: "- ?? (eg: G1.1)(android cn)",
              type: "string"
            },
            pretty_package_version: {
              description: "- ?? (android cn)",
              type: "string"
            }
          },
          type: "object"
        },
        v_platform: {
          description: "- 车辆平台(ios cn)",
          type: "string"
        },
        vehicle_id: {
          description: "- 车辆 id",
          type: "string"
        },
        vin: {
          description: "- 车辆 vin",
          type: "string"
        }
      },
      required: [
        "account_id",
        "display_name",
        "grant_type",
        "is_activated",
        "model_type",
        "vehicle_id",
        "vin"
      ],
      type: "object"
    },
    type: "array"
  },
  HeaderButtonConfig: {
    description: "导航栏自定义按钮组",
    properties: {
      callback: {
        description: "- JS 注册在 bridge 中的方法名，点击按钮会调用。",
        type: "string"
      },
      icon: {
        description: "- icon 配置",
        properties: {
          position: {
            description: "- 图标与文字相对位置，可空，可选值为 left 和 right，不传或为 null 或其他值，则按 left 处理 -- 图标在左，文字在右。",
            type: "string"
          },
          url: {
            description: "- 图标 url，可空，不传或为 null 则不显示图标。",
            type: "string"
          }
        },
        required: [
          "position",
          "url"
        ],
        type: "object"
      },
      text: {
        description: "- 按钮文字，可空，不传或为 null 则不显示按钮文字。",
        type: "string"
      },
      textColor: {
        description: '- 文字颜色，可空，不传或为 null 或颜色非法，则显示 "#333333"',
        type: "string"
      }
    },
    required: [
      "callback",
      "icon",
      "text",
      "textColor"
    ],
    type: "object"
  },
  HeaderIconConfig: {
    description: "导航栏 icon 配置",
    properties: {
      position: {
        description: "- 图标与文字相对位置，可空，可选值为 left 和 right，不传或为 null 或其他值，则按 left 处理 -- 图标在左，文字在右。",
        type: "string"
      },
      url: {
        description: "- 图标 url，可空，不传或为 null 则不显示图标。",
        type: "string"
      }
    },
    required: [
      "position",
      "url"
    ],
    type: "object"
  },
  HeaderSetConfig: {
    description: "设置导航栏样式",
    properties: {
      color: {
        description: "- 颜色",
        type: "string"
      },
      isSow: {
        description: "- 是否显示",
        type: "boolean"
      },
      leftColumn: {
        description: "- 左侧自定义按钮组",
        items: {
          description: "导航栏自定义按钮组",
          properties: {
            callback: {
              description: "- JS 注册在 bridge 中的方法名，点击按钮会调用。",
              type: "string"
            },
            icon: {
              description: "- icon 配置",
              properties: {
                position: {
                  description: "- 图标与文字相对位置，可空，可选值为 left 和 right，不传或为 null 或其他值，则按 left 处理 -- 图标在左，文字在右。",
                  type: "string"
                },
                url: {
                  description: "- 图标 url，可空，不传或为 null 则不显示图标。",
                  type: "string"
                }
              },
              required: [
                "position",
                "url"
              ],
              type: "object"
            },
            text: {
              description: "- 按钮文字，可空，不传或为 null 则不显示按钮文字。",
              type: "string"
            },
            textColor: {
              description: '- 文字颜色，可空，不传或为 null 或颜色非法，则显示 "#333333"',
              type: "string"
            }
          },
          required: [
            "callback",
            "icon",
            "text",
            "textColor"
          ],
          type: "object"
        },
        type: "array"
      },
      rightColumn: {
        description: "- 右侧自定义按钮组",
        items: {
          description: "导航栏自定义按钮组",
          properties: {
            callback: {
              description: "- JS 注册在 bridge 中的方法名，点击按钮会调用。",
              type: "string"
            },
            icon: {
              description: "- icon 配置",
              properties: {
                position: {
                  description: "- 图标与文字相对位置，可空，可选值为 left 和 right，不传或为 null 或其他值，则按 left 处理 -- 图标在左，文字在右。",
                  type: "string"
                },
                url: {
                  description: "- 图标 url，可空，不传或为 null 则不显示图标。",
                  type: "string"
                }
              },
              required: [
                "position",
                "url"
              ],
              type: "object"
            },
            text: {
              description: "- 按钮文字，可空，不传或为 null 则不显示按钮文字。",
              type: "string"
            },
            textColor: {
              description: '- 文字颜色，可空，不传或为 null 或颜色非法，则显示 "#333333"',
              type: "string"
            }
          },
          required: [
            "callback",
            "icon",
            "text",
            "textColor"
          ],
          type: "object"
        },
        type: "array"
      },
      title: {
        description: "- 标题配置",
        properties: {
          callback: {
            description: "- JS 注册在 bridge 中的方法名，点击标题会调用。",
            type: "string"
          },
          icon: {
            description: "- 标题图标，可空，不传或为 null 则不显示标题图标。",
            properties: {
              position: {
                description: "- 图标与文字相对位置，可空，可选值为 left 和 right，不传或为 null 或其他值，则按 left 处理 -- 图标在左，文字在右。",
                type: "string"
              },
              url: {
                description: "- 图标 url，可空，不传或为 null 则不显示图标。",
                type: "string"
              }
            },
            required: [
              "position",
              "url"
            ],
            type: "object"
          },
          text: {
            description: "- 标题文字，可空，不传或为 null 则不显示标题文字。",
            type: "string"
          },
          textColor: {
            description: '- 文字颜色，可空，不传或为 null 或颜色非法，则显示 "#333333"。',
            type: "string"
          }
        },
        required: [
          "callback",
          "icon",
          "text",
          "textColor"
        ],
        type: "object"
      }
    },
    required: [
      "color",
      "isSow",
      "leftColumn",
      "rightColumn",
      "title"
    ],
    type: "object"
  },
  HeaderTitleConfig: {
    description: "导航栏标题配置",
    properties: {
      callback: {
        description: "- JS 注册在 bridge 中的方法名，点击标题会调用。",
        type: "string"
      },
      icon: {
        description: "- 标题图标，可空，不传或为 null 则不显示标题图标。",
        properties: {
          position: {
            description: "- 图标与文字相对位置，可空，可选值为 left 和 right，不传或为 null 或其他值，则按 left 处理 -- 图标在左，文字在右。",
            type: "string"
          },
          url: {
            description: "- 图标 url，可空，不传或为 null 则不显示图标。",
            type: "string"
          }
        },
        required: [
          "position",
          "url"
        ],
        type: "object"
      },
      text: {
        description: "- 标题文字，可空，不传或为 null 则不显示标题文字。",
        type: "string"
      },
      textColor: {
        description: '- 文字颜色，可空，不传或为 null 或颜色非法，则显示 "#333333"。',
        type: "string"
      }
    },
    required: [
      "callback",
      "icon",
      "text",
      "textColor"
    ],
    type: "object"
  },
  ImagePickerObject: {
    description: "图片选择器返回结果",
    properties: {
      identifier: {
        description: "- 图片id",
        type: "string"
      },
      preview_url: {
        description: "- 图片预览 url",
        type: "string"
      },
      type: {
        description: "- 图片类型(eg: image/jpeg)",
        type: "string"
      },
      url: {
        description: "- 图片 url",
        type: "string"
      }
    },
    required: [
      "type",
      "url"
    ],
    type: "object"
  },
  ImagePickerResult: {
    description: "imagePicker 返回结果",
    items: {
      description: "图片选择器返回结果",
      properties: {
        identifier: {
          description: "- 图片id",
          type: "string"
        },
        preview_url: {
          description: "- 图片预览 url",
          type: "string"
        },
        type: {
          description: "- 图片类型(eg: image/jpeg)",
          type: "string"
        },
        url: {
          description: "- 图片 url",
          type: "string"
        }
      },
      required: [
        "type",
        "url"
      ],
      type: "object"
    },
    type: "array"
  },
  LocationResult: {
    description: "定位信息结果",
    properties: {
      latitude: {
        description: "- 纬度",
        type: "number"
      },
      longitude: {
        description: "- 经度",
        type: "number"
      },
      type: {
        description: "- 经纬度类型",
        type: "string"
      }
    },
    required: [
      "latitude",
      "longitude",
      "type"
    ],
    type: "object"
  },
  ModuleInfoResult: {
    description: "模块信息",
    properties: {
      is_active: {
        description: "- 是否激活",
        type: "boolean"
      },
      local_url: {
        description: "- 离线包 file 协议地址(ios cn)",
        type: "string"
      },
      module_id: {
        description: "- 模块 id",
        type: "string"
      },
      package_md5: {
        description: "- 离线包 md5(ios cn)",
        type: "string"
      },
      package_url: {
        description: "- 当前包的 url",
        type: "string"
      },
      release_note: {
        description: "- 发布日志(ios cn)",
        type: "string"
      },
      version: {
        description: "- 版本",
        type: "string"
      }
    },
    type: "object"
  },
  NotificationAuthorizationResult: {
    description: "通知授权状态",
    properties: {
      detail: {
        description: "- 详情",
        properties: {
          alertSetting: {
            type: "string"
          },
          authorizationStatus: {
            type: "string"
          },
          badgeSetting: {
            type: "string"
          },
          carPlaySetting: {
            type: "string"
          },
          lockScreenSetting: {
            type: "string"
          },
          notificationCenterSetting: {
            type: "string"
          },
          soundSetting: {
            type: "string"
          }
        },
        required: [
          "alertSetting",
          "authorizationStatus",
          "badgeSetting",
          "carPlaySetting",
          "lockScreenSetting",
          "notificationCenterSetting",
          "soundSetting"
        ],
        type: "object"
      },
      hasPermisstion: {
        description: "- 是否有通知权限",
        type: "boolean"
      }
    },
    required: [
      "detail",
      "hasPermisstion"
    ],
    type: "object"
  },
  NotificationSettingsResult: {
    description: "系统通知设置",
    properties: {
      detail: {
        description: "- 推送配置详情(ios cn, ios eu)",
        properties: {
          alertSetting: {
            type: "string"
          },
          authorizationStatus: {
            type: "string"
          },
          badgeSetting: {
            type: "string"
          },
          carPlaySetting: {
            type: "string"
          },
          lockScreenSetting: {
            type: "string"
          },
          notificationCenterSetting: {
            type: "string"
          },
          soundSetting: {
            type: "string"
          }
        },
        type: "object"
      },
      hasPermisstion: {
        description: "- 是否授权(拼写错误, 不能改)",
        type: "boolean"
      }
    },
    required: [
      "hasPermisstion"
    ],
    type: "object"
  },
  NumberFormatResult: {
    description: "格式化数字返回结果",
    properties: {
      number: {
        description: "- 原数字",
        type: "number"
      },
      number_display: {
        description: "-  格式化后的数字",
        type: "string"
      }
    },
    required: [
      "number",
      "number_display"
    ],
    type: "object"
  },
  OSInfoResult: {
    description: "系统数据信息",
    properties: {
      batteryLevel: {
        description: "- 电池 level (iOS cn, iOS eu)",
        type: "number"
      },
      batteryState: {
        description: "- 电池状态 (iOS cn, iOS eu)",
        type: "number"
      },
      brand: {
        description: "- 手机品牌 ?? (eg: google)(android cn, android eu)",
        type: "string"
      },
      deviceModel: {
        description: "- ?? (eg:x86_64) (iOS cn, iOS eu)",
        type: "string"
      },
      device_id: {
        description: "- 设备 id",
        type: "string"
      },
      localizedModel: {
        description: "- ?? (eg:iPhone)(iOS cn, iOS eu)",
        type: "string"
      },
      model: {
        description: "- ?? (eg:iPhone, sdk_gphone64_arm64)",
        type: "string"
      },
      safeAreaInsets: {
        description: "- 安全区域",
        properties: {
          bottom: {
            description: "- 底部距离",
            type: "number"
          },
          left: {
            description: "- 左边距离",
            type: "number"
          },
          right: {
            description: "- 右边距离",
            type: "number"
          },
          top: {
            description: "- 顶部距离",
            type: "number"
          }
        },
        required: [
          "bottom",
          "left",
          "right",
          "top"
        ],
        type: "object"
      },
      statusBarHeight: {
        description: "- 状态栏高度 (android eu)",
        type: "string"
      },
      systemName: {
        description: "- 系统名称 (eg:iOS, android)",
        type: "string"
      },
      systemVersion: {
        description: "- 系统版本 (eg:16.2, 13)",
        type: "string"
      },
      userInterfaceIdiom: {
        description: "- ?? (eg: 0) (iOS cn, iOS eu)",
        type: "number"
      }
    },
    required: [
      "device_id",
      "model",
      "safeAreaInsets",
      "systemName",
      "systemVersion"
    ],
    type: "object"
  },
  OpenNioInputEdit2Result: {
    properties: {
      data: {
        properties: {
          comment: {
            properties: {
              content: {
                type: "string"
              },
              id: {
                type: "number"
              }
            },
            required: [
              "content",
              "id"
            ],
            type: "object"
          },
          resource: {
            properties: {
              resource_id: {
                type: "string"
              },
              resource_type: {
                type: "string"
              }
            },
            required: [
              "resource_id",
              "resource_type"
            ],
            type: "object"
          }
        },
        required: [
          "comment",
          "resource"
        ],
        type: "object"
      },
      result: {
        description: "- 是否成功",
        type: "string"
      }
    },
    required: [
      "data",
      "result"
    ],
    type: "object"
  },
  PayResult: {
    description: "支付返回格式",
    properties: {
      amount: {
        description: "- 支付金额",
        type: "string"
      },
      code: {
        description: "- 2000成功，1000失败",
        type: "string"
      },
      message: {
        description: "- message",
        type: "string"
      },
      status: {
        description: "- success or failed",
        type: "string"
      }
    },
    required: [
      "amount",
      "code",
      "message",
      "status"
    ],
    type: "object"
  },
  SafeAreaInsets: {
    description: "安全区域距离",
    properties: {
      bottom: {
        description: "- 底部距离",
        type: "number"
      },
      left: {
        description: "- 左边距离",
        type: "number"
      },
      right: {
        description: "- 右边距离",
        type: "number"
      },
      top: {
        description: "- 顶部距离",
        type: "number"
      }
    },
    required: [
      "bottom",
      "left",
      "right",
      "top"
    ],
    type: "object"
  },
  ScanQRResult: {
    description: "扫码结果",
    properties: {
      charSet: {
        description: "- 所扫码的字符集. (小程序)",
        type: "string"
      },
      metadataType: {
        description: "- 所扫码的类型. (eg: QRCode)(ios cn, ios eu)",
        type: "string"
      },
      rawData: {
        description: "- 原始数据. (小程序)",
        type: "string"
      },
      scanType: {
        description: "- 扫码类型. (小程序)",
        type: "string"
      },
      value: {
        description: "- 二维码内容 (小程序, ios cn)",
        type: "string"
      }
    },
    type: "object"
  },
  Share2Config: {
    properties: {
      content: {
        description: "- share content config",
        properties: {
          channel: {
            type: "string"
          },
          content: {
            properties: {
              content: {
                type: "string"
              },
              name: {
                type: "string"
              },
              topic_id: {
                type: "number"
              },
              type: {
                type: "number"
              },
              user_id: {
                type: "number"
              }
            },
            required: [
              "content",
              "name",
              "topic_id",
              "type",
              "user_id"
            ],
            type: "object"
          },
          desc: {
            type: "string"
          },
          "function": {
            type: "string"
          },
          imgUrl: {
            type: "string"
          },
          imgUrls: {
            items: {
              type: "string"
            },
            type: "array"
          },
          miniProgram: {
            properties: {
              miniProgramType: {
                type: "number"
              },
              path: {
                type: "string"
              },
              userName: {
                type: "string"
              }
            },
            required: [
              "miniProgramType",
              "path",
              "userName"
            ],
            type: "object"
          },
          shareUrl: {
            type: "string"
          },
          title: {
            type: "string"
          }
        },
        required: [
          "channel",
          "content",
          "desc",
          "function",
          "imgUrl",
          "imgUrls",
          "miniProgram",
          "shareUrl",
          "title"
        ],
        type: "object"
      },
      statData: {
        description: "- 享埋点字段，具体定义和值请参考DRD NIO 分享组件2.0埋点DRD",
        properties: {
          extendedField: {
            additionalProperties: {},
            type: "object"
          },
          image: {
            type: "string"
          },
          pageSource: {
            type: "string"
          },
          resourceId: {
            type: "string"
          },
          resourceType: {
            type: "string"
          }
        },
        required: [
          "extendedField",
          "image",
          "pageSource",
          "resourceId",
          "resourceType"
        ],
        type: "object"
      }
    },
    required: [
      "content",
      "statData"
    ],
    type: "object"
  },
  ShareConfig: {
    properties: {
      imgUrl: {
        description: "- imgUrl5.14.0开始支持base64格式图",
        type: "string"
      },
      miniData: {
        description: "- 微信小程序字段。iOS 支持，android需要联调",
        properties: {
          description: {
            type: "string"
          },
          hdImage: {
            type: "string"
          },
          path: {
            type: "string"
          },
          programType: {
            type: "string"
          },
          title: {
            type: "string"
          },
          userName: {
            type: "string"
          }
        },
        required: [
          "description",
          "hdImage",
          "path",
          "programType",
          "title",
          "userName"
        ],
        type: "object"
      },
      nioExtension: {
        description: "- 分享此刻",
        properties: {
          contents: {
            properties: {
              content: {
                type: "string"
              },
              topicId: {
                type: "string"
              },
              topicName: {
                type: "string"
              },
              type: {
                type: "string"
              },
              userId: {
                type: "string"
              },
              userName: {
                type: "string"
              }
            },
            required: [
              "content",
              "topicId",
              "topicName",
              "type",
              "userId",
              "userName"
            ],
            type: "object"
          }
        },
        required: [
          "contents"
        ],
        type: "object"
      },
      priorityData: {
        description: "- 多渠道分享内容,用于支持不同渠道配置不同的分享内容,优先级高于外层字段,字段会覆盖外层的定义",
        properties: {
          channel: {
            type: "string"
          },
          imgUrl: {
            type: "string"
          },
          subTitle: {
            type: "string"
          },
          title: {
            type: "string"
          },
          url: {
            type: "string"
          }
        },
        required: [
          "channel",
          "imgUrl",
          "subTitle",
          "title",
          "url"
        ],
        type: "object"
      },
      statData: {
        description: "- 分享埋点字段，具体定义和值请参考: https://nio.feishu.cn/docx/HYAfd0t37oK3aKx7yczc9MUgn2d",
        properties: {
          extendedField: {
            additionalProperties: {},
            type: "object"
          },
          image: {
            type: "string"
          },
          pageSource: {
            type: "string"
          },
          resourceId: {
            type: "string"
          },
          resourceType: {
            type: "string"
          }
        },
        required: [
          "extendedField",
          "image",
          "pageSource",
          "resourceId",
          "resourceType"
        ],
        type: "object"
      },
      subTitle: {
        description: "- 描述信息 可选",
        type: "string"
      },
      title: {
        description: "- 主标题 可选 当title subTitle url都为空时走分享图片",
        type: "string"
      },
      topicId: {
        description: "- 话题id(可以优先使用nioExtension参数)",
        type: "number"
      },
      topicName: {
        description: "- 话题name(可以优先使用nioExtension参数)",
        type: "string"
      },
      type: {
        description: '- "nio","moment","wx","timeline","weibo","copy","system_more","download"',
        items: {
          type: "string"
        },
        type: "array"
      },
      url: {
        description: "- 分享的网页链接  可选",
        type: "string"
      }
    },
    required: [
      "imgUrl",
      "miniData",
      "nioExtension",
      "priorityData",
      "statData",
      "subTitle",
      "title",
      "topicId",
      "topicName",
      "type",
      "url"
    ],
    type: "object"
  },
  ShareImageResult: {
    description: "分享图片",
    properties: {
      plat: {
        description: "- 分享平台.(wx, timeline, wx_timeline, nio, weibo, moment)",
        type: "string"
      },
      result: {
        description: "- 分享是否成功 (ios_cn)",
        type: "string"
      },
      state: {
        description: "- 分享状态值. (200: 成功, 201: 取消, 202: 错误, -310: 第三方未安装, -320: 分享数据处理中, -330: 分享数据处理完成)",
        type: "string"
      }
    },
    required: [
      "plat",
      "result",
      "state"
    ],
    type: "object"
  },
  T: {
    type: "object"
  },
  TitanUserInfoResult: {
    description: "Titan 用户信息",
    properties: {
      access_token: {
        description: "- account token",
        type: "string"
      },
      accountName: {
        description: "- 用户名",
        type: "string"
      },
      nioToken: {
        description: "- nio token",
        type: "string"
      }
    },
    required: [
      "access_token",
      "accountName",
      "nioToken"
    ],
    type: "object"
  },
  TranslateResult: {
    description: "原生提供翻译能力返回结果",
    properties: {
      content: {
        description: "- 这是个问题",
        type: "string"
      },
      id: {
        description: "- content 的 md5 值",
        type: "string"
      },
      origin_lang: {
        description: "- en",
        type: "string"
      },
      result: {
        description: "- xxx",
        type: "string"
      },
      target_lang: {
        description: "- zh",
        type: "string"
      },
      type: {
        description: "- text",
        type: "string"
      }
    },
    required: [
      "content",
      "id",
      "origin_lang",
      "result",
      "target_lang",
      "type"
    ],
    type: "object"
  },
  UserInfoByRequestResult: {
    description: "通过接口获取到的用户信息",
    properties: {
      account_id: {
        type: "number"
      },
      car_usage_city: {
        type: "string"
      },
      car_usage_city_id: {
        type: "number"
      },
      country_code: {
        type: "string"
      },
      fellow: {
        properties: {
          account_id: {
            type: "string"
          },
          country_code: {
            type: "string"
          },
          fellow_id: {
            type: "number"
          },
          head_image: {
            type: "string"
          },
          mobile: {
            type: "string"
          },
          name: {
            type: "string"
          }
        },
        required: [
          "account_id",
          "country_code",
          "fellow_id",
          "head_image",
          "mobile",
          "name"
        ],
        type: "object"
      },
      head_image: {
        type: "string"
      },
      id: {
        type: "number"
      },
      identity: {
        type: "string"
      },
      is_app_user: {
        type: "boolean"
      },
      is_employee: {
        type: "boolean"
      },
      is_fellow: {
        type: "boolean"
      },
      medal: {
        properties: {
          certification: {
            type: "string"
          },
          identity: {
            type: "string"
          },
          img_url: {
            type: "string"
          },
          is_nio_authorized: {
            type: "boolean"
          },
          level_name: {
            type: "string"
          }
        },
        required: [
          "certification",
          "identity",
          "img_url",
          "is_nio_authorized",
          "level_name"
        ],
        type: "object"
      },
      mobile: {
        type: "string"
      },
      name: {
        type: "string"
      },
      nickname: {
        type: "string"
      },
      nio_code: {
        type: "number"
      },
      register_time: {
        type: "number"
      },
      user_id: {
        type: "number"
      }
    },
    required: [
      "account_id",
      "car_usage_city",
      "car_usage_city_id",
      "country_code",
      "fellow",
      "head_image",
      "id",
      "identity",
      "is_app_user",
      "is_employee",
      "is_fellow",
      "medal",
      "mobile",
      "name",
      "nickname",
      "nio_code",
      "register_time",
      "user_id"
    ],
    type: "object"
  },
  UserInfoMedalResult: {
    description: "用户身份信息",
    properties: {
      certification: {
        description: "- 身份认证 ? (ios cn, ios eu, android eu)",
        type: "string"
      },
      id: {
        description: "- 身份id ?(ios cn)",
        type: "number"
      },
      identity: {
        description: "- 用户身份",
        type: "string"
      },
      img_url: {
        description: "- 标识使用的图片 (iOS cn, android cn)",
        type: "string"
      },
      is_nio_authorized: {
        description: "- 蔚来授权标识",
        type: "boolean"
      },
      level_name: {
        description: "- 用户级别的名称 (iOS cn, android cn)",
        type: "string"
      },
      show_identity: {
        description: "- 显示身份 (ios eu, android eu)",
        type: "boolean"
      }
    },
    required: [
      "identity",
      "is_nio_authorized"
    ],
    type: "object"
  },
  UserInfoMobileResult: {
    description: "用户手机信息",
    properties: {
      callingCode: {
        description: "- 国家区号",
        type: "string"
      },
      calling_code: {
        description: "- 国家区号",
        type: "string"
      },
      mobile: {
        description: "- 电话",
        type: "string"
      }
    },
    required: [
      "callingCode",
      "calling_code",
      "mobile"
    ],
    type: "object"
  },
  UserInfoResult: {
    description: "用户数据信息",
    properties: {
      access_token: {
        description: "- 登录 token",
        type: "string"
      },
      accountId: {
        description: "- 账号 accountId",
        type: "string"
      },
      account_id: {
        description: "- 账号 accountId",
        type: "string"
      },
      account_name: {
        description: "- 账号名(android cn)",
        type: "string"
      },
      avatar: {
        description: "- 头像",
        type: "string"
      },
      chaosa_id: {
        description: "- chaosa_id (iOS eu, android eu)",
        type: "string"
      },
      countryCode: {
        description: "- 国家码(eg:CN)",
        type: "string"
      },
      country_code: {
        description: "- 国家码(eg:CN)(ios cn)",
        type: "string"
      },
      displayLanguage: {
        description: "- 显示语言(eg:en)",
        type: "string"
      },
      display_language: {
        description: "- 显示语言(eg:en)(ios cn)",
        type: "string"
      },
      email: {
        description: "- 邮箱 (iOS eu, android eu)",
        type: "string"
      },
      gender: {
        description: "- 性别(eg:male)(ios cn)",
        type: "string"
      },
      medal: {
        description: "- 用户的身份信息",
        properties: {
          certification: {
            description: "- 身份认证 ? (ios cn, ios eu, android eu)",
            type: "string"
          },
          id: {
            description: "- 身份id ?(ios cn)",
            type: "number"
          },
          identity: {
            description: "- 用户身份",
            type: "string"
          },
          img_url: {
            description: "- 标识使用的图片 (iOS cn, android cn)",
            type: "string"
          },
          is_nio_authorized: {
            description: "- 蔚来授权标识",
            type: "boolean"
          },
          level_name: {
            description: "- 用户级别的名称 (iOS cn, android cn)",
            type: "string"
          },
          show_identity: {
            description: "- 显示身份 (ios eu, android eu)",
            type: "boolean"
          }
        },
        required: [
          "identity",
          "is_nio_authorized"
        ],
        type: "object"
      },
      mobile: {
        description: "- 手机号相关",
        properties: {
          callingCode: {
            description: "- 国家区号",
            type: "string"
          },
          calling_code: {
            description: "- 国家区号",
            type: "string"
          },
          mobile: {
            description: "- 电话",
            type: "string"
          }
        },
        required: [
          "callingCode",
          "calling_code",
          "mobile"
        ],
        type: "object"
      },
      nickName: {
        description: "- 账号 昵称",
        type: "string"
      },
      nick_name: {
        description: "- 账号 昵称 (ios cn, android cn)",
        type: "string"
      },
      profile_id: {
        description: "- ?? (ios cn)",
        type: "string"
      },
      share_uid: {
        description: "- ?? (iOS cn, android cn)",
        type: "string"
      },
      token_type: {
        description: "- token 前缀 (iOS cn, android cn)",
        type: "string"
      },
      user_id: {
        description: "- 用户 id (iOS cn)",
        type: "string"
      }
    },
    required: [
      "access_token",
      "accountId",
      "account_id",
      "avatar",
      "countryCode",
      "displayLanguage",
      "medal",
      "mobile",
      "nickName"
    ],
    type: "object"
  },
  VehicleInfoObject: {
    description: "车辆相关信息",
    properties: {
      account_id: {
        description: "- 当前账号 id",
        type: "string"
      },
      color: {
        description: "- 车辆颜色",
        type: "string"
      },
      display_name: {
        description: "- 车辆显示 name",
        type: "string"
      },
      first_activation_time: {
        description: "- 车辆激活时间",
        type: "number"
      },
      grant_type: {
        description: "- 车辆权限",
        type: "string"
      },
      hubs_style: {
        description: "- 轮毂样式",
        type: "string"
      },
      is_activated: {
        description: "- 车辆激活状态",
        type: "boolean"
      },
      is_checked: {
        description: "- 是否在车控页面选中",
        type: "boolean"
      },
      model_series: {
        description: "- 车系?? (android cn)",
        type: "string"
      },
      model_type: {
        description: "- 车型",
        type: "string"
      },
      profile: {
        description: "- 车辆 profile",
        properties: {
          model_type_year: {
            description: "- ?? (eg: G1.1)(android cn)",
            type: "string"
          },
          pretty_package_version: {
            description: "- ?? (android cn)",
            type: "string"
          }
        },
        type: "object"
      },
      v_platform: {
        description: "- 车辆平台(ios cn)",
        type: "string"
      },
      vehicle_id: {
        description: "- 车辆 id",
        type: "string"
      },
      vin: {
        description: "- 车辆 vin",
        type: "string"
      }
    },
    required: [
      "account_id",
      "display_name",
      "grant_type",
      "is_activated",
      "model_type",
      "vehicle_id",
      "vin"
    ],
    type: "object"
  },
  VehicleInfoProfile: {
    description: "车辆 Profile 信息",
    properties: {
      model_type_year: {
        description: "- ?? (eg: G1.1)(android cn)",
        type: "string"
      },
      pretty_package_version: {
        description: "- ?? (android cn)",
        type: "string"
      }
    },
    type: "object"
  },
  WebviewInfo: {
    description: "获取webview自身信息",
    properties: {
      webview_content_offset: {
        properties: {
          x: {
            type: "number"
          },
          y: {
            type: "number"
          }
        },
        required: [
          "x",
          "y"
        ],
        type: "object"
      },
      webview_content_size: {
        properties: {
          height: {
            type: "number"
          },
          width: {
            type: "number"
          }
        },
        required: [
          "height",
          "width"
        ],
        type: "object"
      },
      webview_frame: {
        properties: {
          height: {
            type: "number"
          },
          width: {
            type: "number"
          },
          x: {
            type: "number"
          },
          y: {
            type: "number"
          }
        },
        required: [
          "height",
          "width",
          "x",
          "y"
        ],
        type: "object"
      }
    },
    required: [
      "webview_content_offset",
      "webview_content_size",
      "webview_frame"
    ],
    type: "object"
  }
};
const TypesSchema = {
  $schema,
  definitions
};
var g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof global !== "undefined" && global || {};
var support = {
  searchParams: "URLSearchParams" in g,
  iterable: "Symbol" in g && "iterator" in Symbol,
  blob: "FileReader" in g && "Blob" in g && function() {
    try {
      new Blob();
      return true;
    } catch (e) {
      return false;
    }
  }(),
  formData: "FormData" in g,
  arrayBuffer: "ArrayBuffer" in g
};
function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj);
}
if (support.arrayBuffer) {
  var viewClasses = [
    "[object Int8Array]",
    "[object Uint8Array]",
    "[object Uint8ClampedArray]",
    "[object Int16Array]",
    "[object Uint16Array]",
    "[object Int32Array]",
    "[object Uint32Array]",
    "[object Float32Array]",
    "[object Float64Array]"
  ];
  var isArrayBufferView = ArrayBuffer.isView || function(obj) {
    return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
  };
}
function normalizeName(name) {
  if (typeof name !== "string") {
    name = String(name);
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") {
    throw new TypeError('Invalid character in header field name: "' + name + '"');
  }
  return name.toLowerCase();
}
function normalizeValue(value) {
  if (typeof value !== "string") {
    value = String(value);
  }
  return value;
}
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift();
      return { done: value === void 0, value };
    }
  };
  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator;
    };
  }
  return iterator;
}
function Headers(headers) {
  this.map = {};
  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      if (header.length != 2) {
        throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
      }
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name]);
    }, this);
  }
}
Headers.prototype.append = function(name, value) {
  name = normalizeName(name);
  value = normalizeValue(value);
  var oldValue = this.map[name];
  this.map[name] = oldValue ? oldValue + ", " + value : value;
};
Headers.prototype["delete"] = function(name) {
  delete this.map[normalizeName(name)];
};
Headers.prototype.get = function(name) {
  name = normalizeName(name);
  return this.has(name) ? this.map[name] : null;
};
Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name));
};
Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value);
};
Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this);
    }
  }
};
Headers.prototype.keys = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push(name);
  });
  return iteratorFor(items);
};
Headers.prototype.values = function() {
  var items = [];
  this.forEach(function(value) {
    items.push(value);
  });
  return iteratorFor(items);
};
Headers.prototype.entries = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push([name, value]);
  });
  return iteratorFor(items);
};
if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}
function consumed(body) {
  if (body._noBody)
    return;
  if (body.bodyUsed) {
    return Promise.reject(new TypeError("Already read"));
  }
  body.bodyUsed = true;
}
function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result);
    };
    reader.onerror = function() {
      reject(reader.error);
    };
  });
}
function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise;
}
function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
  var encoding = match ? match[1] : "utf-8";
  reader.readAsText(blob, encoding);
  return promise;
}
function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);
  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }
  return chars.join("");
}
function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0);
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer;
  }
}
function Body() {
  this.bodyUsed = false;
  this._initBody = function(body) {
    this.bodyUsed = this.bodyUsed;
    this._bodyInit = body;
    if (!body) {
      this._noBody = true;
      this._bodyText = "";
    } else if (typeof body === "string") {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer);
      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }
    if (!this.headers.get("content-type")) {
      if (typeof body === "string") {
        this.headers.set("content-type", "text/plain;charset=UTF-8");
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set("content-type", this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
      }
    }
  };
  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }
      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      } else if (this._bodyFormData) {
        throw new Error("could not read FormData body as blob");
      } else {
        return Promise.resolve(new Blob([this._bodyText]));
      }
    };
  }
  this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var isConsumed = consumed(this);
      if (isConsumed) {
        return isConsumed;
      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
        return Promise.resolve(
          this._bodyArrayBuffer.buffer.slice(
            this._bodyArrayBuffer.byteOffset,
            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
          )
        );
      } else {
        return Promise.resolve(this._bodyArrayBuffer);
      }
    } else if (support.blob) {
      return this.blob().then(readBlobAsArrayBuffer);
    } else {
      throw new Error("could not read as ArrayBuffer");
    }
  };
  this.text = function() {
    var rejected = consumed(this);
    if (rejected) {
      return rejected;
    }
    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob);
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
    } else if (this._bodyFormData) {
      throw new Error("could not read FormData body as text");
    } else {
      return Promise.resolve(this._bodyText);
    }
  };
  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode);
    };
  }
  this.json = function() {
    return this.text().then(JSON.parse);
  };
  return this;
}
var methods = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  }
  options = options || {};
  var body = options.body;
  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError("Already read");
    }
    this.url = input.url;
    this.credentials = input.credentials;
    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }
    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;
    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }
  this.credentials = options.credentials || this.credentials || "same-origin";
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }
  this.method = normalizeMethod(options.method || this.method || "GET");
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal || function() {
    if ("AbortController" in g) {
      var ctrl = new AbortController();
      return ctrl.signal;
    }
  }();
  this.referrer = null;
  if ((this.method === "GET" || this.method === "HEAD") && body) {
    throw new TypeError("Body not allowed for GET or HEAD requests");
  }
  this._initBody(body);
  if (this.method === "GET" || this.method === "HEAD") {
    if (options.cache === "no-store" || options.cache === "no-cache") {
      var reParamSearch = /([?&])_=[^&]*/;
      if (reParamSearch.test(this.url)) {
        this.url = this.url.replace(reParamSearch, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
      } else {
        var reQueryString = /\?/;
        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
      }
    }
  }
}
Request.prototype.clone = function() {
  return new Request(this, { body: this._bodyInit });
};
function decode(body) {
  var form = new FormData();
  body.trim().split("&").forEach(function(bytes) {
    if (bytes) {
      var split = bytes.split("=");
      var name = split.shift().replace(/\+/g, " ");
      var value = split.join("=").replace(/\+/g, " ");
      form.append(decodeURIComponent(name), decodeURIComponent(value));
    }
  });
  return form;
}
function parseHeaders(rawHeaders) {
  var headers = new Headers();
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
  preProcessedHeaders.split("\r").map(function(header) {
    return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
  }).forEach(function(line) {
    var parts = line.split(":");
    var key = parts.shift().trim();
    if (key) {
      var value = parts.join(":").trim();
      try {
        headers.append(key, value);
      } catch (error) {
        console.warn("Response " + error.message);
      }
    }
  });
  return headers;
}
Body.call(Request.prototype);
function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  }
  if (!options) {
    options = {};
  }
  this.type = "default";
  this.status = options.status === void 0 ? 200 : options.status;
  if (this.status < 200 || this.status > 599) {
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
  }
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = options.statusText === void 0 ? "" : "" + options.statusText;
  this.headers = new Headers(options.headers);
  this.url = options.url || "";
  this._initBody(bodyInit);
}
Body.call(Response.prototype);
Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  });
};
Response.error = function() {
  var response = new Response(null, { status: 200, statusText: "" });
  response.status = 0;
  response.type = "error";
  return response;
};
var redirectStatuses = [301, 302, 303, 307, 308];
Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError("Invalid status code");
  }
  return new Response(null, { status, headers: { location: url } });
};
var DOMException = g.DOMException;
try {
  new DOMException();
} catch (err) {
  DOMException = function(message, name) {
    this.message = message;
    this.name = name;
    var error = Error(message);
    this.stack = error.stack;
  };
  DOMException.prototype = Object.create(Error.prototype);
  DOMException.prototype.constructor = DOMException;
}
function fetch$1(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init);
    if (request.signal && request.signal.aborted) {
      return reject(new DOMException("Aborted", "AbortError"));
    }
    var xhr = new XMLHttpRequest();
    function abortXhr() {
      xhr.abort();
    }
    xhr.onload = function() {
      var options = {
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
      };
      if (request.url.startsWith("file://") && (xhr.status < 200 || xhr.status > 599)) {
        options.status = 200;
      } else {
        options.status = xhr.status;
      }
      options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
      var body = "response" in xhr ? xhr.response : xhr.responseText;
      setTimeout(function() {
        resolve(new Response(body, options));
      }, 0);
    };
    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError("Network request failed"));
      }, 0);
    };
    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError("Network request timed out"));
      }, 0);
    };
    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException("Aborted", "AbortError"));
      }, 0);
    };
    function fixUrl(url) {
      try {
        return url === "" && g.location.href ? g.location.href : url;
      } catch (e) {
        return url;
      }
    }
    xhr.open(request.method, fixUrl(request.url), true);
    if (request.credentials === "include") {
      xhr.withCredentials = true;
    } else if (request.credentials === "omit") {
      xhr.withCredentials = false;
    }
    if ("responseType" in xhr) {
      if (support.blob) {
        xhr.responseType = "blob";
      } else if (support.arrayBuffer) {
        xhr.responseType = "arraybuffer";
      }
    }
    if (init && typeof init.headers === "object" && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
      var names = [];
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        names.push(normalizeName(name));
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
      });
      request.headers.forEach(function(value, name) {
        if (names.indexOf(name) === -1) {
          xhr.setRequestHeader(name, value);
        }
      });
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });
    }
    if (request.signal) {
      request.signal.addEventListener("abort", abortXhr);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          request.signal.removeEventListener("abort", abortXhr);
        }
      };
    }
    xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
  });
}
fetch$1.polyfill = true;
if (!g.fetch) {
  g.fetch = fetch$1;
  g.Headers = Headers;
  g.Request = Request;
  g.Response = Response;
}
var fetchNpmBrowserify = self.fetch.bind(self);
const fetch = /* @__PURE__ */ getDefaultExportFromCjs(fetchNpmBrowserify);
function isString(value) {
  const type = typeof value;
  return type === "string" || type === "object" && value != null && !Array.isArray(value) && getTag(value) === "[object String]";
}
function isFunction(value) {
  return typeof value === "function";
}
function getTag(value) {
  if (value == null) {
    return value === void 0 ? "[object Undefined]" : "[object Null]";
  }
  return toString.call(value);
}
function isObjectLike(value) {
  return typeof value === "object" && value !== null;
}
function isArray(value) {
  return Array.isArray(value);
}
function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && getTag(value) === "[object Boolean]";
}
function isInteger(value) {
  return Number.isInteger(value);
}
function isNumber(value) {
  return typeof value === "number" || isObjectLike(value) && getTag(value) === "[object Number]";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function");
}
function hop(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function checker(context) {
  if (context !== void 0) {
    if (!isObject(context)) {
      throw new Error("error info:  error param type ， need object has context.data or context.callback or context.event");
    }
    if (context.data !== void 0) {
      if (!isObject(context.data)) {
        throw new Error("error info:  context.data type need Object");
      }
    }
    if (context.event !== void 0) {
      if (!isString(context.event)) {
        throw new Error("error info:  context.event type need String");
      }
    }
    if (context.callback !== void 0) {
      if (!isFunction(context.callback)) {
        throw new Error("error info:  context.callback type need Function");
      }
    } else {
      context.callback = () => null;
    }
  }
}
function getDsBridge$2() {
  return window["dsBridge"] || window["_dsbridge"];
}
function getJSONSchema() {
  return TypesSchema["definitions"];
}
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c2) {
    let r = Math.random() * 16 | 0, v = c2 === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
function navigatorToMpPage(url) {
  return new Promise((resolve, reject) => {
    let { hash } = window.location;
    let href = location.href.split("#")[0];
    let _uuid2 = generateUUID();
    let universalParams = {
      _u_href: href,
      _u_hash: hash,
      _u_uuid: _uuid2
    };
    let connector = url.includes("?") ? "&" : "?";
    wx.miniProgram.navigateTo({
      url: `${url}${connector}${lib.stringify(universalParams)}`
    });
    let hashChanged = (_) => {
      let { callback: result, _u_uuid } = lib.parse(location.hash.split("?")[1]);
      if (_u_uuid === _uuid2) {
        try {
          result = JSON.parse(decodeURIComponent(result));
        } catch (e) {
          result = {};
        }
        resolve(result.body || {});
        history.back();
        window.removeEventListener("hashchange", hashChanged);
      }
    };
    window.addEventListener("hashchange", hashChanged);
  });
}
function currentInMPContainer() {
  if (typeof window === "undefined")
    return false;
  return navigator.userAgent.includes("miniProgram");
}
function currentInCloudAppContainer() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("wv=cloudapp") || location.href.includes("is_cloud_app=true");
}
function currentInWebFContainer() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("webf/");
}
function currentInMockContainer() {
  if (typeof window === "undefined") {
    return process.env.jsbridge_model === "mock";
  }
  return location.search.includes("mock_jsbridge=true") || location.search.includes("jsbridge_model=mock");
}
function currentInLiveContainer() {
  if (typeof window === "undefined") {
    return process.env.jsbridge_model === "live";
  }
  return location.search.includes("jsbridge_model=live");
}
function currentInLgContainer() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("webview/lg");
}
function currentInSWCContainer() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("lifestyle") && !lowCaseUA.includes("lg");
}
function getAppUriScheme() {
  if (currentInNioCNiOS() || currentInNioCNAndroid()) {
    return "nio";
  } else if (currentInNioEUiOS() || currentInNioEUAndroid()) {
    return "nioapp";
  } else {
    return "";
  }
}
function currentInNioCNiOS() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return (lowCaseUA.includes("iphone") || lowCaseUA.includes("ipad")) && lowCaseUA.includes("com.do1.weilaiapp") && lowCaseUA.includes("webview/lg");
}
function currentInAlpsCNiOS() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return (lowCaseUA.includes("iphone") || lowCaseUA.includes("ipad")) && lowCaseUA.includes("com.nio.app-uni") && lowCaseUA.includes("webview/lg");
}
function currentInAlpsCNAndroid() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("android") && lowCaseUA.includes("alps") && lowCaseUA.includes("webview/lg");
}
function currentInNioCNAndroid() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("android") && lowCaseUA.includes("nioappcn") && lowCaseUA.includes("webview/lg");
}
function currentInNioTitanAndroid() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("android") && (lowCaseUA.includes("titan cn") || lowCaseUA.includes("mate")) && lowCaseUA.includes("webview/lg");
}
function currentInNioEUiOS() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("ios") && lowCaseUA.includes("com.nextev.beyondcar") && lowCaseUA.includes("webview/lg");
}
function currentInNioEUAndroid() {
  if (typeof window === "undefined")
    return false;
  const lowCaseUA = navigator.userAgent.toLowerCase();
  return lowCaseUA.includes("android") && lowCaseUA.includes("nio/") && lowCaseUA.includes("webview/lg");
}
function currentNotSupport() {
  return new Promise((resolve) => {
    resolve({
      display_message: "暂不支持该功能",
      error_type: "unsupported",
      result_code: "failed"
    });
  });
}
function currentExecSuccess() {
  return new Promise((resolve) => {
    resolve({
      result_code: "success"
    });
  });
}
function unknownError() {
  return new Promise((resolve) => {
    resolve({
      result_code: "error",
      error_type: "unknown_error",
      result_message: "发生未知错误"
    });
  });
}
async function mockJsbridgeForType(type) {
  const result = {
    result_code: "success"
  };
  result.result_code = "success";
  if (type === "") {
    delete result.data;
    result.display_message = `mock( ${("00" + (/* @__PURE__ */ new Date()).getHours()).slice(-2)}:${("00" + (/* @__PURE__ */ new Date()).getMinutes()).slice(-2)}:${("00" + (/* @__PURE__ */ new Date()).getSeconds()).slice(-2)} )`;
    return result;
  }
  const response = await fetch(`https://apidoc.nioint.com/mock/11297/${type}`);
  const jsonResult = await response.json();
  if (!jsonResult.errcode) {
    result.data = jsonResult;
    return result;
  }
  return result;
}
let nextMonth$1 = new Date((/* @__PURE__ */ new Date()).setMonth((/* @__PURE__ */ new Date()).getMonth() + 1));
let expire$1 = nextMonth$1.getTime();
const storage = {
  /**
   * 设置 key value
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - key
   * @param {any}    context.data.value - value
   * @param {number} context.data.expire - 过期时间. (单位: 毫秒)
   */
  set(context) {
    checker(context);
    context.data.expire = new Date(context.data.expire || expire$1).getTime();
    getDsBridge$2().call("setStorageValue", context.data);
  },
  /**
   * 获取 key 对应的 value
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - key
   *
   * @return {any}
   */
  get(context) {
    checker(context);
    let result = getDsBridge$2().call("getStorageValue", context.data.key);
    if (result) {
      delete result.expire;
    }
    return result;
  },
  /**
   * 删除 key 对应的 value
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - key
   * @param context
   */
  remove(context) {
    checker(context);
    getDsBridge$2().call("removeStorage", context.data.key);
  },
  /**
   * 删除 key 对应的 value
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - key
   * @param context
   */
  delete(context) {
    checker(context);
    getDsBridge$2().call("removeStorage", context.data.key);
  },
  /**
   * @description 清除所有 慎用，会把app 存储没有 domain 概念会导致全部清除
   */
  clear() {
    getDsBridge$2().call("clearStorage", "");
  }
};
let _uuid = 0;
const _NIOWebsocket = class _NIOWebsocket {
  constructor(url, customOptions) {
    this.ws = null;
    this.url = url;
    this.eventCallbacks = {};
    this.sendMsgQuene = [];
    this.reconnectCount = 0;
    this.options = {
      ..._NIOWebsocket.defaultOptions,
      ...customOptions
    };
  }
  /**
   * init websocket
   */
  init() {
    this.ws = new WebSocket(this.url);
    this.ws.uuid = _uuid++;
    if (this.options.debug) {
      console.groupCollapsed(`ws start connecting: ${this.ws.uuid}`);
      console.groupEnd();
    }
    this.ws.onerror = (e) => {
      if (this.options.debug) {
        console.groupCollapsed(`ws onerror: ${this.ws.uuid}`);
        console.log(e);
        console.groupEnd();
      }
      this.ws.lastError = "error here";
      this.options.onerror(e);
      const eventCallbacks = Object.values(this.eventCallbacks.error || {});
      eventCallbacks.forEach((eventCallback) => {
        eventCallback(e);
      });
    };
    this.ws.onopen = (e) => {
      if (this.options.debug) {
        console.groupCollapsed(`ws onopen: ${this.ws.uuid}`);
        console.log(e);
        console.groupEnd();
      }
      this.options.onopen(e);
      const eventCallbacks = Object.values(this.eventCallbacks.open || {});
      eventCallbacks.forEach((eventCallback) => {
        eventCallback(e);
      });
      this.connectSuccess();
      while (this.sendMsgQuene.length > 0) {
        const WSMsg = this.sendMsgQuene.shift();
        this.send(WSMsg);
      }
    };
    this.ws.onclose = () => {
      const evt = {
        uuid: this.ws.uuid,
        lastError: this.ws.lastError
      };
      if (this.options.debug) {
        console.groupCollapsed(`ws onclose: ${this.ws.uuid}`);
        console.log(evt);
        console.groupEnd();
      }
      this.options.onclose();
      const eventCallbacks = Object.values(this.eventCallbacks.close || {});
      eventCallbacks.forEach((eventCallback) => {
        eventCallback(evt);
      });
      this.reconnect();
    };
    this.ws.onmessage = (e) => {
      let WSMsg;
      try {
        WSMsg = JSON.parse(e.data);
      } catch (err) {
        WSMsg = e.data;
      }
      if (this.options.debug) {
        console.groupCollapsed(`ws onmessage: ${this.ws.uuid}`);
        console.log(WSMsg);
        console.groupEnd();
      }
      this.options.onmessage(WSMsg, e);
      const eventCallbacks = Object.values(this.eventCallbacks.message || {});
      eventCallbacks.forEach((eventCallback) => {
        eventCallback(WSMsg);
      });
    };
  }
  /**
   * try to reconnect ws connect
   */
  reconnect() {
    if (this.getState() === _NIOWebsocket.readyState.connecting.value) {
      if (this.options.debug) {
        console.log("stop reconnect, current ws still connecting");
      }
      return;
    }
    if (this.getState() === _NIOWebsocket.readyState.open.value) {
      if (this.options.debug) {
        console.log("stop reconnect, current ws still opened");
      }
      return;
    }
    if (this.reconnectCount >= this.options.maxReconnectCount) {
      if (this.options.debug) {
        console.log("stop reconnect, reach max allowed reconnect count");
      }
      return;
    }
    setTimeout(() => {
      if (this.options.debug) {
        console.log("\n");
        console.log("******** WS TRY RECONNECT ********");
      }
      this.init();
    }, Math.min(this.options.reconnectInterval, this.options.reconnectInterval * this.reconnectCount));
    this.reconnectCount++;
  }
  /**
   * reset reconnect count after connect success
   */
  connectSuccess() {
    this.reconnectCount = 0;
  }
  /**
   * close ws connect
   */
  close() {
    this.ws.close();
  }
  /**
   * send ws message
   * @param data
   */
  send(data) {
    if (this.getState() !== _NIOWebsocket.readyState.open.value) {
      this.sendMsgQuene.push(data);
      return;
    }
    this.ws.send(JSON.stringify(data));
  }
  /**
   * @description monitor websocket event,
   * multiple monitor is allowed with same event,
   * identify and remove duplicate by identify.
   *
   * attention: invoke returned off method after callback is suggested.
   *
   * @param {Object} options
   * @param {String} options.eventName - event name
   * @param {String} [options.identity] - specify event identify, default same as eventName
   * @param callback
   * @return {Function} - return off event method
   */
  on(options, callback) {
    let { eventName, identity } = options;
    identity = identity || eventName;
    this.eventCallbacks[eventName] = this.eventCallbacks[eventName] || {};
    this.eventCallbacks[eventName][identity] = callback;
    return () => {
      if (this.options.debug) {
        console.log(`ws off monitor: ${options.eventName}, ${options.identity}`);
      }
      this.off(options);
    };
  }
  /**
   * @description remove monitor with specific event name and identity
   * @param {object} options - options
   * @param {string} options.identity - event identity
   * @param {string} options.eventName - event name
   */
  off(options) {
    let { eventName, identity } = options;
    identity = identity || eventName;
    if (!this.eventCallbacks[eventName]) {
      return;
    }
    if (!this.eventCallbacks[eventName][identity]) {
      return;
    }
    delete this.eventCallbacks[eventName][identity];
  }
  /**
   * get current ws state
   * @returns {*}
   */
  getState() {
    return this.ws.readyState;
  }
};
__publicField(_NIOWebsocket, "defaultOptions", {
  debug: false,
  onopen: () => {
  },
  onclose: () => {
  },
  onmessage: () => {
  },
  onerror: () => {
  },
  autoReconnect: true,
  maxReconnectCount: 1e3,
  reconnectInterval: 5e3
});
__publicField(_NIOWebsocket, "readyState", {
  connecting: {
    value: 0
  },
  open: {
    value: 1
  },
  closing: {
    value: 2
  },
  closed: {
    value: 3
  }
});
let NIOWebsocket = _NIOWebsocket;
const WEBSOCKET_CONSTANT = {
  /**
   * websocket 消息类型
   */
  MSG_TYPE: {
    ADD_CALENDAR_EVENT: "addCalendarEvent",
    // 添加日历事件
    DOWNLOAD_VIDEO: "downloadVideo",
    // 下载视频
    GET_APP_INFO: "getAppInfo",
    // 获取app信息
    GET_CURRENCY_FORMAT: "getCurrencyFormat",
    // 获取货币格式
    GET_DEBUG_INFO: "getDebugInfo",
    // 获取调试信息
    GET_GLOBAL_DATA_MP: "getGlobalDataMP",
    // 获取小程序全局数据
    GET_INVOICE_DETAIL: "getInvoiceDetail",
    // 获取发票详情
    GET_LOCATION: "getLocation",
    // 获取当前定位
    GET_MODULE_INFO: "getModuleInfo",
    // 获取模块信息
    GET_NOTIFICATION_SETTINGS: "getNotificationSettings",
    // 获取通知设置
    GET_NUMBER_FORMAT: "getNumberFormat",
    // 获取数字格式
    GET_OS_INFO: "getOSInfo",
    // 获取操作系统信息
    GET_SCRAMBLE_ID: "getScrambleId",
    // 获取 scrambleId
    GET_USER_INFO_FOR_TITAN: "getUserInfoForTitan",
    // 获取 titan 用户信息
    GET_USER_INFO: "getUserInfo",
    // 获取用户信息
    GET_VEHICLE_INFO: "getVehicleInfo",
    // 获取车辆信息
    GET_WECHAT_BIND_MOBILE: "getWeChatBindMobile",
    // 获取微信绑定手机号
    GET_WX_LOGIN_CODE: "getWXLoginCode",
    // 获取微信登录 code
    OPEN_CUSTOMER_SERVICE_CHAT: "openCustomerServiceChat",
    // 打开微信客服对话框
    HEART_BEAT: "heartbeat",
    // 心跳
    HIDE_LOADING: "hideLoading",
    // 隐藏一个 loading 组件
    IMAGE_PICKER: "imagePicker",
    // 图片选择器
    IOS_ALLOWS_BACK_FORWARD_NAVIGATION_GESTURES: "iosAllowsBackForwardNavigationGestures",
    // iOS 允许手势开关
    IOS_DISABLE_BACK_FORWARD_NAVIGATION_GESTURES: "iosDisableBackForwardNavigationGestures",
    // iOS 禁用手势开关
    IOS_TOGGLE_BOUNCES: "iosToggleBounces",
    // ios弹性效果开关
    MAKE_CALL: "makeCall",
    // 拨打电话
    NOTIFICATION_AUTHORIZATION_STATUS: "notificationAuthorizationStatus",
    // 通知权限状态
    OPEN_APP_SETTING: "openAppSetting",
    // 打开app设置
    OPEN_EXTERNAL_BROWSER: "openExternalBrowser",
    // 打开外部浏览器
    OPEN_LOGIN_PAGE: "openLoginPage",
    // 打开登录页面
    OPEN_MAP: "openMap",
    // 打开地图上某个点
    OPEN_NIO_INPUT_EDIT2: "openNioInputEdit2",
    // 打开输入框
    OPEN_NIO_INPUT_EDIT: "openNioInputEdit",
    // 打开输入框
    OPEN_NOTIFICATION_SETTING: "openNotificationSetting",
    // 打开通知设置
    OPEN_PDF: "openPDF",
    // 打开pdf
    OPEN_URL: "openURL",
    // 打开链接
    PAYMENT: "payment",
    // 跳转支付页
    POST_NOTIFICATION_FROM_HTML_TO_NATIVE: "postNotificationFromHtmlToNative",
    // 从html页面发送通知给native
    POST_UGC: "postUGC",
    // 发布UGC
    PREVIEW_IMAGE: "previewImage",
    // 预览图片
    REPLACE: "replace",
    // 替换当前页面
    REPORT: "report",
    // 举报 UGC
    REPORT_LIVING: "reportLiving",
    // 上报 living 状态
    REQUEST_EVENT_ANDROID: "requestEventAndroid",
    // 设置android touchSlop
    REQUEST_REWARD: "requestReward",
    // 加电打赏
    SAVE_IMAGE: "saveImage",
    // 保存图片
    SCAN_QR: "scanQR",
    // 扫码
    SELECT_IMAGE: "selectImage",
    // 选择图片
    SEND_POI: "sendPOI",
    // 发送POI
    SET_COPY_TEXT: "setCopyText",
    // 设置内容到剪贴板
    SET_GLOBAL_DATA_MP: "setGlobalDataMP",
    // 设置小程序全局数据
    SET_NAVIGATION_BAR_TITLE: "setNavigationBarTitle",
    // 设置导航栏标题
    SET_HEADER_OPTION: "setHeaderOption",
    // 设置 header 选项
    SET_PAGE_IDENTIFIER: "setPageIdentifier",
    // 设置页面标识
    SET_SHARE_CONFIG_MP: "setShareConfigMP",
    // 设置小程序分享
    SHARE2: "share2",
    // 分享2
    SHARE: "share",
    // 分享
    SHARE_IMAGE: "shareImage",
    // 分享图片
    SHOW_COUNTRIES: "showCountries",
    // 显示国家选择器
    SHOW_LOADING: "showLoading",
    // 显示一个 loading 组件
    SHOW_TOAST: "showToast",
    // 显示消息提示框
    TOUCH_SLOP_ANDROID: "touchSlopAndroid",
    // 设置android touchSlop
    TRANSLATE: "translate",
    // 翻译
    UNKNOWN_ACTION: "unknownAction"
    // 未知类型的操作
  }
};
const jsbridgeWebsocket = {
  wsInstance: null,
  /**
   * @description invoke all registered callback
   */
  wsConfig: {
    uuid: "",
    env: "prod",
    /**
     * 获取 live url
     * @return {string}
     */
    getLiveURL() {
      return `https://m-niojsbridge-demo-dev.nioint.com/live?wv=lg&load_js_bridge=true&uuid=${jsbridgeWebsocket.wsConfig.uuid}&env=${jsbridgeWebsocket.wsConfig.env}`;
    }
  },
  heartBeat: {
    isWorking: false,
    intervalId: null,
    /**
     * increase number when not receive heartbeat with interval
     * reset number when received heartbeat
     * reconnect if reached 3
     */
    continuousNoResCount: 0,
    open: () => {
      if (jsbridgeWebsocket.heartBeat.isWorking) {
        console.warn("heart beat is working");
        return;
      }
      jsbridgeWebsocket.heartBeat.intervalId = setInterval(() => {
        jsbridgeWebsocket.wsInstance.send({
          type: WEBSOCKET_CONSTANT.MSG_TYPE.HEART_BEAT
        });
        jsbridgeWebsocket.heartBeat.addContinuousNoResCount();
      }, 5e3);
      jsbridgeWebsocket.heartBeat.isWorking = true;
    },
    close: () => {
      clearInterval(jsbridgeWebsocket.heartBeat.intervalId);
      jsbridgeWebsocket.heartBeat.isWorking = false;
    },
    addContinuousNoResCount: () => {
      jsbridgeWebsocket.heartBeat.continuousNoResCount++;
      if (jsbridgeWebsocket.heartBeat.continuousNoResCount > 2) {
        jsbridgeWebsocket.heartBeat.resetContinuousNoResCount();
        jsbridgeWebsocket.close();
        jsbridgeWebsocket.open(jsbridgeWebsocket.wsConfig.env);
      }
    },
    resetContinuousNoResCount: () => {
      jsbridgeWebsocket.heartBeat.continuousNoResCount = 0;
    }
  },
  eventCallbacks: {},
  /**
   * @description get current websocket url
   * @param {{from: string, to: string, uuid: string}} [config] - ws connect config
   * @returns {string}
   */
  getWebsocketUrl(config = {}) {
    let currentUrl = location.href;
    let { from = "h5", to = "mp" } = config;
    let searchParamsStr = currentUrl.split("?").pop();
    let query = new URLSearchParams(searchParamsStr);
    let uuid = config.uuid || query.get("uuid");
    if (!uuid || uuid === "") {
      uuid = this.getUUID();
    }
    jsbridgeWebsocket.wsConfig.uuid = uuid;
    if (jsbridgeWebsocket.wsConfig.env === "test") {
      return `wss://universal-bridge-ws-test.nioint.com?uuid=${uuid}&from=${from}&to=${to}`;
    }
    return `wss://universal-bridge-ws.nio.com?uuid=${uuid}&from=${from}&to=${to}`;
  },
  /**
   * get live model's uuid
   * @return {string}
   */
  getUUID() {
    let localUUID = localStorage.getItem("universal_uuid");
    if (!localUUID) {
      localUUID = generateUUID();
      localStorage.setItem("universal_uuid", localUUID);
    }
    return localUUID;
  },
  /**
   * open websocket
   * @param {string} env - current connect environment
   * @param {{from?:string, to?:string, uuid?:string}} [config={}]  - ws connect config
   */
  open(env = "prod", config) {
    jsbridgeWebsocket.wsConfig.env = env;
    let websocketUrl = this.getWebsocketUrl(config);
    jsbridgeWebsocket.wsInstance = new NIOWebsocket(websocketUrl, { debug: false });
    jsbridgeWebsocket.wsInstance.on(
      {
        eventName: "open"
      },
      () => {
        jsbridgeWebsocket.heartBeat.open();
      }
    );
    jsbridgeWebsocket.wsInstance.on(
      {
        eventName: "close"
      },
      () => {
        jsbridgeWebsocket.heartBeat.close();
      }
    );
    jsbridgeWebsocket.wsInstance.on(
      {
        eventName: "error"
      },
      () => {
        jsbridgeWebsocket.heartBeat.close();
      }
    );
    jsbridgeWebsocket.wsInstance.on(
      {
        eventName: "message"
      },
      (WSMsg) => {
        if (!WSMsg) {
          console.error(new Error("can not handle empty msg"));
          return;
        }
        if (!WSMsg.type) {
          console.group("can not handle message without type");
          console.groupEnd();
          return;
        }
        if (WSMsg.type === "heartbeat") {
          jsbridgeWebsocket.heartBeat.resetContinuousNoResCount();
          return;
        }
        jsbridgeWebsocket.execCallbacks("message", WSMsg);
      }
    );
    jsbridgeWebsocket.wsInstance.init();
  },
  /**
   * manual close ws connect
   */
  close() {
    jsbridgeWebsocket.wsInstance.close();
    jsbridgeWebsocket.heartBeat.close();
  },
  /**
   * @description monitor websocket event,
   * multiple monitor is allowed with same event,
   * identify and remove duplicate by identify.
   *
   * attention: invoke returned off method after callback is suggested.
   *
   * @param {Object} options
   * @param {string} options.eventName - event name
   * @param {string} options.identity - specify event identify
   * @param {string} options.id - specify event id
   * @param callback
   * @return {Function} - return off event method
   */
  on(options, callback) {
    let { eventName, identity, id } = options;
    jsbridgeWebsocket.eventCallbacks[eventName] = jsbridgeWebsocket.eventCallbacks[eventName] || {};
    let callbackKey = identity;
    if (id) {
      callbackKey = `${callbackKey}_${id}`;
    }
    jsbridgeWebsocket.eventCallbacks[eventName][callbackKey] = callback;
    return () => {
      this.off({
        identity: callbackKey,
        eventName
      });
    };
  },
  /**
   * @description remove monitor with specific event name and identity
   * @param {object} options - options
   * @param {string} options.identity - event identity
   * @param {string} options.eventName - event name
   */
  off(options) {
    let { eventName, identity } = options;
    identity = identity || eventName;
    if (!jsbridgeWebsocket.eventCallbacks[eventName]) {
      return;
    }
    if (!jsbridgeWebsocket.eventCallbacks[eventName][identity]) {
      return;
    }
    delete jsbridgeWebsocket.eventCallbacks[eventName][identity];
  },
  /**
   * exec registered callback
   * @param eventName
   * @param message
   */
  execCallbacks(eventName, message) {
    var _a;
    let callbackKey = message.type;
    if (message.id) {
      callbackKey = `${callbackKey}_${message.id}`;
    } else {
      let allKeys = Object.keys(jsbridgeWebsocket.eventCallbacks[eventName]);
      let specialKeys = allKeys.filter((item) => {
        return item.startsWith(`${message.type}_`);
      });
      if (specialKeys.length > 0) {
        callbackKey = specialKeys[0];
      }
    }
    const callback = (_a = jsbridgeWebsocket.eventCallbacks[eventName]) == null ? void 0 : _a[callbackKey];
    if (callback) {
      callback(message);
    }
  },
  /**
   * @description send ws msg
   * @private
   */
  _sendRawWSMsg(WSMsg) {
    jsbridgeWebsocket.wsInstance.send(WSMsg);
  },
  /**
   *
   * @param {string} msgType - ws 消息类型
   * @param {Object} context - context
   * @return {Promise<*>}
   */
  sendMsg(msgType, context = {}) {
    const { data = {} } = context;
    let id = `${Date.now()}${Math.floor(Math.random() * 100).toString().padStart(2, "0")}`;
    const WSMsg = {
      type: msgType,
      id,
      body: { ...data }
    };
    jsbridgeWebsocket._sendRawWSMsg(WSMsg);
    return jsbridgeWebsocket.getWebSocketMonitor(msgType, id);
  },
  /**
   * 返回一个 ws 等待超时的 timer
   * @param msg_type 消息类型
   * @param time  等待多久
   * @param errMsg 超时失败
   * @returns {Promise<unknown>}
   */
  getWebSocketTimer(msg_type, time = 5e3, errMsg = "操作超时, 请重试") {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject({
          type: msg_type,
          data: {
            result_code: "timeout",
            display_message: errMsg
          }
        });
      }, time);
    });
  },
  /**
   * 监听指定消息类型的 websocket 消息
   * @param {string} msgType - 消息类型
   * @param {string} id - 消息唯一 id
   * @returns {Promise<unknown>}
   */
  getWebSocketMonitor(msgType, id) {
    return new Promise((resolve) => {
      const offMonitor = jsbridgeWebsocket.on({
        eventName: "message",
        identity: msgType,
        id
      }, (msg) => {
        resolve(msg.body || {});
        offMonitor();
      });
    });
  },
  /**
   *
   * @param {string} msgType - 需要监听的 ws 消息类型
   * @param {function} callback - 收到指定消息类型后的回调.
   * @return {(function(): void)|*} - 页面销毁, 或者不想继续监听时, 调用该方法
   */
  getWebSocketMonitorContinues(msgType, callback) {
    return jsbridgeWebsocket.on({
      eventName: "message",
      identity: msgType
    }, (msg) => {
      callback(msg);
    });
  }
};
const _NioCloudAppJsBridge = class _NioCloudAppJsBridge {
  static _eventCallBack(eventKey, value) {
    try {
      if (eventKey === this.EventCallbackKeyEnum.WINDOW_OPENED) {
        this.WINDOW_OPENED = true;
      } else if (eventKey === this.EventCallbackKeyEnum.WINDOW_CLOSED) {
        this.WINDOW_OPENED = false;
      }
    } catch (e) {
      console.log(e);
    }
    this._eventCallBackListenerList.forEach((handler) => {
      try {
        handler(eventKey, value);
      } catch (e) {
        console.log("window.nio_cloud_app.EventCallBack failed.\n", e);
      }
    });
  }
  /**
   * 初始化 EventCallBack 方法供车机端调用
   */
  static initEventCallBack() {
    if (!window.nio_cloud_app) {
      window.nio_cloud_app = {};
    }
    window.nio_cloud_app.EventCallBack = (eventKey, value) => {
      this._eventCallBack(eventKey, value);
    };
  }
  /**
   * dev mode
   */
  static initDevBridge() {
    window.nio_cloud_app = {
      InvokeEvent: () => {
        console.log("InvokeEvent\n", arguments);
        return "{}";
      }
    };
  }
  /**
   * H5调用-InvokeEvent
   * 车机端实现，供H5通知车机端需要处理的事件
   * @param {string} eventKey
   * @param {string} value
   * @return string JSON string
   */
  static invokeEvent(eventKey, value = "") {
    if (!this.hasJsBridge()) {
      throw new Error("no InvokeEvent method");
    }
    try {
      let _value = value;
      if (typeof value !== "string") {
        _value = JSON.stringify(value);
      }
      const resString = window.nio_cloud_app.InvokeEvent(
        eventKey,
        _value,
        null
      );
      return JSON.parse(resString || "{}");
    } catch (e) {
      console.log(e);
      return {
        result: -1,
        jsException: e
      };
    }
  }
  /**
   * H5调用-InvokeEvent (带 callback)
   * 车机端实现，供H5通知车机端需要处理的事件
   * @param eventKey
   * @param value
   * @param callback
   */
  static invokeEventWithCallback(eventKey, value = "", callback) {
    if (!this.hasJsBridge()) {
      throw new Error("no InvokeEvent method");
    }
    try {
      let callbackName = null;
      if (typeof callback === "function") {
        window.CA_JB_CB = (window.CA_JB_CB === void 0 ? -1 : window.CA_JB_CB) + 1;
        const d = "CA_JB_CB_" + window.CA_JB_CB;
        window[d] = (respStr) => {
          const resp = JSON.parse(respStr);
          callback(resp);
        };
        callbackName = d;
      }
      window.nio_cloud_app.InvokeEvent(eventKey, value, callbackName);
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * 添加 EventCallBack 监听事件
   * @param {function} handler
   */
  static addEventCallBackListener(handler) {
    this._eventCallBackListenerList.push(handler);
  }
  /**
   * 去除 EventCallBack 监听事件
   * @param {function} handler
   */
  static removeEventCallBackListener(handler) {
    for (let i = 0; i < this._eventCallBackListenerList.length; i++) {
      if (handler === this._eventCallBackListenerList[i]) {
        this._eventCallBackListenerList.splice(i, 1);
        i--;
      }
    }
  }
  /**
   * 通过 JsBridge 检测是否在 NIO Cloud APP 环境中运行
   * @returns {*}
   */
  static isInNioCloudApp() {
    return _NioCloudAppJsBridge.hasJsBridge();
  }
  /**
   * 检测是否存在 InvokeEvent 方法
   * @return {boolean}
   */
  static hasJsBridge() {
    return !!(window.nio_cloud_app && window.nio_cloud_app.InvokeEvent);
  }
  static closePage() {
    return this.invokeEvent(this.InvokeEventKeyEnum.CLOSE_PAGE);
  }
  static getLoginInfo() {
    return this.invokeEvent(this.InvokeEventKeyEnum.GET_LOGIN_INFO);
  }
  static getSystemInfo() {
    return this.invokeEvent(this.InvokeEventKeyEnum.GET_SYSTEM_INFO);
  }
  static openAmbientLight(value) {
    return this.invokeEvent(
      this.InvokeEventKeyEnum.OPEN_AMBIENT_LIGHT,
      value
    );
  }
  static closeAmbientLight() {
    return this.invokeEvent(this.InvokeEventKeyEnum.CLOSE_AMBIENT_LIGHT);
  }
  static nomiTTS(value) {
    return this.invokeEvent(this.InvokeEventKeyEnum.NOMI_TTS, value);
  }
  static showNomiEmoticon(value) {
    return this.invokeEvent(
      this.InvokeEventKeyEnum.SHOW_NOMI_EMOTICON,
      value
    );
  }
  static closeNomiEmoticon() {
    return this.invokeEvent(this.InvokeEventKeyEnum.CLOSE_NOMI_EMOTICON);
  }
  static showToast(value) {
    return this.invokeEvent(this.InvokeEventKeyEnum.TOAST, value);
  }
  static showDialog(value, callback) {
    return this.invokeEventWithCallback(
      this.InvokeEventKeyEnum.DIALOG,
      value,
      callback
    );
  }
  static pageLoaded() {
    return this.invokeEvent(this.InvokeEventKeyEnum.PAGE_LOADED);
  }
  static printLog(msg) {
    return this.invokeEvent(this.InvokeEventKeyEnum.PRINT_LOG, msg);
  }
  static openMap(context) {
    const { data = {} } = context;
    let { latitude, longitude, addressName: name } = data;
    latitude = Number.parseFloat(latitude);
    longitude = Number.parseFloat(longitude);
    const value = {
      latitude,
      longitude,
      name,
      address: name
    };
    this.smartAction([{
      id: "",
      actions: [{
        pkg: "com.nio.cloudapp",
        code: "StartNavi",
        value: JSON.stringify(value),
        domain: "NAVI"
      }],
      extra_data: { ver: 1 }
    }]);
  }
  static smartAction(value) {
    return this.invokeEvent(this.InvokeEventKeyEnum.SMART_ACTION, value);
  }
};
__publicField(_NioCloudAppJsBridge, "InvokeEventKeyEnum", {
  CLOSE_PAGE: "1000",
  GET_LOGIN_INFO: "1001",
  GET_SYSTEM_INFO: "1002",
  PAGE_LOADED: "1003",
  PRINT_LOG: "1004",
  OPEN_AMBIENT_LIGHT: "1301",
  CLOSE_AMBIENT_LIGHT: "1302",
  NOMI_TTS: "1303",
  SHOW_NOMI_EMOTICON: "1304",
  CLOSE_NOMI_EMOTICON: "1305",
  SMART_ACTION: "1306",
  TOAST: "1201",
  DIALOG: "1202"
});
/**
 * "NE086_BIRTHDAY_CONFETTI": NOMI 放彩带表情
 * "NE995_HEART_HANDS": NOMI 比心表情API
 */
__publicField(_NioCloudAppJsBridge, "NomiEmoticonEnum", {
  HEART_HANDS: "NE995_HEART_HANDS",
  BIRTHDAY_CONFETTI: "NE086_BIRTHDAY_CONFETTI"
});
/**
 * 1008: 关闭H5音视频
 */
__publicField(_NioCloudAppJsBridge, "EventCallbackKeyEnum", {
  SYSTEM_INFO_UPDATE: "9001",
  WINDOW_OPENED: "9002",
  CHANGE_BGM_STATUS: "9003",
  WINDOW_CLOSED: "9004"
});
/**
 * "2": "亮橙色",
 * "8": "亮蓝色",
 * "10": "亮紫色"
 */
__publicField(_NioCloudAppJsBridge, "AmbientLightKey", {
  ORANGE: "2",
  BLUE: "8",
  PURPLE: "10"
});
__publicField(_NioCloudAppJsBridge, "_eventCallBackListenerList", []);
__publicField(_NioCloudAppJsBridge, "WINDOW_OPENED", false);
let NioCloudAppJsBridge = _NioCloudAppJsBridge;
const debug$1 = typeof process === "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...args) => console.error("SEMVER", ...args) : () => {
};
var debug_1 = debug$1;
const SEMVER_SPEC_VERSION = "2.0.0";
const MAX_LENGTH$1 = 256;
const MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991;
const MAX_SAFE_COMPONENT_LENGTH = 16;
const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6;
const RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
var re$1 = { exports: {} };
(function(module, exports) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: MAX_SAFE_COMPONENT_LENGTH2,
    MAX_SAFE_BUILD_LENGTH: MAX_SAFE_BUILD_LENGTH2,
    MAX_LENGTH: MAX_LENGTH2
  } = constants;
  const debug2 = debug_1;
  exports = module.exports = {};
  const re2 = exports.re = [];
  const safeRe = exports.safeRe = [];
  const src = exports.src = [];
  const t2 = exports.t = {};
  let R = 0;
  const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
  const safeRegexReplacements = [
    ["\\s", 1],
    ["\\d", MAX_LENGTH2],
    [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH2]
  ];
  const makeSafeRegex = (value) => {
    for (const [token, max] of safeRegexReplacements) {
      value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    }
    return value;
  };
  const createToken = (name, value, isGlobal) => {
    const safe = makeSafeRegex(value);
    const index = R++;
    debug2(name, index, value);
    t2[name] = index;
    src[index] = value;
    re2[index] = new RegExp(value, isGlobal ? "g" : void 0);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : void 0);
  };
  createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
  createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
  createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
  createToken("MAINVERSION", `(${src[t2.NUMERICIDENTIFIER]})\\.(${src[t2.NUMERICIDENTIFIER]})\\.(${src[t2.NUMERICIDENTIFIER]})`);
  createToken("MAINVERSIONLOOSE", `(${src[t2.NUMERICIDENTIFIERLOOSE]})\\.(${src[t2.NUMERICIDENTIFIERLOOSE]})\\.(${src[t2.NUMERICIDENTIFIERLOOSE]})`);
  createToken("PRERELEASEIDENTIFIER", `(?:${src[t2.NUMERICIDENTIFIER]}|${src[t2.NONNUMERICIDENTIFIER]})`);
  createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t2.NUMERICIDENTIFIERLOOSE]}|${src[t2.NONNUMERICIDENTIFIER]})`);
  createToken("PRERELEASE", `(?:-(${src[t2.PRERELEASEIDENTIFIER]}(?:\\.${src[t2.PRERELEASEIDENTIFIER]})*))`);
  createToken("PRERELEASELOOSE", `(?:-?(${src[t2.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t2.PRERELEASEIDENTIFIERLOOSE]})*))`);
  createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
  createToken("BUILD", `(?:\\+(${src[t2.BUILDIDENTIFIER]}(?:\\.${src[t2.BUILDIDENTIFIER]})*))`);
  createToken("FULLPLAIN", `v?${src[t2.MAINVERSION]}${src[t2.PRERELEASE]}?${src[t2.BUILD]}?`);
  createToken("FULL", `^${src[t2.FULLPLAIN]}$`);
  createToken("LOOSEPLAIN", `[v=\\s]*${src[t2.MAINVERSIONLOOSE]}${src[t2.PRERELEASELOOSE]}?${src[t2.BUILD]}?`);
  createToken("LOOSE", `^${src[t2.LOOSEPLAIN]}$`);
  createToken("GTLT", "((?:<|>)?=?)");
  createToken("XRANGEIDENTIFIERLOOSE", `${src[t2.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
  createToken("XRANGEIDENTIFIER", `${src[t2.NUMERICIDENTIFIER]}|x|X|\\*`);
  createToken("XRANGEPLAIN", `[v=\\s]*(${src[t2.XRANGEIDENTIFIER]})(?:\\.(${src[t2.XRANGEIDENTIFIER]})(?:\\.(${src[t2.XRANGEIDENTIFIER]})(?:${src[t2.PRERELEASE]})?${src[t2.BUILD]}?)?)?`);
  createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t2.XRANGEIDENTIFIERLOOSE]})(?:${src[t2.PRERELEASELOOSE]})?${src[t2.BUILD]}?)?)?`);
  createToken("XRANGE", `^${src[t2.GTLT]}\\s*${src[t2.XRANGEPLAIN]}$`);
  createToken("XRANGELOOSE", `^${src[t2.GTLT]}\\s*${src[t2.XRANGEPLAINLOOSE]}$`);
  createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH2}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH2}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH2}}))?(?:$|[^\\d])`);
  createToken("COERCERTL", src[t2.COERCE], true);
  createToken("LONETILDE", "(?:~>?)");
  createToken("TILDETRIM", `(\\s*)${src[t2.LONETILDE]}\\s+`, true);
  exports.tildeTrimReplace = "$1~";
  createToken("TILDE", `^${src[t2.LONETILDE]}${src[t2.XRANGEPLAIN]}$`);
  createToken("TILDELOOSE", `^${src[t2.LONETILDE]}${src[t2.XRANGEPLAINLOOSE]}$`);
  createToken("LONECARET", "(?:\\^)");
  createToken("CARETTRIM", `(\\s*)${src[t2.LONECARET]}\\s+`, true);
  exports.caretTrimReplace = "$1^";
  createToken("CARET", `^${src[t2.LONECARET]}${src[t2.XRANGEPLAIN]}$`);
  createToken("CARETLOOSE", `^${src[t2.LONECARET]}${src[t2.XRANGEPLAINLOOSE]}$`);
  createToken("COMPARATORLOOSE", `^${src[t2.GTLT]}\\s*(${src[t2.LOOSEPLAIN]})$|^$`);
  createToken("COMPARATOR", `^${src[t2.GTLT]}\\s*(${src[t2.FULLPLAIN]})$|^$`);
  createToken("COMPARATORTRIM", `(\\s*)${src[t2.GTLT]}\\s*(${src[t2.LOOSEPLAIN]}|${src[t2.XRANGEPLAIN]})`, true);
  exports.comparatorTrimReplace = "$1$2$3";
  createToken("HYPHENRANGE", `^\\s*(${src[t2.XRANGEPLAIN]})\\s+-\\s+(${src[t2.XRANGEPLAIN]})\\s*$`);
  createToken("HYPHENRANGELOOSE", `^\\s*(${src[t2.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t2.XRANGEPLAINLOOSE]})\\s*$`);
  createToken("STAR", "(<|>)?=?\\s*\\*");
  createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
  createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$1, re$1.exports);
var reExports = re$1.exports;
const looseOption = Object.freeze({ loose: true });
const emptyOpts = Object.freeze({});
const parseOptions$1 = (options) => {
  if (!options) {
    return emptyOpts;
  }
  if (typeof options !== "object") {
    return looseOption;
  }
  return options;
};
var parseOptions_1 = parseOptions$1;
const numeric = /^[0-9]+$/;
const compareIdentifiers$1 = (a, b) => {
  const anum = numeric.test(a);
  const bnum = numeric.test(b);
  if (anum && bnum) {
    a = +a;
    b = +b;
  }
  return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const rcompareIdentifiers = (a, b) => compareIdentifiers$1(b, a);
var identifiers = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1;
const { MAX_LENGTH, MAX_SAFE_INTEGER } = constants;
const { safeRe: re, t } = reExports;
const parseOptions = parseOptions_1;
const { compareIdentifiers } = identifiers;
let SemVer$1 = class SemVer {
  constructor(version2, options) {
    options = parseOptions(options);
    if (version2 instanceof SemVer) {
      if (version2.loose === !!options.loose && version2.includePrerelease === !!options.includePrerelease) {
        return version2;
      } else {
        version2 = version2.version;
      }
    } else if (typeof version2 !== "string") {
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version2}".`);
    }
    if (version2.length > MAX_LENGTH) {
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    }
    debug("SemVer", version2, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    const m = version2.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
    if (!m) {
      throw new TypeError(`Invalid Version: ${version2}`);
    }
    this.raw = version2;
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
      throw new TypeError("Invalid major version");
    }
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
      throw new TypeError("Invalid minor version");
    }
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
      throw new TypeError("Invalid patch version");
    }
    if (!m[4]) {
      this.prerelease = [];
    } else {
      this.prerelease = m[4].split(".").map((id) => {
        if (/^[0-9]+$/.test(id)) {
          const num = +id;
          if (num >= 0 && num < MAX_SAFE_INTEGER) {
            return num;
          }
        }
        return id;
      });
    }
    this.build = m[5] ? m[5].split(".") : [];
    this.format();
  }
  format() {
    this.version = `${this.major}.${this.minor}.${this.patch}`;
    if (this.prerelease.length) {
      this.version += `-${this.prerelease.join(".")}`;
    }
    return this.version;
  }
  toString() {
    return this.version;
  }
  compare(other) {
    debug("SemVer.compare", this.version, this.options, other);
    if (!(other instanceof SemVer)) {
      if (typeof other === "string" && other === this.version) {
        return 0;
      }
      other = new SemVer(other, this.options);
    }
    if (other.version === this.version) {
      return 0;
    }
    return this.compareMain(other) || this.comparePre(other);
  }
  compareMain(other) {
    if (!(other instanceof SemVer)) {
      other = new SemVer(other, this.options);
    }
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
  }
  comparePre(other) {
    if (!(other instanceof SemVer)) {
      other = new SemVer(other, this.options);
    }
    if (this.prerelease.length && !other.prerelease.length) {
      return -1;
    } else if (!this.prerelease.length && other.prerelease.length) {
      return 1;
    } else if (!this.prerelease.length && !other.prerelease.length) {
      return 0;
    }
    let i = 0;
    do {
      const a = this.prerelease[i];
      const b = other.prerelease[i];
      debug("prerelease compare", i, a, b);
      if (a === void 0 && b === void 0) {
        return 0;
      } else if (b === void 0) {
        return 1;
      } else if (a === void 0) {
        return -1;
      } else if (a === b) {
        continue;
      } else {
        return compareIdentifiers(a, b);
      }
    } while (++i);
  }
  compareBuild(other) {
    if (!(other instanceof SemVer)) {
      other = new SemVer(other, this.options);
    }
    let i = 0;
    do {
      const a = this.build[i];
      const b = other.build[i];
      debug("prerelease compare", i, a, b);
      if (a === void 0 && b === void 0) {
        return 0;
      } else if (b === void 0) {
        return 1;
      } else if (a === void 0) {
        return -1;
      } else if (a === b) {
        continue;
      } else {
        return compareIdentifiers(a, b);
      }
    } while (++i);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(release, identifier, identifierBase) {
    switch (release) {
      case "premajor":
        this.prerelease.length = 0;
        this.patch = 0;
        this.minor = 0;
        this.major++;
        this.inc("pre", identifier, identifierBase);
        break;
      case "preminor":
        this.prerelease.length = 0;
        this.patch = 0;
        this.minor++;
        this.inc("pre", identifier, identifierBase);
        break;
      case "prepatch":
        this.prerelease.length = 0;
        this.inc("patch", identifier, identifierBase);
        this.inc("pre", identifier, identifierBase);
        break;
      case "prerelease":
        if (this.prerelease.length === 0) {
          this.inc("patch", identifier, identifierBase);
        }
        this.inc("pre", identifier, identifierBase);
        break;
      case "major":
        if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) {
          this.major++;
        }
        this.minor = 0;
        this.patch = 0;
        this.prerelease = [];
        break;
      case "minor":
        if (this.patch !== 0 || this.prerelease.length === 0) {
          this.minor++;
        }
        this.patch = 0;
        this.prerelease = [];
        break;
      case "patch":
        if (this.prerelease.length === 0) {
          this.patch++;
        }
        this.prerelease = [];
        break;
      case "pre": {
        const base = Number(identifierBase) ? 1 : 0;
        if (!identifier && identifierBase === false) {
          throw new Error("invalid increment argument: identifier is empty");
        }
        if (this.prerelease.length === 0) {
          this.prerelease = [base];
        } else {
          let i = this.prerelease.length;
          while (--i >= 0) {
            if (typeof this.prerelease[i] === "number") {
              this.prerelease[i]++;
              i = -2;
            }
          }
          if (i === -1) {
            if (identifier === this.prerelease.join(".") && identifierBase === false) {
              throw new Error("invalid increment argument: identifier already exists");
            }
            this.prerelease.push(base);
          }
        }
        if (identifier) {
          let prerelease = [identifier, base];
          if (identifierBase === false) {
            prerelease = [identifier];
          }
          if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
            if (isNaN(this.prerelease[1])) {
              this.prerelease = prerelease;
            }
          } else {
            this.prerelease = prerelease;
          }
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${release}`);
    }
    this.raw = this.format();
    if (this.build.length) {
      this.raw += `+${this.build.join(".")}`;
    }
    return this;
  }
};
var semver = SemVer$1;
const SemVer2 = semver;
const compare$1 = (a, b, loose) => new SemVer2(a, loose).compare(new SemVer2(b, loose));
var compare_1 = compare$1;
const compare = compare_1;
const gte = (a, b, loose) => compare(a, b, loose) >= 0;
var gte_1 = gte;
const semverGte = /* @__PURE__ */ getDefaultExportFromCjs(gte_1);
const version = "0.2.6";
function getDsBridge$1() {
  return window["dsBridge"];
}
function getAppInfo$4() {
  return getDsBridge$1().call("getAppInfo", "");
}
function getOSInfo$4() {
  return getDsBridge$1().call("getOSInfo", "");
}
function getModuleInfo$3() {
  return getDsBridge$1().call("getModuleInfo", "");
}
async function getUserInfo$5() {
  const info = await getDsBridge$1().call("getUserInfo", "");
  const { result_code } = info;
  if (result_code !== "success") {
    return info;
  }
  if (info.result_code === "success") {
    const accountId = info.data.accountId || info.data.account_id;
    info.data.accountId = accountId;
    info.data.account_id = accountId;
    info.data.avatar = info.data.avatar || "";
    if (!info.data.displayLanguage) {
      info.data.displayLanguage = "";
    }
    const { mobile } = info.data;
    if (typeof mobile === "string")
      ;
    else {
      ["callingCode", "calling_code", "mobile"].forEach((item) => {
        info.data.mobile[item] = info.data.mobile[item] || "";
      });
      const callingCode = info.data.mobile.calling_code || info.data.mobile.callingCode;
      info.data.mobile.callingCode = callingCode;
      info.data.mobile.calling_code = callingCode;
    }
    if (currentInNioCNAndroid()) {
      const { account_name } = info.data;
      info.data.nick_name = account_name;
      info.data.nickName = account_name;
    }
    if (!info.data.countryCode) {
      info.data.countryCode = "";
    }
  }
  return info;
}
async function _getUserInfoV2$1() {
  const info = await getUserInfo$5();
  const { mobile } = info.data;
  if (typeof mobile === "string") {
    info.data.mobile = {
      mobile,
      callingCode: "",
      calling_code: ""
    };
  }
  return info;
}
function getCurrencyFormat$3(context) {
  checker(context);
  return getDsBridge$1().call("getCurrencyFormat", context.data);
}
function getNumberFormat$3(context) {
  checker(context);
  return getDsBridge$1().call("getNumberFormat", context.data);
}
function getScrambleId$3(context) {
  checker(context);
  return getDsBridge$1().call("getScrambleId", context.data);
}
function touchSlopAndroid$3(context) {
  return getDsBridge$1().call("touchSlop", context.data);
}
function requestEventAndroid$3(context) {
  return getDsBridge$1().call("requestEvent", context.data);
}
const APP_NIO_DOMAIN = {
  dev: "https://app-dev.nio.com",
  test: "https://app-test.nio.com",
  stg: "https://app-stg.nio.com",
  prod: "https://app.nio.com"
};
const GATEWAY_DOMAIN = {
  dev: "https://gateway-front-external-dev.nioint.com",
  test: "https://gateway-front-external-test.nioint.com",
  stg: "https://gateway-front-external-stg.nio.com",
  prod: "https://gateway-front-external.nio.com"
};
async function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
async function getUserInfo$4(context) {
  const { data = {} } = context;
  const { env = "prod", autoJump = false, customQuery = {}, reload = true } = data;
  const gotoUniversalLogin = async () => {
    const params = {
      redirect_url: data.redirectUrl ? decodeURIComponent(data.redirectUrl) : window.location.href,
      ...customQuery
    };
    window.location.href = `${APP_NIO_DOMAIN[env]}/app/community_basic_h5/module_10093/login/nio_cn?${qs.stringify(params)}`;
    await sleep(5e3);
  };
  let token = localStorage.getItem("universal_bridge_token");
  if (!token) {
    const urlParams2 = new URLSearchParams(window.location.search);
    try {
      token = urlParams2.get("token");
    } catch (e) {
      await gotoUniversalLogin();
      return;
    }
  }
  if (!token) {
    if (!autoJump) {
      return {
        "display_message": "用户未登录",
        "result_code": "not_login"
      };
    }
    await gotoUniversalLogin();
    return;
  }
  localStorage.setItem("universal_bridge_token", token);
  const response = await fetch(`${GATEWAY_DOMAIN[env]}/moat/10086/app/api/mercury/v2/invite/friend/userInfo`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    }
  });
  const jsonResult = await response.json();
  if (jsonResult.result_code !== "success") {
    localStorage.removeItem("universal_bridge_token");
    await gotoUniversalLogin();
    return;
  }
  const user = jsonResult.data.user;
  const { medal = {} } = user;
  const result = {
    access_token: token,
    accountId: user.account_id.toString(),
    account_id: user.account_id.toString(),
    avatar: user.head_image,
    medal: {
      certification: medal.certification,
      identity: medal.identity,
      img_url: medal.img_url,
      is_nio_authorized: medal.is_nio_authorized,
      level_name: medal.level_name
    },
    mobile: {
      callingCode: user.country_code,
      calling_code: user.country_code,
      mobile: user.mobile
    },
    nickName: user.nickname,
    nick_name: user.nickname,
    profile_id: user.account_id.toString(),
    user_id: user.account_id.toString()
  };
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("token")) {
    urlParams.delete("token");
    let url = `${window.location.origin}${window.location.pathname}`;
    if (urlParams.toString()) {
      url = `${url}?${urlParams.toString()}`;
    }
    if (reload) {
      window.location.href = decodeURIComponent(url);
    } else {
      history.pushState({}, "", decodeURIComponent(url));
    }
  }
  return Promise.resolve({
    result_code: "success",
    data: result
  });
}
function getWSConnect$1(env = "prod", config) {
  if (jsbridgeWebsocket.wsInstance === null) {
    jsbridgeWebsocket.open(env, config);
  }
  return jsbridgeWebsocket;
}
function reportLiving$1(env) {
  getWSConnect$1(env)._sendRawWSMsg({
    type: WEBSOCKET_CONSTANT.MSG_TYPE.REPORT_LIVING
  });
}
function monitorLiving$1(env, uuid, callback) {
  getWSConnect$1(env, {
    from: "h5",
    to: "mp",
    uuid
  }).getWebSocketMonitorContinues(WEBSOCKET_CONSTANT.MSG_TYPE.REPORT_LIVING, callback);
}
function showToast$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SHOW_TOAST, context);
}
function showLoading$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SHOW_LOADING, context);
}
function hideLoading$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.HIDE_LOADING, context);
}
function makeCall$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.MAKE_CALL, context);
}
function setCopyText$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SET_COPY_TEXT, context);
}
function getAppInfo$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_APP_INFO, context);
}
function getUserInfo$3(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_USER_INFO, context);
}
function getUserInfoForTitan$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_USER_INFO_FOR_TITAN, context);
}
function getOSInfo$3(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_OS_INFO, context);
}
function getVehicleInfo$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_VEHICLE_INFO, context);
}
function getModuleInfo$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_MODULE_INFO, context);
}
function getDebugInfo$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_DEBUG_INFO, context);
}
function getNotificationSettings$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_NOTIFICATION_SETTINGS, context);
}
function getLocation$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_LOCATION, context);
}
function openNotificationSetting$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_NOTIFICATION_SETTING, context);
}
function iosAllowsBackForwardNavigationGestures$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.IOS_ALLOWS_BACK_FORWARD_NAVIGATION_GESTURES, context);
}
function iosDisableBackForwardNavigationGestures$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.IOS_DISABLE_BACK_FORWARD_NAVIGATION_GESTURES, context);
}
function openMap$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_MAP, context);
}
function openPDF$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_PDF, context);
}
function showCountries$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SHOW_COUNTRIES, context);
}
function downloadVideo$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.DOWNLOAD_VIDEO, context);
}
function imagePicker$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.IMAGE_PICKER, context);
}
function selectImage$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SELECT_IMAGE, context);
}
function saveImage$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SAVE_IMAGE, context);
}
function previewPhoto$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.PREVIEW_IMAGE, context);
}
function scanQR$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SCAN_QR, context);
}
function setHeaderOption$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SET_HEADER_OPTION, context);
}
function openLoginPage$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_LOGIN_PAGE, context);
}
function openURL$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_URL, context);
}
function replace$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.REPLACE, context);
}
function setPageIdentifier$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SET_PAGE_IDENTIFIER, context);
}
function pay$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.PAYMENT, context);
}
function share$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SHARE, context);
}
function share2$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SHARE2, context);
}
function shareImage$3(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SHARE_IMAGE, context);
}
function openExternalBrowser$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_EXTERNAL_BROWSER, context);
}
function openNioInputEdit$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_NIO_INPUT_EDIT, context);
}
function openNioInputEdit2$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_NIO_INPUT_EDIT2, context);
}
function postUGC$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.POST_UGC, context);
}
function report$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.REPORT, context);
}
function postNotificationFromHtmlToNative$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.POST_NOTIFICATION_FROM_HTML_TO_NATIVE, context);
}
function iosToggleBounces$1(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.IOS_TOGGLE_BOUNCES, context);
}
function getCurrencyFormat$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_CURRENCY_FORMAT, context);
}
function getNumberFormat$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_NUMBER_FORMAT, context);
}
function requestReward$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.REQUEST_REWARD, context);
}
function translate$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.TRANSLATE, context);
}
function getScrambleId$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_SCRAMBLE_ID, context);
}
function notificationAuthorizationStatus$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.NOTIFICATION_AUTHORIZATION_STATUS, context);
}
function openAppSetting$2(context = {}) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_APP_SETTING, context);
}
function getInvoiceDetail$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_INVOICE_DETAIL, context);
}
function addCalendarEvent$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.ADD_CALENDAR_EVENT, context);
}
function touchSlopAndroid$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.TOUCH_SLOP_ANDROID, context);
}
function requestEventAndroid$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.REQUEST_EVENT_ANDROID, context);
}
function sendPOI$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SEND_POI, context);
}
function setShareConfigMP$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SET_SHARE_CONFIG_MP, context);
}
function getGlobalDataMP$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_GLOBAL_DATA_MP, context);
}
function setGlobalDataMP$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SET_GLOBAL_DATA_MP, context);
}
function setNavigationBarTitle$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.SET_NAVIGATION_BAR_TITLE, context);
}
function getWXLoginCode$2(context) {
  return getWSConnect$1().sendMsg(WEBSOCKET_CONSTANT.MSG_TYPE.GET_WX_LOGIN_CODE, context);
}
const MP_CENTRAL_PAGE = "/modules/universal/pages/universal-bridge-central/index";
function showToast$2(context) {
  return showToast$3(context);
}
function showLoading$2(context) {
  const { content = "", mask = false } = context.data;
  return showLoading$3({
    data: {
      title: content,
      mask
    }
  });
}
function hideLoading$2() {
  return hideLoading$3();
}
function makeCall$2(context) {
  return makeCall$3(context);
}
function setCopyText$2(context) {
  return setCopyText$3(context);
}
function getAppInfo$2() {
  return new Promise((resolve) => {
    Promise.race([
      getAppInfo$3(),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.GET_APP_INFO)
    ]).then((res) => {
      resolve(res);
    }).catch((err) => {
      resolve(err);
    });
  });
}
function getBindMobileMP$1(context) {
  return new Promise((resolve, reject) => {
    let mpParams = {
      // 需要执行操作的类型
      type: WEBSOCKET_CONSTANT.MSG_TYPE.GET_WECHAT_BIND_MOBILE,
      // 额外需要的参数放这个里面
      data: {}
    };
    let jumpURL = `${MP_CENTRAL_PAGE}?${lib.stringify(mpParams)}`;
    navigatorToMpPage(jumpURL).then((result) => {
      resolve(result);
    }).catch((err) => {
      reject(err);
    });
  });
}
function openCustomerServiceChatMP$1(context) {
  return new Promise((resolve, reject) => {
    let mpParams = {
      // 需要执行操作的类型
      type: WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_CUSTOMER_SERVICE_CHAT,
      // 额外需要的参数放这个里面
      body: context
    };
    let jumpURL = `${MP_CENTRAL_PAGE}?${lib.stringify(mpParams)}`;
    navigatorToMpPage(jumpURL).then((result) => {
      resolve(result);
    }).catch((err) => {
      reject(err);
    });
  });
}
function getUserInfo$2(context = {}) {
  const { central = false } = context;
  return new Promise((resolve, reject) => {
    Promise.race([
      getUserInfo$3(context),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.GET_USER_INFO)
    ]).then((result) => resolve(result)).catch((err) => {
      const { data = {} } = err;
      const { result_code = "" } = data;
      if (result_code === "timeout" && central) {
        let mpParams = {
          // 需要执行操作的类型
          type: WEBSOCKET_CONSTANT.MSG_TYPE.GET_USER_INFO,
          // 额外需要的参数放这个里面
          data: {}
        };
        let jumpURL = `${MP_CENTRAL_PAGE}?${lib.stringify(mpParams)}`;
        navigatorToMpPage(jumpURL).then((result) => {
          resolve(result);
        }).catch((err2) => {
          resolve(err2);
        });
      } else {
        return unknownError();
      }
    });
  });
}
function getOSInfo$2() {
  return new Promise((resolve) => {
    Promise.race([
      getOSInfo$3(),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.GET_OS_INFO)
    ]).then((res) => {
      resolve(res);
    }).catch((err) => {
      resolve(err);
    });
  });
}
function setNavigationBarTitle$1(context = {}) {
  setNavigationBarTitle$2(context).then();
  return currentExecSuccess();
}
function getLocation$2(context) {
  const { data = {}, central = false } = context;
  const { type = "gcj-02" } = data;
  checker(context);
  const centralHandler = (resolve, reject) => {
    let mpParams = {
      // 需要执行操作的类型
      type: WEBSOCKET_CONSTANT.MSG_TYPE.GET_LOCATION,
      // 额外需要的参数放这个里面
      data: {}
    };
    let jumpURL = `${MP_CENTRAL_PAGE}?${lib.stringify(mpParams)}`;
    navigatorToMpPage(jumpURL).then((result) => {
      resolve(result);
    }).catch((err) => {
      resolve(err);
    });
  };
  if (central) {
    return new Promise((resolve, reject) => {
      centralHandler(resolve);
    });
  }
  return new Promise((resolve, reject) => {
    Promise.race([
      getLocation$3({
        data: { type }
      }),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.GET_LOCATION)
    ]).then((res) => {
      resolve(res);
    }).catch((err) => {
      const { data: data2 = {} } = err;
      const { result_code = "" } = data2;
      if (result_code === "timeout") {
        centralHandler(resolve);
      } else {
        return unknownError();
      }
    });
  });
}
function openMap$2(context) {
  return new Promise((resolve) => {
    Promise.race([
      openMap$3(context),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.OPEN_MAP)
    ]).then((res) => {
      resolve(res);
    }).catch((err) => {
      resolve(err);
    });
  });
}
function openURL$2(context) {
  const { data = {} } = context;
  const { url = "" } = data;
  wx.miniProgram.navigateTo({
    url
  });
  return currentExecSuccess();
}
function saveImage$2(context) {
  return new Promise((resolve) => {
    Promise.race([
      saveImage$3(context)
    ]).then((res) => {
      resolve(res);
    }).catch((err) => {
      resolve(err);
    });
  });
}
function previewPhoto$2(context) {
  return new Promise((resolve) => {
    Promise.race([
      previewPhoto$3(context)
    ]).then((res) => {
      resolve(res);
    }).catch((err) => {
      resolve(err);
    });
  });
}
function scanQR$2(context) {
  return new Promise((resolve) => {
    Promise.race([
      scanQR$3(context)
    ]).then((res) => {
      const { result, scanType, charSet, path, rawData } = res;
      resolve({
        result_code: "success",
        data: {
          value: result,
          scanType,
          charSet,
          path,
          // 如果是小程序码, 会有这个字段.
          rawData
        }
      });
    }).catch((err) => {
      resolve(err);
    });
  });
}
function replace$2(context) {
  const { data = {} } = context;
  const { url = "" } = data;
  wx.miniProgram.redirectTo({
    url
  });
  return currentExecSuccess();
}
function reLaunch(context) {
  const { data = {} } = context;
  const { url = "" } = data;
  wx.miniProgram.reLaunch({
    url
  });
  return currentExecSuccess();
}
function close$2() {
  wx.miniProgram.navigateBack();
  return currentExecSuccess();
}
function pay$2(context) {
  const { amount, merchantNo, payOrderNo } = context.data;
  let mpParams = {
    // 需要执行操作的类型
    type: WEBSOCKET_CONSTANT.MSG_TYPE.PAYMENT,
    // 额外需要的参数放这个里面
    data: {
      amount,
      merchantNo,
      payOrderNo,
      module: "activity"
    }
  };
  return new Promise((resolve) => {
    navigatorToMpPage(`${MP_CENTRAL_PAGE}?${lib.stringify(mpParams)}`).then((res) => {
      resolve(res);
    });
  });
}
function shareImage$2(context) {
  return new Promise((resolve) => {
    Promise.race([
      shareImage$3(context)
    ]).then((result) => {
      resolve(result);
    }).catch((err) => {
      resolve(err);
    });
  });
}
function setShareConfigMP$1(context) {
  return new Promise((resolve) => {
    Promise.race([
      setShareConfigMP$2(context),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.SET_SHARE_CONFIG_MP)
    ]).then((result) => {
      resolve(result);
    }).catch((err) => {
      resolve(err);
    });
  });
}
function getGlobalDataMP$1(context) {
  return new Promise((resolve) => {
    Promise.race([
      getGlobalDataMP$2(context),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.GET_GLOBAL_DATA_MP)
    ]).then((result) => resolve(result)).catch((err) => resolve(err));
  });
}
function setGlobalDataMP$1(context) {
  return new Promise((resolve) => {
    Promise.race([
      setGlobalDataMP$2(context),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.SET_GLOBAL_DATA_MP)
    ]).then((result) => resolve(result)).catch((err) => resolve(err));
  });
}
function getWXLoginCode$1(context) {
  return new Promise((resolve) => {
    Promise.race([
      getWXLoginCode$2(context),
      jsbridgeWebsocket.getWebSocketTimer(WEBSOCKET_CONSTANT.MSG_TYPE.SET_GLOBAL_DATA_MP)
    ]).then((result) => resolve(result)).catch((err) => resolve(err));
  });
}
function deepFreeze(object) {
  const propNames = Reflect.ownKeys(object);
  for (const name of propNames) {
    const value = object[name];
    if (value && typeof value === "object" || typeof value === "function") {
      deepFreeze(value);
    }
  }
  return Object.freeze(object);
}
const BRIDGE_CONSTANT = {
  RESULT_CODE: {
    SUCCESS: "success"
  },
  TOAST: {
    LENGTH: "LENGTH",
    SHORT: "SHORT"
  },
  SWITCH: {
    ENABLE: "1",
    DISABLE: "0"
  },
  SCHEME: {
    CHINA: "nio",
    GLOBAL: "nioapp"
  },
  LOCATION: {
    WGS_84: "wgs-84",
    GCJ_02: "gcj-02"
  },
  OS: {
    ANDROID: "android",
    IOS: "ios"
  },
  EVENT: {
    ON_PRESS_BACK: "ON_PRESS_BACK",
    // 点击回退按钮
    ON_APPEAR: "ON_APPEAR",
    // 切换页面
    ON_NET_WORK_CHANGE: "ON_NET_WORK_CHANGE",
    // 网络状态变化
    ON_PULL_REFRESH: "ON_PULL_REFRESH",
    // 下拉刷新通知
    ON_SELF_DEFINE_EVENT_FOR_HEAD: "ON_SELF_DEFINE_EVENT_FOR_HEAD",
    // 自定义头部注册按钮的回调
    ON_INPUT_KEYBROAD_CHANGE: "ON_INPUT_KEYBROAD_CHANGE",
    // nio 定制输入组件弹出回调
    ON_KEYBOARD_STATE_CHANGE: "ON_KEYBOARD_STATE_CHANGE",
    // 软键盘弹出收起状态通知
    ON_URL_CHANGE: "ON_URL_CHANGE"
    // 客户端通知h5 出发url 重定向
  }
};
deepFreeze(BRIDGE_CONSTANT);
var minimal$1 = {};
var model240dd8c3 = {};
var z = Object.defineProperty;
var Q = (t2, e, n) => e in t2 ? z(t2, e, { enumerable: true, configurable: true, writable: true, value: n }) : t2[e] = n;
var Y = (t2, e, n) => (Q(t2, typeof e != "symbol" ? e + "" : e, n), n);
const Z = { TYPE: "ualt-action-type", EVENT_NAME: "ualt-action-event-name", EVENT_METRICS: "ualt-action-event-metrics", EVENT_CATEGORIES: "ualt-action-event-categories", LOG_CONTENT: "ualt-action-log-content", LOG_LEVEL: "ualt-action-log-level", LOG_EXTRA: "ualt-action-log-extra" };
function tt(t2, e, n) {
  var f, g2, m;
  if (!t2 || !(n != null && n.enable) || typeof window == "undefined" || !(window != null && window.document) || !((f = window == null ? void 0 : window.document) != null && f.addEventListener))
    return;
  const { TYPE: o, EVENT_NAME: r, EVENT_METRICS: l, EVENT_CATEGORIES: d, LOG_CONTENT: u, LOG_LEVEL: i, LOG_EXTRA: E } = Z;
  (m = (g2 = window.document) == null ? void 0 : g2.addEventListener) == null || m.call(g2, "click", (w) => {
    var N, b, L, y, O, T, k, h, R, U, S, V, B, x, P, G, D, J, K, F;
    try {
      if (!w)
        return;
      const v = (N = w == null ? void 0 : w.target) != null ? N : w == null ? void 0 : w.srcElement;
      let W = (b = n == null ? void 0 : n.depth) != null ? b : 7;
      for (let s = v; s && (s == null ? void 0 : s.nodeType) !== 9 && W >= 0; s = s == null ? void 0 : s.parentNode) {
        if (W--, (s == null ? void 0 : s.nodeType) !== 1)
          continue;
        const a = s, _ = (L = a == null ? void 0 : a.getAttribute) == null ? void 0 : L.call(a, r), I = (y = a == null ? void 0 : a.getAttribute) == null ? void 0 : y.call(a, u), X = (k = (T = (O = a == null ? void 0 : a.getAttribute) == null ? void 0 : O.call(a, o)) != null ? T : n == null ? void 0 : n.defaultType) != null ? k : o;
        if (X === "log") {
          if (!I)
            continue;
          const p = (U = (R = (h = a == null ? void 0 : a.getAttribute) == null ? void 0 : h.call(a, i)) != null ? R : n == null ? void 0 : n.defaultLogLevel) != null ? U : "info", C = JSON.parse((V = (S = a == null ? void 0 : a.getAttribute) == null ? void 0 : S.call(a, E)) != null ? V : "{}");
          e === "standard" ? (B = t2 == null ? void 0 : t2.sendLog) == null || B.call(t2, { level: p, content: I, extra: C }) : (x = t2 == null ? void 0 : t2.report) == null || x.call(t2, { ev_type: "custom", payload: { level: p, content: I, categories: C, type: "log" } });
          return;
        } else if (X === "event") {
          if (!_)
            continue;
          const p = JSON.parse((G = (P = a == null ? void 0 : a.getAttribute) == null ? void 0 : P.call(a, l)) != null ? G : "{}"), C = JSON.parse((J = (D = a == null ? void 0 : a.getAttribute) == null ? void 0 : D.call(a, d)) != null ? J : "{}");
          e === "standard" ? (K = t2 == null ? void 0 : t2.sendEvent) == null || K.call(t2, { name: _, metrics: p, categories: C }) : (F = t2 == null ? void 0 : t2.report) == null || F.call(t2, { ev_type: "custom", payload: { name: _, metrics: p, categories: C, type: "event" } });
          return;
        }
      }
    } catch (v) {
      console.log("[NIO APM Plus] autoReportClickEventPlugin failed", v);
    }
  }, true);
}
function et() {
  var n, o;
  const t2 = (o = (n = window == null ? void 0 : window.dsBridge) == null ? void 0 : n.call) == null ? void 0 : o.call(n, "getUserInfo", ""), { result_code: e } = t2;
  if (e !== "success")
    return t2;
  if (t2.result_code === "success") {
    const r = t2.data.accountId || t2.data.account_id;
    t2.data.accountId = r, t2.data.account_id = r, t2.data.avatar = t2.data.avatar || "", t2.data.displayLanguage || (t2.data.displayLanguage = "");
    const { mobile: l } = t2.data;
    if (typeof l != "string") {
      ["callingCode", "calling_code", "mobile"].forEach((u) => {
        t2.data.mobile[u] = t2.data.mobile[u] || "";
      });
      const d = t2.data.mobile.calling_code || t2.data.mobile.callingCode;
      t2.data.mobile.callingCode = d, t2.data.mobile.calling_code = d;
    }
    if (A()) {
      const { account_name: d } = t2.data;
      t2.data.nick_name = d, t2.data.nickName = d;
    }
    t2.data.countryCode || (t2.data.countryCode = "");
  }
  return t2;
}
function nt(t2 = {}) {
  const e = at(t2), { result_code: n, data: o = { access_token: "" } } = e;
  if (n !== "success" || !o.access_token)
    return e;
  const { mobile: r } = e.data;
  return typeof r == "string" && (e.data.mobile = { mobile: r, callingCode: "", calling_code: "" }), e;
}
function at(t2 = {}) {
  var r, l, d, u;
  const e = window.dsBridge.call("getUserInfo", t2), { result_code: n, data: o = { access_token: "" } } = e;
  if (n !== "success" || !o.access_token)
    return e;
  if (e.result_code === "success") {
    const i = e.data.accountId || e.data.account_id;
    e.data.accountId = i, e.data.account_id = i, e.data.avatar = e.data.avatar || "", e.data.displayLanguage || (e.data.displayLanguage = "");
    const { mobile: E } = e.data;
    if (typeof E != "string") {
      ["callingCode", "calling_code", "mobile"].forEach((g2) => {
        e.data.mobile[g2] = e.data.mobile[g2] || "";
      });
      const f = ((l = (r = e.data) == null ? void 0 : r.mobile) == null ? void 0 : l.calling_code) || ((u = (d = e.data) == null ? void 0 : d.mobile) == null ? void 0 : u.callingCode);
      e.data.mobile.callingCode = f, e.data.mobile.calling_code = f;
    }
    if (A()) {
      const { account_name: f } = e.data;
      e.data.nick_name = f, e.data.nickName = f;
    }
    e.data.countryCode || (e.data.countryCode = "");
  }
  return e;
}
function q() {
  var t2, e;
  return (e = (t2 = window == null ? void 0 : window.dsBridge) == null ? void 0 : t2.call) == null ? void 0 : e.call(t2, "getAppInfo", "");
}
function ot() {
  var t2, e;
  return (e = (t2 = window == null ? void 0 : window.dsBridge) == null ? void 0 : t2.call) == null ? void 0 : e.call(t2, "getOSInfo", "");
}
class H {
  static _eventCallBack(e, n) {
    this._eventCallBackListenerList.forEach((o) => {
      try {
        o(e, n);
      } catch (r) {
        console.error(`window.nio_cloud_app.EventCallBack failed.
`, r);
      }
    });
  }
  static initEventCallBack() {
    window.nio_cloud_app || (window.nio_cloud_app = {}), window.nio_cloud_app.EventCallBack = (e, n) => {
      this._eventCallBack(e, n);
    };
  }
  static invokeEvent(e, n = "") {
    try {
      let o = n;
      typeof n != "string" && (o = JSON.stringify(n));
      const r = window.nio_cloud_app.InvokeEvent(e, o, null);
      return JSON.parse(r || "{}");
    } catch (o) {
      return console.error(o), { result: -1, jsException: o };
    }
  }
  static getLoginInfo() {
    return this.invokeEvent("1001");
  }
}
Y(H, "_eventCallBackListenerList", []);
let c = "unknown";
function rt() {
  try {
    M() ? c = "lg" : ut() ? c = "wx" : st() ? c = "cloud_app" : dt() && (c = "webf");
  } catch (t2) {
    console.error(t2);
  }
}
function ct() {
  return c;
}
function it() {
  var t2, e;
  if (c === "lg" || c === "webf")
    try {
      const n = q();
      return (e = (t2 = n == null ? void 0 : n.data) == null ? void 0 : t2.version) != null ? e : "NA";
    } catch (n) {
      return console.log(n), "NA";
    }
  return "NA";
}
function dt() {
  return navigator.userAgent.toLowerCase().includes("webf/");
}
function st() {
  return navigator.userAgent.toLowerCase().includes("wv=cloudapp") || location.href.includes("is_cloud_app=true");
}
function ut() {
  return navigator.userAgent.includes("miniProgram");
}
function M() {
  return navigator.userAgent.toLowerCase().includes("webview/lg");
}
function A() {
  const t2 = navigator.userAgent.toLowerCase();
  return t2.includes("android") && t2.includes("nioappcn") && t2.includes("webview/lg");
}
function lt() {
  var t2, e, n, o, r, l, d, u;
  if (c === "wx")
    return (t2 = new URL(window.location.href).searchParams.get("distinctId")) != null ? t2 : void 0;
  try {
    if (c === "lg") {
      const i = nt();
      return (o = (e = i.data) == null ? void 0 : e.account_id) != null ? o : (n = i.data) == null ? void 0 : n.accountId;
    } else if (c === "webf") {
      const i = et();
      return (d = (r = i.data) == null ? void 0 : r.account_id) != null ? d : (l = i.data) == null ? void 0 : l.accountId;
    } else if (c === "cloud_app")
      return (u = H.getLoginInfo().data) == null ? void 0 : u.profile_id;
  } catch (i) {
    console.log(i);
  }
}
function ft() {
  var t2, e;
  if (c === "lg" || c === "webf")
    try {
      return (e = (t2 = q().data) == null ? void 0 : t2.env) != null ? e : j();
    } catch (n) {
      console.log(n);
    }
  return j();
}
function j() {
  var t2;
  try {
    const e = (t2 = window.location.hostname) != null ? t2 : window.location.host;
    if (e === "127.0.0.1" || e === "localhost" || e.indexOf("-local") > -1 || gt(e))
      return "local";
    if (e.indexOf("-dev") > -1 || e.indexOf("-qa") > -1)
      return "dev";
    if (e.indexOf("-test") > -1 || e.indexOf("-sit") > -1)
      return "test";
    if (e.indexOf("-stg") > -1 || e.indexOf("-uat") > -1)
      return "stg";
  } catch (e) {
    console.log(e);
  }
  return "prod";
}
function gt(t2) {
  return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(t2);
}
function wt() {
  var t2;
  if (c === "lg" || c === "webf")
    try {
      return (t2 = ot().data) == null ? void 0 : t2.device_id;
    } catch (e) {
      console.log(e);
    }
}
const pt = "2.8.2";
var $ = ((t2) => (t2.fp = "fp", t2.fcp = "fcp", t2.fid = "fid", t2.mpfid = "mpfid", t2.lcp = "lcp", t2.cls = "cls", t2.longtask = "longtask", t2.timing = "timing", t2))($ || {});
model240dd8c3.CURRENT_SDK_VERSION = pt;
model240dd8c3.MetricEnum = $;
model240dd8c3.currentInLgContainer = M;
model240dd8c3.currentInNioCNAndroid = A;
model240dd8c3.getDeviceID = wt;
model240dd8c3.getEnv = ft;
model240dd8c3.getNioAppVersion = it;
model240dd8c3.getRuntime = ct;
model240dd8c3.getUserID = lt;
model240dd8c3.initAutoReportClickEventPlugin = tt;
model240dd8c3.initRuntime = rt;
(function(exports) {
  var vt = Object.defineProperty, yt = Object.defineProperties;
  var ht = Object.getOwnPropertyDescriptors;
  var H2 = Object.getOwnPropertySymbols;
  var mt = Object.prototype.hasOwnProperty, bt = Object.prototype.propertyIsEnumerable;
  var A2 = (t2, n, r) => n in t2 ? vt(t2, n, { enumerable: true, configurable: true, writable: true, value: r }) : t2[n] = r, j2 = (t2, n) => {
    for (var r in n || (n = {}))
      mt.call(n, r) && A2(t2, r, n[r]);
    if (H2)
      for (var r of H2(n))
        bt.call(n, r) && A2(t2, r, n[r]);
    return t2;
  }, P = (t2, n) => yt(t2, ht(n));
  var N = (t2, n, r) => (A2(t2, typeof n != "symbol" ? n + "" : n, r), r);
  Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
  const _ = model240dd8c3;
  var M2 = {}, $2;
  Object.defineProperty(M2, "__esModule", { value: true });
  var d = function() {
    return (d = Object.assign || function(t2) {
      for (var n, r = 1, e = arguments.length; r < e; r++)
        for (var i in n = arguments[r])
          Object.prototype.hasOwnProperty.call(n, i) && (t2[i] = n[i]);
      return t2;
    }).apply(this, arguments);
  };
  function _t(t2, n) {
    var r = {};
    for (i in t2)
      Object.prototype.hasOwnProperty.call(t2, i) && n.indexOf(i) < 0 && (r[i] = t2[i]);
    if (t2 != null && typeof Object.getOwnPropertySymbols == "function")
      for (var e = 0, i = Object.getOwnPropertySymbols(t2); e < i.length; e++)
        n.indexOf(i[e]) < 0 && Object.prototype.propertyIsEnumerable.call(t2, i[e]) && (r[i[e]] = t2[i[e]]);
    return r;
  }
  function p(t2, n) {
    var r = typeof Symbol == "function" && t2[Symbol.iterator];
    if (!r)
      return t2;
    var e, i, o = r.call(t2), u = [];
    try {
      for (; (n === void 0 || 0 < n--) && !(e = o.next()).done; )
        u.push(e.value);
    } catch (a) {
      i = { error: a };
    } finally {
      try {
        e && !e.done && (r = o.return) && r.call(o);
      } finally {
        if (i)
          throw i.error;
      }
    }
    return u;
  }
  function h(t2, n, r) {
    if (r || arguments.length === 2)
      for (var e, i = 0, o = n.length; i < o; i++)
        !e && i in n || ((e = e || Array.prototype.slice.call(n, 0, i))[i] = n[i]);
    return t2.concat(e || Array.prototype.slice.call(n));
  }
  var St = 10, Et = 1e3, tt2 = function(t2) {
    return JSON.stringify({ ev_type: "batch", list: t2 });
  };
  function wt2(u) {
    var n, r = u.transport, e = u.endpoint, i = u.size, o = i === void 0 ? St : i, u = u.wait, a = u === void 0 ? Et : u, l = [], s = 0;
    function f() {
      var g2;
      l.length && (g2 = this.getBatchData(), r.post({ url: e, data: g2, fail: function(v) {
        n && n(v, g2);
      } }), l = []);
    }
    return { getSize: function() {
      return o;
    }, getWait: function() {
      return a;
    }, setSize: function(g2) {
      o = g2;
    }, setWait: function(g2) {
      a = g2;
    }, getEndpoint: function() {
      return e;
    }, setEndpoint: function(g2) {
      e = g2;
    }, send: function(g2) {
      l.push(g2), l.length >= o && f.call(this), clearTimeout(s), s = setTimeout(f.bind(this), a);
    }, flush: function() {
      clearTimeout(s), f.call(this);
    }, getBatchData: function() {
      return l.length ? tt2(l) : "";
    }, clear: function() {
      clearTimeout(s), l = [];
    }, fail: function(g2) {
      n = g2;
    } };
  }
  var It = ["init", "start", "config", "beforeDestroy", "provide", "beforeReport", "report", "beforeBuild", "build", "beforeSend", "send", "beforeConfig"], m = function() {
    return {};
  };
  function b(t2) {
    return typeof t2 == "object" && t2 !== null;
  }
  var k = Object.prototype;
  function nt2(t2) {
    return b(t2) ? typeof Object.getPrototypeOf != "function" ? k.toString.call(t2) === "[object Object]" : (t2 = Object.getPrototypeOf(t2), t2 === k || t2 === null) : false;
  }
  function E(t2) {
    return k.toString.call(t2) === "[object Array]";
  }
  function T(t2) {
    return typeof t2 == "function";
  }
  function Ct(t2) {
    return typeof t2 == "number";
  }
  function Ot(t2) {
    return typeof t2 == "string";
  }
  function Tt(t2, n) {
    return Object.prototype.hasOwnProperty.call(t2, n);
  }
  function Dt() {
    for (var t2 = [], n = 0; n < arguments.length; n++)
      t2[n] = arguments[n];
    for (var r = {}, e = 0; e < t2.length; )
      r = U(r, t2[e++]);
    return r;
  }
  function U(t2, n) {
    var r, e = d({}, t2);
    for (r in n)
      Tt(n, r) && n[r] !== void 0 && (b(n[r]) && nt2(n[r]) ? e[r] = U(b(t2[r]) ? t2[r] : {}, n[r]) : E(n[r]) && E(t2[r]) ? e[r] = rt2(t2[r], n[r]) : e[r] = n[r]);
    return e;
  }
  function rt2(t2, n) {
    return t2 = E(t2) ? t2 : [], n = E(n) ? n : [], Array.prototype.concat.call(t2, n).map(function(r) {
      return r instanceof RegExp ? r : b(r) && nt2(r) ? U({}, r) : E(r) ? rt2([], r) : r;
    });
  }
  function et2(t2, n) {
    if (!E(t2) || t2.length === 0)
      return false;
    for (var r = 0; r < t2.length; ) {
      if (t2[r] === n)
        return true;
      r++;
    }
    return false;
  }
  var F = function(t2, n) {
    if (!E(t2))
      return t2;
    var r = t2.indexOf(n);
    return 0 <= r ? (n = t2.slice(), n.splice(r, 1), n) : t2;
  }, Rt = function(t2, n, r) {
    for (var e, n = p(n.split(".")), i = n[0], o = n.slice(1); t2 && 0 < o.length; )
      t2 = t2[i], i = (e = p(o))[0], o = e.slice(1);
    if (t2)
      return r(t2, i);
  }, xt = function(t2, n, r) {
    return Rt(t2, n, function(e, i) {
      if (e && i in e && T(e[i]))
        try {
          return e[i].apply(e, r);
        } catch (o) {
          return;
        }
    });
  };
  function X(t2) {
    try {
      return Ot(t2) ? t2 : JSON.stringify(t2);
    } catch (n) {
      return "[FAILED_TO_STRINGIFY]:" + String(n);
    }
  }
  var At = function(t2) {
    return b(t2) ? Object.keys(t2).reduce(function(n, r) {
      return n += "&" + r + "=" + t2[r];
    }, "").replace("&", "?") : "";
  };
  function jt() {
    var t2 = {}, n = {}, r = { set: function(e, i) {
      return t2[e] = i, n[e] = X(i), r;
    }, merge: function(e) {
      return t2 = d(d({}, t2), e), Object.keys(e).forEach(function(i) {
        n[i] = X(e[i]);
      }), r;
    }, delete: function(e) {
      return delete t2[e], delete n[e], r;
    }, clear: function() {
      return t2 = {}, n = {}, r;
    }, get: function(e) {
      return n[e];
    }, toString: function() {
      return d({}, n);
    } };
    return r;
  }
  var Pt = function(t2, n, r, e) {
    return e === void 0 && (e = true), function() {
      for (var i = [], o = 0; o < arguments.length; o++)
        i[o] = arguments[o];
      if (!t2)
        return m;
      var u = t2[n], a = r.apply(void 0, h([u], p(i), false)), l = a;
      return T(l) && e && (l = function() {
        for (var s = [], f = 0; f < arguments.length; f++)
          s[f] = arguments[f];
        try {
          return a.apply(this, s);
        } catch (g2) {
          return T(u) && u.apply(this, s);
        }
      }), t2[n] = l, function(s) {
        s || (l === t2[n] ? t2[n] = u : a = u);
      };
    };
  }, Nt = function() {
    return "".padStart ? function(t2, n) {
      return t2.padStart(n = n === void 0 ? 8 : n, " ");
    } : function(t2) {
      return t2;
    };
  }, it2 = Nt(), Mt = 0, kt = function() {
    for (var t2 = [], n = 0; n < arguments.length; n++)
      t2[n] = arguments[n];
    console.error.apply(console, h(["[SDK]", Date.now(), it2("" + Mt++)], p(t2), false));
  }, Bt = 0, J = function() {
    for (var t2 = [], n = 0; n < arguments.length; n++)
      t2[n] = arguments[n];
    console.warn.apply(console, h(["[SDK]", Date.now(), it2("" + Bt++)], p(t2), false));
  }, C = function(t2) {
    return function(n) {
      for (var r = n, e = 0; e < t2.length && r; e++)
        try {
          r = t2[e](r);
        } catch (i) {
          kt(i);
        }
      return r;
    };
  };
  function Lt() {
    for (var t2 = new Array(16), n = 0, r = 0; r < 16; r++)
      !(3 & r) && (n = 4294967296 * Math.random()), t2[r] = n >>> ((3 & r) << 3) & 255;
    return t2;
  }
  function Ut(t2) {
    for (var n = [], r = 0; r < 256; ++r)
      n[r] = (r + 256).toString(16).substr(1);
    var e = 0, i = n;
    return [i[t2[e++]], i[t2[e++]], i[t2[e++]], i[t2[e++]], "-", i[t2[e++]], i[t2[e++]], "-", i[t2[e++]], i[t2[e++]], "-", i[t2[e++]], i[t2[e++]], "-", i[t2[e++]], i[t2[e++]], i[t2[e++]], i[t2[e++]], i[t2[+e]], i[t2[15]]].join("");
  }
  function B() {
    var t2 = Lt();
    return t2[6] = 15 & t2[6] | 64, t2[8] = 63 & t2[8] | 128, Ut(t2);
  }
  var Ft = 3e5, zt = function(t2, n, r) {
    var e = 0;
    return r === -1 ? m : function() {
      if (t2())
        return e && clearTimeout(e), void (e = 0);
      e === 0 && (e = setTimeout(n, r));
    };
  }, ot2 = function(t2, n) {
    var r = [];
    try {
      r = n.reduce(function(e, i) {
        try {
          var o = i(t2);
          typeof o == "function" && e.push(o);
        } catch (u) {
        }
        return e;
      }, []);
    } catch (e) {
    }
    return function(e) {
      return ot2(e, r);
    };
  }, Gt = function(t2) {
    function n(a) {
      e = F(e, a), o || u();
    }
    var r, e = [], i = [], o = false, u = zt(function() {
      return !!e.length;
    }, function() {
      o = true, r && r[0](), i.forEach(function(a) {
        return a();
      }), i.length = 0, r = void 0;
    }, t2 = t2 === void 0 ? Ft : t2);
    return { next: function(a) {
      return ot2(a, e);
    }, complete: function(a) {
      i.push(a);
    }, attach: function(a, l) {
      r = [a, l];
    }, subscribe: function(a) {
      if (o)
        throw new Error("Observer is closed");
      return e.push(a), r && r[1] && r[1](a), u(), function() {
        return n(a);
      };
    }, unsubscribe: n };
  }, Kt = function(t2, n, r) {
    r = Gt(r);
    try {
      t2(r.next, r.attach), n && r.complete(n);
    } catch (e) {
    }
    return [r.subscribe, r.unsubscribe];
  };
  function Wt() {
    function t2(i) {
      i.length && i.forEach(function(o) {
        try {
          o();
        } catch (u) {
        }
      }), i.length = 0;
    }
    function n(i) {
      e[i] && e[i].forEach(function(o) {
        t2(o[1]);
      }), e[i] = void 0;
    }
    var r = false, e = {};
    return { set: function(i, o, u) {
      e[i] ? e[i].push([o, u]) : e[i] = [[o, u]], r && t2(u);
    }, has: function(i) {
      return !!e[i];
    }, remove: n, removeByEvType: function(i) {
      Object.keys(e).forEach(function(o) {
        e[o] && e[o].forEach(function(u) {
          u[0] === i && t2(u[1]);
        });
      });
    }, clear: function() {
      r = true, Object.keys(e).forEach(function(i) {
        n(i);
      });
    } };
  }
  function qt(t2) {
    var n, r, e = t2.builder, i = t2.createSender, o = t2.createDefaultConfig, u = t2.createConfigManager, a = t2.userConfigNormalizer, l = t2.initConfigNormalizer, s = t2.validateInitConfig, f = {};
    It.forEach(function(c2) {
      return f[c2] = [];
    });
    var g2 = false, v = false, K = false, I = [], q2 = [], W = Wt(), R = { getBuilder: function() {
      return e;
    }, getSender: function() {
      return n;
    }, getPreStartQueue: function() {
      return I;
    }, init: function(c2) {
      if (g2)
        J("already inited");
      else {
        if (!(c2 && b(c2) && s(c2)))
          throw new Error("invalid InitConfig, init failed");
        var y = o(c2);
        if (!y)
          throw new Error("defaultConfig missing");
        if (c2 = l(c2), (r = u(y)).setConfig(c2), r.onChange(function() {
          S("config");
        }), !(n = i(r.getConfig())))
          throw new Error("sender missing");
        S("init", g2 = true);
      }
    }, set: function(c2) {
      g2 && c2 && b(c2) && (S("beforeConfig", false, c2), r != null && r.setConfig(c2));
    }, config: function(c2) {
      if (g2)
        return c2 && b(c2) && (S("beforeConfig", false, c2), r != null && r.setConfig(a(c2))), r == null ? void 0 : r.getConfig();
    }, provide: function(c2, y) {
      et2(q2, c2) ? J("cannot provide " + c2 + ", reserved") : (R[c2] = y, S("provide", false, c2));
    }, start: function() {
      var c2 = this;
      g2 && (v || r != null && r.onReady(function() {
        S("start", v = true), I.forEach(function(y) {
          return c2.build(y);
        }), I.length = 0;
      }));
    }, report: function(c2) {
      c2 && (!(c2 = C(f.beforeReport)(c2)) || (c2 = C(f.report)(c2)) && (v ? this.build(c2) : I.push(c2)));
    }, build: function(c2) {
      !v || (c2 = C(f.beforeBuild)(c2)) && (!(c2 = e.build(c2)) || (c2 = C(f.build)(c2)) && this.send(c2));
    }, send: function(c2) {
      !v || (c2 = C(f.beforeSend)(c2)) && (n.send(c2), S("send", false, c2));
    }, destroy: function() {
      W.clear(), K = true, S("beforeDestroy", !(I.length = 0));
    }, on: function(c2, y) {
      if (c2 === "init" && g2 || c2 === "start" && v || c2 === "beforeDestroy" && K)
        try {
          y();
        } catch (x) {
        }
      else
        f[c2] && f[c2].push(y);
    }, off: function(c2, y) {
      f[c2] && (f[c2] = F(f[c2], y));
    }, destroyAgent: W }, q2 = Object.keys(R);
    return R;
    function S(c2, y) {
      y === void 0 && (y = false);
      for (var x = [], O = 2; O < arguments.length; O++)
        x[O - 2] = arguments[O];
      f[c2].forEach(function(pt2) {
        try {
          pt2.apply(void 0, h([], p(x), false));
        } catch (Kn) {
        }
      }), y && (f[c2].length = 0);
    }
  }
  var Ht = function(t2) {
    var n = jt();
    t2.provide("context", n), t2.on("report", function(r) {
      return r.extra || (r.extra = {}), r.extra.context = n.toString(), r;
    });
  }, Xt = function(t2, n, r) {
    function e() {
      for (var u = [], a = 0; a < arguments.length; a++)
        u[a] = arguments[a];
      if (f = u[0]) {
        var l = f.split(".")[0];
        if (l in e)
          return xt(e, f, [].slice.call(u, 1));
        var s = o[l] || [], f = (f = n == null ? void 0 : n(t2)) !== null && f !== void 0 ? f : {};
        s.push(h([f], p(u), false)), o[l] = s;
      }
    }
    var i, o = {};
    for (i in Pt(t2, "provide", function(u) {
      return function(a, l) {
        e[a] = l, u.call(t2, a, l);
      };
    })(), t2)
      Object.prototype.hasOwnProperty.call(t2, i) && (e[i] = t2[i]);
    return t2.on("provide", function(u) {
      o[u] && (o[u].forEach(function(l) {
        var s = p(l), l = s[0], s = s.slice(1);
        r != null && r(t2, l, s);
      }), o[u] = null);
    }), e;
  };
  function Jt(t2, n) {
    t2.on("init", function() {
      function r(o) {
        o.forEach(function(u) {
          var a = u.name;
          et2(e, a) || (e.push(a), u.setup(t2), n && n(a, u.setup), t2.destroyAgent.set(a, a, [function() {
            e = F(e, a), u.tearDown && u.tearDown();
          }]));
        });
      }
      var e = [];
      t2.provide("applyIntegrations", r);
      var i = t2.config();
      i && i.integrations && r(i.integrations);
    });
  }
  function Vt(t2, n) {
    var r = n || {};
    t2.provide("initSubject", function(o) {
      var o = p(o, 2), i = o[0], o = o[1];
      return r[i] || (r[i] = Kt(o, function() {
        r[i] = void 0;
      })), r[i];
    }), t2.provide("getSubject", function(e) {
      return r[e];
    }), t2.provide("privateSubject", {});
  }
  var D = function() {
    return Date.now();
  };
  function w() {
    if (typeof window == "object" && b(window))
      return window;
  }
  function Yt() {
    return w() && window.location;
  }
  function Qt() {
    if (typeof XMLHttpRequest == "function" && T(XMLHttpRequest))
      return XMLHttpRequest;
  }
  function Zt() {
    if (w() && "navigator" in window)
      return window.navigator;
  }
  function $t() {
    var t2 = Zt();
    if (t2)
      return t2.connection || t2.mozConnection || t2.webkitConnection;
  }
  function ut2() {
    var t2 = w() && Yt();
    return t2 == null ? void 0 : t2.href;
  }
  var at2 = function(t2) {
    if (t2)
      return t2.__SLARDAR_REGISTRY__ || (t2.__SLARDAR_REGISTRY__ = { Slardar: { plugins: [], errors: [], subject: {} } }), t2.__SLARDAR_REGISTRY__.Slardar;
  }, tn = function(t2) {
    var n = { url: ut2(), timestamp: D() }, r = t2.config();
    return r != null && r.pid && (n.pid = r.pid), t2 != null && t2.context && (n.context = t2.context.toString()), n;
  }, nn = function(t2, n) {
    return function(r) {
      function e(i) {
        return i.overrides = n, i;
      }
      t2.on("report", e), r(), t2.off("report", e);
    };
  }, rn = function(t2) {
    var n = false;
    return [function(r) {
      n || (n = true, t2 && t2(r));
    }];
  }, en = function(t2) {
    var n, r = w();
    r && (n = p(rn(t2), 1)[0], ["unload", "beforeunload", "pagehide"].forEach(function(e) {
      r.addEventListener(e, n);
    }));
  }, z2 = function() {
    return !!btoa && !!atob;
  };
  function on(t2) {
    return z2() ? btoa(encodeURI(t2)) : t2;
  }
  function un(t2) {
    return z2() ? decodeURI(atob(t2)) : t2;
  }
  var an = function(t2) {
    try {
      var n = localStorage.getItem(t2), r = n, e = r = n && typeof n == "string" ? JSON.parse(un(n)) : r, i = e.expires, o = _t(e, ["expires"]);
      return i >= D() ? o : void 0;
    } catch (u) {
      return;
    }
  }, ct2 = function(t2, n, r) {
    if (!(r <= 0))
      try {
        localStorage.setItem(t2, on(JSON.stringify(d(d({}, n), { expires: D() + r }))));
      } catch (e) {
      }
  }, cn = 7776e6, ft2 = function(t2) {
    return t2 === false ? 0 : t2 !== true && t2 !== void 0 && Ct(t2) ? t2 : cn;
  }, fn = function(t2) {
    return sn(t2, D());
  }, sn = function(t2, n) {
    return t2 + "_" + n;
  };
  function V(t2) {
    return (t2 == null ? void 0 : t2.effectiveType) || (t2 == null ? void 0 : t2.type) || "";
  }
  var ln = function(t2) {
    var n = $t(), r = V(n);
    n && (n.onchange = function() {
      r = V(n);
    }), t2.on("report", function(e) {
      return d(d({}, e), { extra: d(d({}, e.extra || {}), { network_type: r }) });
    });
  }, dn = function() {
    var t2 = w();
    return t2 && t2.navigator.sendBeacon ? { get: function() {
    }, post: function(n, r) {
      t2.navigator.sendBeacon(n, r);
    } } : { get: m, post: m };
  }, Y2 = function(t2, s, f) {
    var e = s.url, i = s.data, a = s.success, o = a === void 0 ? m : a, a = s.fail, u = a === void 0 ? m : a, a = s.getResponseText, l = a === void 0 ? m : a, s = s.withCredentials, s = s !== void 0 && s, f = new f();
    f.withCredentials = s, f.open(t2, e, true), f.setRequestHeader("Content-Type", "application/json"), f.onload = function() {
      l != null && l(this.responseText);
      try {
        var g2;
        this.responseText ? (g2 = JSON.parse(this.responseText), o(g2)) : o({});
      } catch (v) {
        u(v);
      }
    }, f.onerror = function() {
      u(new Error("Network request failed"));
    }, f.onabort = function() {
      u(new Error("Network request aborted"));
    }, f.send(i);
  }, gn = function() {
    var t2 = Qt();
    return t2 ? { get: function(n) {
      Y2("GET", n, t2);
    }, post: function(n) {
      Y2("POST", n, t2);
    } } : { get: m, post: m };
  };
  function pn(t2) {
    function n(i) {
      e.post(r.getEndpoint(), tt2([i]));
    }
    var r = wt2(t2), e = dn();
    return en(function() {
      var i = r.getBatchData();
      i && (e.post(r.getEndpoint(), i), r.clear()), r.send = n;
    }), r;
  }
  var vn = { build: function(t2) {
    return { ev_type: t2.ev_type, payload: t2.payload, common: d(d({}, t2.extra || {}), t2.overrides || {}) };
  } };
  function yn(t2) {
    var n, r = t2.plugins || {};
    for (n in r)
      r[n] && !b(r[n]) && (r[n] = {});
    return d(d({}, t2), { plugins: r });
  }
  function hn(t2) {
    return b(t2) && "aid" in t2;
  }
  function mn(t2) {
    return d({}, t2);
  }
  function bn(u) {
    if (!u)
      return {};
    var n = u.sample, r = u.timestamp, e = u.status, i = u.apdex;
    if (!n)
      return {};
    var o = n.sample_rate, u = n.sample_granularity;
    return { sample: { include_users: n.include_users, sample_rate: e && e === 4 ? 0 : o, sample_granularity: u, rules: n.rules.reduce(function(a, v) {
      var s = v.name, f = v.enable, g2 = v.sample_rate, v = v.conditional_sample_rules;
      return a[s] = { enable: f, sample_rate: g2, conditional_sample_rules: v }, a;
    }, {}) }, apdex: i, serverTimestamp: r };
  }
  var _n = "apmplus.volces.com", G = "2.4.0", Sn = "APM_PLUS_WEB", st2 = "/settings/get/webpro", lt2 = "/monitor_web/collect", En = "APMPLUS", Q2 = [lt2, st2, "/monitor_browser/collect"], wn = { sample_rate: 1, include_users: [], sample_granularity: "session", rules: {} }, In = 20, Cn = function(t2, n) {
    return n === void 0 && (n = lt2), (t2 && 0 <= t2.indexOf("//") ? "" : "https://") + t2 + n;
  }, On = function(t2, n) {
    return n === void 0 && (n = st2), (t2 && 0 <= t2.indexOf("//") ? "" : "https://") + t2 + n;
  }, Tn = function() {
    return B();
  }, dt2 = function(t2) {
    return En + t2;
  }, Dn = function(t2, n) {
    var r = localStorage.getItem(t2);
    if (r && z2() && r[0] === "{")
      try {
        ct2(t2, JSON.parse(r), n);
      } catch (e) {
      }
  }, Rn = function(t2, n) {
    t2 === void 0 && (t2 = 0);
    var r = { userId: B(), deviceId: B(), r: Math.random() };
    return n <= 0 ? r : (t2 = dt2(t2), Dn(t2, n), an(t2) || r);
  }, xn = function(i) {
    var o = i.aid, n = i.userId, r = i.deviceId, e = i.sample, i = i.storageExpires, o = dt2(o);
    ct2(o, { userId: n, deviceId: r, r: e.r }, ft2(i));
  }, An = function(t2) {
    var n, r, e, i = t2, o = {}, u = m, a = m;
    return { getConfig: function() {
      return i;
    }, setConfig: function(f) {
      return o = d(d({}, o), f || {}), l(), n || (n = f, i.useLocalConfig ? (e = {}, u()) : r ? s() : jn(i.transport, i.domain, i.aid, function(g2) {
        r = g2, s();
      })), i;
    }, onChange: function(f) {
      a = f;
    }, onReady: function(f) {
      u = function() {
        (function() {
          t2.userId !== i.userId && (t2.sample.r = Math.random(), l()), xn(i);
        })(), f();
      }, e && u();
    } };
    function l() {
      var f = d(d(d({}, t2), e || {}), o);
      f.plugins = Dt(t2.plugins, (e == null ? void 0 : e.plugins) || {}, o.plugins || {}), f.sample = Z2(Z2(t2.sample, e == null ? void 0 : e.sample), o.sample), i = f, a();
    }
    function s() {
      e = bn(r), l(), u();
    }
  };
  function jn(t2, n, r, e) {
    t2.get({ withCredentials: true, url: On(n) + "?aid=" + r, success: function(i) {
      e(i.data || {});
    }, fail: function() {
      e();
    } });
  }
  function Z2(t2, n) {
    if (!t2 || !n)
      return t2 || n;
    var r = d(d({}, t2), n);
    return r.include_users = h(h([], p(t2.include_users || []), false), p(n.include_users || []), false), r.rules = h(h([], p(Object.keys(t2.rules || {})), false), p(Object.keys(n.rules || {})), false).reduce(function(e, i) {
      var o;
      return i in e || (i in (t2.rules || {}) && i in (n.rules || {}) ? (e[i] = d(d({}, t2.rules[i]), n.rules[i]), e[i].conditional_sample_rules = h(h([], p(t2.rules[i].conditional_sample_rules || []), false), p(n.rules[i].conditional_sample_rules || []), false)) : e[i] = ((o = t2.rules) === null || o === void 0 ? void 0 : o[i]) || ((o = n.rules) === null || o === void 0 ? void 0 : o[i])), e;
    }, {}), r;
  }
  function Pn(t2, n) {
    return t2.plugins.filter(function(r) {
      return r.name === n && r.version === G;
    })[0];
  }
  function Nn(t2, n, r) {
    (r = r === void 0 ? at2(w()) : r) && r.plugins && (Pn(r, t2) || r.plugins.push({ name: t2, version: G, apply: n }));
  }
  var Mn = function(t2) {
    var n = { url: ut2(), timestamp: Date.now() };
    return d(d({}, t2), { extra: d(d({}, n), t2.extra || {}) });
  }, kn = function(t2) {
    t2.on("report", function(n) {
      return Mn(n);
    });
  }, Bn = 700, Ln = function(t2) {
    var n, r = false;
    t2.on("init", function() {
      n = (/* @__PURE__ */ new Date()).getTime(), t2.on("config", function() {
        var e, i = (e = t2.config()) === null || e === void 0 ? void 0 : e.serverTimestamp;
        isNaN(i) || Number(i) <= 0 || r || (r = true, (e = (/* @__PURE__ */ new Date()).getTime()) - n < Bn && i && (e = i - (e + n) / 2, !isNaN(e) && (0 < e || e < -6e5) && t2.set({ offset: e })));
      });
    });
  }, Un = function(t2, n) {
    var r = {};
    return r.aid = n.aid, r.pid = n.pid, r.view_id = n.viewId, r.user_id = n.userId, d(d({}, t2), { extra: d(d({}, r), t2.extra || {}) });
  }, Fn = function(t2) {
    t2.on("beforeBuild", function(n) {
      return Un(n, t2.config());
    });
  }, zn = function(t2) {
    t2.on("start", function() {
      var a = t2.config(), n = a.deviceId, r = a.sessionId, e = a.release, i = a.env, o = a.offset, u = a.aid, a = a.token, u = { did: n, sid: r, release: e, env: i, sname: Sn, sversion: G, soffset: o || 0, biz_id: u, x_auth_token: a }, a = t2.getSender();
      a.setEndpoint(a.getEndpoint() + At(u));
    });
  }, gt2 = function(r) {
    var n = ft2(r.storageExpires), r = Rn(r.aid, n);
    return { aid: 0, pid: "", token: "", viewId: fn("_"), userId: r.userId, deviceId: r.deviceId, sessionId: Tn(), storageExpires: n, domain: _n, plugins: { ajax: { ignoreUrls: Q2 }, fetch: { ignoreUrls: Q2 }, breadcrumb: {}, pageview: {}, jsError: {}, resource: {}, resourceError: {}, performance: {}, tti: {}, fmp: {}, blankScreen: false }, release: "", env: "production", sample: d(d({}, wn), { r: r.r }), transport: gn() };
  }, Gn = function(r) {
    var e = r === void 0 ? {} : r, n = e.createSender, r = e.builder, e = e.createDefaultConfig, i = qt({ validateInitConfig: hn, initConfigNormalizer: yn, userConfigNormalizer: mn, createSender: n === void 0 ? function(o) {
      return pn({ size: In, endpoint: Cn(o.domain), transport: o.transport });
    } : n, builder: r === void 0 ? vn : r, createDefaultConfig: e === void 0 ? gt2 : e, createConfigManager: An });
    return Ht(i), e = at2(w()), Vt(i, e && e.subject), Ln(i), Fn(i), kn(i), ln(i), zn(i), e = Xt(i, tn, function(o, u, a) {
      return nn(o, u)(function() {
        var s = p(a), l = s[0], s = s.slice(1);
        i[l].apply(i, h([], p(s), false));
      });
    }), Jt(e, Nn), e;
  };
  $2 = M2.createMinimalBrowserClient = Gn, M2.getDefaultConfig = gt2;
  class L {
    static createInstance(n) {
      try {
        if (typeof window == "undefined")
          return null;
        if (n.region !== "cn")
          return console.warn(`[${this.SDK_NAME}] cannot be used in non-CN regions`), null;
        _.initRuntime(), this.instance = $2();
        const r = { aid: n.aid, token: n.token, domain: "apmplus.nio.com", env: n.env || _.getEnv() };
        n.release && (r.release = n.release);
        const e = n.deviceId || _.getDeviceID();
        e && (r.deviceId = e);
        const i = n.userId || _.getUserID();
        return i && (r.userId = i), this.instance("context.set", "nio_runtime", _.getRuntime()), this.instance("context.set", "nio_app_version", _.getNioAppVersion()), this.instance("context.set", "nio_apm_plus_version", _.CURRENT_SDK_VERSION), Array.isArray(n == null ? void 0 : n.context) && n.context.forEach((o) => {
          var u, a;
          o != null && o.key && ((a = this.instance) == null || a.call(this, "context.set", o.key, (u = o == null ? void 0 : o.value) != null ? u : ""));
        }), this.instance.init(r), _.initAutoReportClickEventPlugin(this.instance, "minimal", n == null ? void 0 : n.autoReportClickEvent), this.instance.start(), this.instance;
      } catch (r) {
        return console.error(`[${this.SDK_NAME}] create instance failed, error: `, r), null;
      }
    }
    static getInstance() {
      return this.instance;
    }
    static sendEvent(n) {
      var r, e;
      (e = (r = this.instance) == null ? void 0 : r.report) == null || e.call(r, { ev_type: "custom", payload: P(j2({}, n), { type: "event" }) });
    }
    static sendLog(n) {
      var r, e;
      (e = (r = this.instance) == null ? void 0 : r.report) == null || e.call(r, { ev_type: "custom", payload: P(j2({}, n), { type: "log" }) });
    }
    static setContext(n, r) {
      var e;
      (e = this.instance) == null || e.call(this, "context.set", n, r);
    }
  }
  N(L, "SDK_NAME", "NIO APM Plus Minimal"), N(L, "instance", null);
  exports.MetricEnum = _.MetricEnum;
  exports.NioApmPlusMinimal = L;
})(minimal$1);
const minimal = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null
}, [minimal$1]);
const APM_EVENT_NAME$1 = "native-bridge-invoke";
function sendEvent$1(categories, name = APM_EVENT_NAME$1) {
  if (typeof window === "undefined")
    return;
  if (window.lastUniversalBridge === categories.name)
    return;
  try {
    if (!minimal$1.NioApmPlusMinimal.getInstance()) {
      minimal$1.NioApmPlusMinimal.createInstance({
        region: "cn",
        aid: 1108356211,
        token: "25ab507a9a0741ea89547547dffbb4f9",
        release: version
      });
    }
    minimal$1.NioApmPlusMinimal.sendEvent({
      name,
      categories
    });
  } catch (e) {
    console.log("apm error:", e);
  }
}
function getDsBridge() {
  return window["dsBridge"];
}
function currentInNioCNApp$1() {
  return currentInNioCNiOS() || currentInNioCNAndroid();
}
function showToast$1(context = {}) {
  if (isString(context)) {
    context = { data: { content: context } };
  }
  const { data = {} } = context;
  const { content = "" } = data;
  getDsBridge().call("showToast", content);
  sendEvent$1({
    name: "showToast",
    context: JSON.stringify(context)
  });
}
function showLoading$1(context = {}) {
  if (!context) {
    context = "";
  }
  if (isObject(context)) {
    checker(context);
  }
  getDsBridge().call("showLoading", isString(context) ? context : context.data.content);
  sendEvent$1({
    name: "showLoading",
    context: JSON.stringify(context)
  });
}
function hideLoading$1() {
  getDsBridge().call("hideLoading", "");
  sendEvent$1({
    name: "hideLoading",
    context: JSON.stringify({})
  });
}
function closeKeyboard$1() {
  getDsBridge().call("closeKeyboard", "");
  sendEvent$1({
    name: "closeKeyboard",
    context: JSON.stringify({})
  });
}
function makeCall$1(context = {}) {
  if (isObject(context)) {
    checker(context);
  }
  const telNumber = isString(context) ? context : context.data.tel;
  getDsBridge().call("makeCall", telNumber);
  sendEvent$1({
    name: "makeCall",
    // todo: [answer] 号码隐私处理
    context: JSON.stringify({})
  });
}
function setCopyText$1(context = {}) {
  if (isObject(context)) {
    checker(context);
  }
  sendEvent$1({
    name: "setCopyText",
    context: JSON.stringify({})
  });
  return getDsBridge().call("setCopyText", isString(context) ? context : context.data.content);
}
function pullRefresh$1(context = {}) {
  if (isObject(context)) {
    checker(context);
  }
  let param;
  if (context === "0" || context === "1" || context === 0 || context === 1) {
    param = context;
  } else {
    param = context.data.type;
  }
  param = param.toString();
  getDsBridge().call("isShowPullRefresh", param);
  sendEvent$1({
    name: "pullRefresh",
    context: JSON.stringify({})
  });
}
function getAppInfo$1() {
  sendEvent$1({
    name: "getAppInfo",
    context: JSON.stringify({})
  });
  return getDsBridge().call("getAppInfo", "");
}
function getUserInfo$1(context = {}) {
  var _a, _b, _c, _d;
  sendEvent$1({
    name: "getUserInfo",
    context: JSON.stringify(context)
  });
  const info = getDsBridge().call("getUserInfo", context);
  const { result_code, data = {} } = info;
  if (result_code !== BRIDGE_CONSTANT.RESULT_CODE.SUCCESS) {
    return info;
  }
  if (!data.access_token) {
    return info;
  }
  if (info.result_code === BRIDGE_CONSTANT.RESULT_CODE.SUCCESS) {
    const accountId = info.data.accountId || info.data.account_id;
    info.data.accountId = accountId;
    info.data.account_id = accountId;
    info.data.avatar = info.data.avatar || "";
    if (!info.data.displayLanguage) {
      info.data.displayLanguage = "";
    }
    const { mobile } = info.data;
    if (typeof mobile === "string")
      ;
    else {
      ["callingCode", "calling_code", "mobile"].forEach((item) => {
        info.data.mobile[item] = info.data.mobile[item] || "";
      });
      const callingCode = ((_b = (_a = info.data) == null ? void 0 : _a.mobile) == null ? void 0 : _b.calling_code) || ((_d = (_c = info.data) == null ? void 0 : _c.mobile) == null ? void 0 : _d.callingCode);
      info.data.mobile.callingCode = callingCode;
      info.data.mobile.calling_code = callingCode;
    }
    if (currentInNioCNAndroid()) {
      const { account_name } = info.data;
      info.data.nick_name = account_name;
      info.data.nickName = account_name;
    }
    if (!info.data.countryCode) {
      info.data.countryCode = "";
    }
  }
  return info;
}
function _getUserInfoV2(context = {}) {
  const info = getUserInfo$1(context);
  const { result_code, data = {} } = info;
  if (result_code !== BRIDGE_CONSTANT.RESULT_CODE.SUCCESS) {
    return info;
  }
  if (!data.access_token) {
    return info;
  }
  const { mobile } = info.data;
  if (typeof mobile === "string") {
    info.data.mobile = {
      mobile,
      callingCode: "",
      calling_code: ""
    };
  }
  return info;
}
function getUserInfoForTitan$1(context = {}) {
  const { data } = context;
  const result = getDsBridge().call("getUserInfo", data);
  const { result_code = "" } = result;
  if (result_code === BRIDGE_CONSTANT.RESULT_CODE.SUCCESS)
    ;
  sendEvent$1({
    name: "getUserInfoForTitan",
    context: JSON.stringify(context)
  });
  return result;
}
function toLoginForTitan$1(context = {}) {
  const { data } = context;
  const result = getDsBridge().call("toLogin", data);
  const { result_code = "" } = result;
  if (result_code === BRIDGE_CONSTANT.RESULT_CODE.SUCCESS)
    ;
  sendEvent$1({
    name: "toLoginForTitan",
    context: JSON.stringify(context)
  });
  return result;
}
function getOSInfo$1() {
  sendEvent$1({
    name: "getOSInfo",
    context: JSON.stringify({})
  });
  return getDsBridge().call("getOSInfo", "");
}
function getVehicleInfo$1(context = {}) {
  getDsBridge().call("getVehicleInfo", "", (result) => {
    if (isFunction(context.callback)) {
      context.callback(result);
    }
  });
  sendEvent$1({
    name: "getVehicleInfo",
    context: JSON.stringify(context)
  });
}
function getModuleInfo$1() {
  sendEvent$1({
    name: "getModuleInfo",
    context: JSON.stringify({})
  });
  return getDsBridge().call("getModuleInfo", "");
}
function getDebugInfo$1() {
  sendEvent$1({
    name: "getDebugInfo",
    context: JSON.stringify({})
  });
  return getDsBridge().call("getH5DebugInfo", "");
}
function getNotificationSettings$1(context = {}) {
  sendEvent$1({
    name: "getNotificationSettings",
    context: JSON.stringify(context)
  });
  if (isObject(context)) {
    checker(context);
  } else {
    throw new Error("context need Object like {callback:function(){ } }");
  }
  return getDsBridge().call("isNotificationEnabled", "", (result) => {
    if (isFunction(context.callback)) {
      context.callback(result);
    }
  });
}
function getLocation$1(context = {}) {
  sendEvent$1({
    name: "getLocation",
    context: JSON.stringify(context)
  });
  checker(context);
  let locType;
  if (context.data.type) {
    locType = context.data.type;
  } else {
    if (currentInNioCNApp$1()) {
      locType = BRIDGE_CONSTANT.LOCATION.GCJ_02;
    } else {
      locType = BRIDGE_CONSTANT.LOCATION.WGS_84;
    }
  }
  return getDsBridge().call("getLocation", { type: locType }, (result) => {
    if (result.result_code === BRIDGE_CONSTANT.RESULT_CODE.SUCCESS) {
      let type;
      if (hop(result.data, "type"))
        ;
      else {
        if (currentInNioCNApp$1()) {
          if (currentInNioCNiOS()) {
            type = BRIDGE_CONSTANT.LOCATION.WGS_84;
          } else if (currentInNioCNAndroid()) {
            type = BRIDGE_CONSTANT.LOCATION.GCJ_02;
          } else {
            throw new Error("error info: unknown system");
          }
        } else {
          type = BRIDGE_CONSTANT.LOCATION.WGS_84;
        }
        result.data.type = type;
      }
    }
    context.callback(result);
  });
}
function openNotificationSetting$1() {
  sendEvent$1({
    name: "openNotificationSetting",
    context: JSON.stringify({})
  });
  getDsBridge().call("goToSetNotification", "");
}
function iosAllowsBackForwardNavigationGestures$1() {
  sendEvent$1({
    name: "iosAllowsBackForwardNavigationGestures",
    context: JSON.stringify({})
  });
  getDsBridge().call("allowsBackForwardNavigationGestures", "");
}
function openMap$1(context = {}) {
  sendEvent$1({
    name: "openMap",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("openMap", context.data);
}
function iosDisableBackForwardNavigationGestures$1() {
  sendEvent$1({
    name: "iosDisableBackForwardNavigationGestures",
    context: JSON.stringify({})
  });
  getDsBridge().call("disableBackForwardNavigationGestures", "");
}
function iosDisableIOSSystemKeyboardObserver$1() {
  sendEvent$1({
    name: "iosDisableIOSSystemKeyboardObserver",
    context: JSON.stringify({})
  });
  getDsBridge().call("disableSystemKeyboardObserver", "");
}
function openPDF$1(context = {}) {
  sendEvent$1({
    name: "openPDF",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("openPdf", isString(context) ? context : context.data.url, (result) => {
    if (isFunction(context.callback)) {
      context.callback(result);
    }
  });
}
function showCountries$1(context = {}) {
  sendEvent$1({
    name: "showCountries",
    context: JSON.stringify(context)
  });
  checker(context);
  const url = `nioapp://user/countries${context.data.content ? "?callingCode=" + context.data.content : ""}`;
  openURL$1({
    data: { url },
    callback(res) {
      if (isFunction(context.callback)) {
        context.callback(res);
      }
    }
  });
}
function downloadVideo$1(context = {}) {
  sendEvent$1({
    name: "downloadVideo",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("videoDownload", context.data, (result) => {
    context.callback && context.callback(result);
  });
}
function imagePicker$1(context = {}) {
  sendEvent$1({
    name: "imagePicker",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("imagePicker", context.data, (result) => {
    context.callback(result);
  });
}
function selectImage$1(context = {}) {
  sendEvent$1({
    name: "selectImage",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("selectImage", context.data, (result) => {
    console.log("selectImage:", result);
    context.callback(result);
  });
}
function saveImage$1(context = {}) {
  sendEvent$1({
    name: "saveImage",
    context: JSON.stringify(context)
  });
  checker(context);
  let img_data = isArray(context) ? context : context.data;
  getDsBridge().call("savePhotosAlbum", img_data, (result) => {
    if (result.result_code === BRIDGE_CONSTANT.RESULT_CODE.SUCCESS)
      ;
    context.callback && context.callback(result);
  });
}
function previewPhoto$1(context = {}) {
  sendEvent$1({
    name: "previewPhoto",
    context: JSON.stringify(context)
  });
  checker(context);
  const {
    callback = () => {
    }
  } = context;
  getDsBridge().call("previewPhoto", context.data, callback);
}
function scanQR$1(context = {}) {
  sendEvent$1({
    name: "scanQR",
    context: JSON.stringify(context)
  });
  checker(context);
  let url = "";
  const protocol = getAppUriScheme();
  const { data = {} } = context;
  const { autoJump = true } = data;
  if (currentInNioCNiOS()) {
    url = `${protocol}://scan/qrcodescanner?autoJump=${autoJump}`;
  } else if (currentInNioEUiOS()) {
    url = `${protocol}://scan/qrcode`;
  } else if (currentInNioCNAndroid()) {
    url = `${protocol}://scan`;
  } else if (currentInNioEUAndroid()) {
    url = `${protocol}://scan/qrcode`;
  }
  openURL$1({
    data: { url },
    callback(res) {
      context.callback(res);
    }
  });
}
function close$1() {
  sendEvent$1({
    name: "close",
    context: JSON.stringify({})
  });
  getDsBridge().call("close", "");
}
function setHeaderOption$1(context = {}) {
  sendEvent$1({
    name: "setHeaderOption",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("headerSetOption", context.data);
}
function openLoginPage$1(context = {}) {
  sendEvent$1({
    name: "openLoginPage",
    context: JSON.stringify(context)
  });
  const url = currentInNioCNApp$1() ? `nio://user/login` : `nioapp://user/requirelogin`;
  openURL$1({
    data: { url },
    callback(res) {
      context.callback(res);
    }
  });
}
function openURL$1(context = {}) {
  sendEvent$1({
    name: "openURL",
    context: JSON.stringify(context)
  });
  if (isObject(context)) {
    checker(context);
  }
  let url = isString(context) ? context : context.data.url;
  getDsBridge().call("openURL", url, (result) => {
    if (isFunction(context.callback)) {
      context.callback(result);
    }
  });
}
function replace$1(context = {}) {
  sendEvent$1({
    name: "replace",
    context: JSON.stringify(context)
  });
  const { data = {} } = getDsBridge().call("getOSInfo", "");
  const { systemName = "" } = data;
  let url = isString(context) ? context : context.data.url;
  if (systemName.toLowerCase() === BRIDGE_CONSTANT.OS.ANDROID) {
    close$1();
    openURL$1({
      data: { url },
      callback(res) {
        context.callback(res);
      }
    });
  } else {
    getDsBridge().call("replacePage", url, (result) => {
      if (isFunction(context.callback)) {
        context.callback(result);
      }
    });
  }
}
function setPageIdentifier$1(context = {}) {
  sendEvent$1({
    name: "setPageIdentifier",
    context: JSON.stringify(context)
  });
  getDsBridge().call("setIdentifier", isString(context) ? context : context.data.id);
}
function back$1(context = {}) {
  sendEvent$1({
    name: "back",
    context: JSON.stringify(context)
  });
  if (isObject(context)) {
    checker(context);
  }
  if (isNumber(context) || isObject(context) && context.data.step) {
    let step = isInteger(context) ? context : context.data.step;
    if (!(isNumber(step) && isInteger(step) && step > 0)) {
      throw new Error("if context is integer need gt 0");
    }
    getDsBridge().call("goBack", step.toString());
  }
  if (isString(context) || isObject(context) && context.data.name) {
    let pageName = isString(context) ? context : context.data.name;
    getDsBridge().call("goBackTo", pageName);
  }
}
function pay$1(context = {}) {
  sendEvent$1({
    name: "pay",
    context: JSON.stringify(context)
  });
  checker(context);
  let url = "";
  if (currentInNioCNApp$1()) {
    url = `nio://pay/paylist?merchant_no=${context.data.merchantNo}&pay_order_no=${context.data.payOrderNo}`;
  } else {
    url = `nioapp://pay/paylist?merchantNo=${context.data.merchantNo}&payOrderNo=${context.data.payOrderNo}`;
  }
  openURL$1({
    data: { url },
    callback(res) {
      context.callback(res);
    }
  });
}
function share$1(context = {}) {
  sendEvent$1({
    name: "share",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("share", context.data, function(result) {
    context.callback(result);
  });
}
function share2$1(context = {}) {
  sendEvent$1({
    name: "share2",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("share2", context.data, function(result) {
    context.callback(result);
  });
}
function shareImage$1(context = {}) {
  sendEvent$1({
    name: "shareImage",
    context: JSON.stringify(context)
  });
  return new Promise((resolve) => {
    checker(context);
    const { url, type } = context.data;
    getDsBridge().call("share", {
      imgUrl: url,
      type
    }, function(result) {
      resolve(result);
    });
  });
}
function openExternalBrowser$1(context = {}) {
  sendEvent$1({
    name: "openExternalBrowser",
    context: JSON.stringify(context)
  });
  if (!context) {
    throw new Error("param context is required .....");
  }
  if (isObject(context)) {
    checker(context);
  }
  getDsBridge().call("openExternalBrowser", isString(context) ? context : context.data.url);
}
function openNioInputEdit$1(context = {}) {
  sendEvent$1({
    name: "openNioInputEdit",
    context: JSON.stringify(context)
  });
  let param = {};
  if (context === void 0) {
    param.content = "";
  } else if (isString(context)) {
    param.content = context;
  } else if (isObject(context)) {
    param = context.data;
  }
  getDsBridge().call("showInputEdit", param, function(result) {
    if (isObject(context) && isFunction(context.callback)) {
      context.callback(result);
    }
  });
}
function openNioInputEdit2$1(context = {}) {
  sendEvent$1({
    name: "openNioInputEdit2",
    context: JSON.stringify(context)
  });
  let param = context.data || {};
  getDsBridge().call("showInputEdit2", param, function(result) {
    if (isObject(context) && isFunction(context.callback)) {
      context.callback(result);
    }
  });
}
function postUGC$1(context = {}) {
  sendEvent$1({
    name: "postUGC",
    context: JSON.stringify(context)
  });
  checker(context);
  getDsBridge().call("postUGC", context.data, function(result) {
    context.callback(result);
  });
}
function report$1(context = {}) {
  sendEvent$1({
    name: "report",
    context: JSON.stringify(context)
  });
  checker(context);
  const {
    data: {
      resource_id,
      resource_type,
      nick_name,
      content
    } = {}
  } = context;
  const url = `nioapp://feed/report?resource_id=${resource_id}&resource_type=${resource_type}${resource_type === "comment" ? `&content=${content}` : `&nick_name=${nick_name}`}`;
  openURL$1({
    data: { url },
    callback(res) {
      context.callback(res);
    }
  });
}
function postNotificationFromHtmlToNative$1(context = {}) {
  sendEvent$1({
    name: "postNotificationFromHtmlToNative",
    context: JSON.stringify(context)
  });
  if (isObject(context)) {
    checker(context);
  } else {
    throw new Error("params need Object like this  {  data:{key: 'KtNotificationName',data: { subKey: 'value' } } }");
  }
  getDsBridge().call("postNotificationFromHtmlToNative", context.data);
}
function iosToggleBounch(context = {}) {
  sendEvent$1({
    name: "iosToggleBounch",
    context: JSON.stringify(context)
  });
  checker(context);
  let { data = {} } = getDsBridge().call("getOSInfo", "");
  let { systemName = "" } = data;
  if (systemName.toLowerCase() === BRIDGE_CONSTANT.OS.IOS) {
    getDsBridge().call("toggleBounces", isBoolean() ? context : context.data.enable);
  }
}
function getCurrencyFormat$1(context = {}) {
  sendEvent$1({
    name: "getCurrencyFormat",
    context: JSON.stringify(context)
  });
  checker(context);
  return getDsBridge().call("getCurrencyFormat", context.data);
}
function getNumberFormat$1(context = {}) {
  sendEvent$1({
    name: "getNumberFormat",
    context: JSON.stringify(context)
  });
  checker(context);
  return getDsBridge().call("getNumberFormat", context.data);
}
function register$1(context = {}) {
  sendEvent$1({
    name: "register",
    context: JSON.stringify(context)
  });
  checker(context);
  if (isObject(context.data)) {
    let info = {};
    let { data = {} } = getDsBridge().call("getOSInfo", "");
    let { systemName = "" } = data;
    if (systemName.toLowerCase() === BRIDGE_CONSTANT.OS.ANDROID) {
      try {
        info = getDsBridge().call("getCurrentPageInfo", "")["data"];
      } catch (ex) {
        console.error(ex);
      }
      storage.set({
        data: {
          key: info.objectId + "_" + context.event,
          value: context.data
        }
      });
    }
  }
  getDsBridge().register(context.event, (result) => {
    context.callback(result);
  });
  return true;
}
function requestReward$1(context = {}) {
  sendEvent$1({
    name: "requestReward",
    context: JSON.stringify(context)
  });
  const data = context && context.data ? context.data : context;
  return new Promise((resolve) => {
    getDsBridge().call("requestReward", data, (responseData) => {
      resolve({
        type: "success",
        result: responseData
      });
    });
  });
}
function imageLongPress$1(context = {}) {
  sendEvent$1({
    name: "imageLongPress",
    context: JSON.stringify(context)
  });
  const data = context && context.data ? context.data : context;
  getDsBridge().call("imageLongPress", data);
}
function translate$1(context = {}) {
  sendEvent$1({
    name: "translate",
    context: JSON.stringify(context)
  });
  getDsBridge().call("translate", context.data, (result) => {
    context.callback(result);
  });
}
function setBackActionEnable$1(context = {}) {
  sendEvent$1({
    name: "setBackActionEnable",
    context: JSON.stringify(context)
  });
  getDsBridge().call("setBackActionEnable", context.data);
}
function getScrambleId$1(context = {}) {
  sendEvent$1({
    name: "getScrambleId",
    context: JSON.stringify(context)
  });
  return getDsBridge().call("getScrambleId", context.data);
}
function notificationAuthorizationStatus$1(context = {}) {
  sendEvent$1({
    name: "notificationAuthorizationStatus",
    context: JSON.stringify(context)
  });
  getDsBridge().call("notificationAuthorizationStatus", context.data, (result) => {
    context.callback(result);
  });
}
function openAppSetting$1(context = {}) {
  sendEvent$1({
    name: "openAppSetting",
    context: JSON.stringify(context)
  });
  getDsBridge().call("openAppSetting", context.data);
}
function getInvoiceDetail$1(context = {}) {
  sendEvent$1({
    name: "getInvoiceDetail",
    context: JSON.stringify(context)
  });
  getDsBridge().call("invoiceDetail", context.data, (result) => {
    context.callback(result);
  });
}
function addCalendarEvent$1(context = {}) {
  sendEvent$1({
    name: "addCalendarEvent",
    context: JSON.stringify(context)
  });
  getDsBridge().call("addCalendarEvent", context.data, (result) => {
    context.callback(result);
  });
}
function touchSlopAndroid$1(context = {}) {
  sendEvent$1({
    name: "touchSlopAndroid",
    context: JSON.stringify(context)
  });
  return getDsBridge().call("touchSlop", context.data);
}
function requestEventAndroid$1(context = {}) {
  sendEvent$1({
    name: "requestEventAndroid",
    context: JSON.stringify(context)
  });
  return getDsBridge().call("requestEvent", context.data);
}
function sendPOI$1(context = {}) {
  sendEvent$1({
    name: "sendPOI",
    context: JSON.stringify(context)
  });
  getDsBridge().call("sendPOI", context.data, (result) => {
    context && context.callback(result);
  });
}
function switchBackActionControl$1(context = {}) {
  sendEvent$1({
    name: "switchBackActionControl",
    context: JSON.stringify(context)
  });
  const { data = {} } = context;
  const { status = "0" } = data;
  getDsBridge().call("common.controlBackSyn", status, (result) => {
    context && context.callback(result);
  });
}
function changeStatusBarStyle$1(context = {}) {
  sendEvent$1({
    name: "changeStatusBarStyle",
    context: JSON.stringify(context)
  });
  return getDsBridge().call("changeStatusBarStyle", context.data);
}
function applyJoinGroup$1(context = {}) {
  sendEvent$1({
    name: "applyJoinGroup",
    context: JSON.stringify(context)
  });
  return getDsBridge().call("applyJoinGroup", context.data, (result) => {
    context.callback && context.callback(result);
  });
}
function invokeAnonymousBridge$1(context = {}) {
  sendEvent$1({
    name: "invokeAnonymousBridge",
    context: JSON.stringify(context)
  });
  return getDsBridge().call(context.name, context.data);
}
const APM_EVENT_NAME = "universal-bridge-invoke";
let mockData = {};
async function sendEvent(categories, name = APM_EVENT_NAME) {
  if (typeof window === "undefined")
    return;
  window.lastUniversalBridge = categories.name;
  try {
    const { NioApmPlusMinimal } = await Promise.resolve().then(() => minimal);
    if (!NioApmPlusMinimal.getInstance()) {
      NioApmPlusMinimal.createInstance({
        region: "cn",
        aid: 1108356211,
        token: "25ab507a9a0741ea89547547dffbb4f9",
        release: version
      });
    }
    NioApmPlusMinimal.sendEvent({
      name,
      categories
    });
  } catch (e) {
    console.log("apm error:", e);
  }
}
function getUserInfo(context = {}) {
  sendEvent({
    name: "getUserInfo",
    context: JSON.stringify(context)
  }).then();
  const { data = {} } = context;
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getUserInfo"]) {
      return Promise.resolve(window["mockData"]["getUserInfo"]);
    }
    if (mockData && mockData["getUserInfo"]) {
      return Promise.resolve(mockData["getUserInfo"]);
    }
    return Promise.resolve(mockJsbridgeForType("UserInfoResult"));
  } else if (currentInLiveContainer()) {
    return getUserInfo$3(context);
  } else if (currentInMPContainer()) {
    return getUserInfo$2(context);
  } else if (currentInLgContainer()) {
    return Promise.resolve(_getUserInfoV2(context));
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await _getUserInfoV2$1();
      resolve(result);
    });
  } else if (currentInCloudAppContainer()) {
    return new Promise((resolve) => {
      resolve(NioCloudAppJsBridge.getLoginInfo());
    });
  } else if (data.uniLogin) {
    return getUserInfo$4(context);
  } else {
    return currentNotSupport();
  }
}
function getWSConnect(env = "prod", config) {
  sendEvent({
    name: "getWSConnect",
    context: JSON.stringify(config),
    wsEnv: env
  }).then();
  if (jsbridgeWebsocket.wsInstance === null) {
    jsbridgeWebsocket.open(env, config);
  }
  return jsbridgeWebsocket;
}
function startLiveModel() {
  sendEvent({
    name: "startLiveModel",
    context: JSON.stringify({}),
    wsEnv: "test"
  }).then();
  if (jsbridgeWebsocket.wsInstance === null) {
    jsbridgeWebsocket.open("test", {});
  }
  return jsbridgeWebsocket;
}
function getBridgeJSONSchema() {
  return getJSONSchema();
}
function reportLiving(env) {
  if (currentInLiveContainer()) {
    reportLiving$1(env);
  }
}
function initMockData(data) {
  mockData = data;
}
function monitorLiving(env, uuid, callback) {
  monitorLiving$1(env, uuid, callback);
}
function currentInNioCNApp() {
  return currentInNioCNiOS() || currentInNioCNAndroid();
}
function currentInAlpsCNApp() {
  return currentInAlpsCNiOS() || currentInAlpsCNAndroid();
}
function currentInNioEUApp() {
  return currentInNioEUiOS() || currentInNioEUAndroid();
}
function showToast(context) {
  sendEvent({
    name: "showToast",
    context: JSON.stringify(context)
  }).then();
  if (isString(context)) {
    context = { data: { content: (
      /**@type string */
      context
    ) } };
  }
  const { data = {} } = context;
  const { content = "" } = data;
  const newContext = { data: { content } };
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return showToast$3(newContext);
  } else if (currentInMPContainer()) {
    return showToast$2(newContext);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    showToast$1(newContext);
    return currentExecSuccess();
  } else if (currentInCloudAppContainer()) {
    NioCloudAppJsBridge.showToast(content);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function showLoading(context) {
  sendEvent({
    name: "showLoading",
    context: JSON.stringify(context)
  }).then();
  if (isObject(context)) {
    checker(context);
  } else {
    context = {
      data: {
        content: context
      }
    };
  }
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return showLoading$3(context);
  } else if (currentInMPContainer()) {
    return showLoading$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    showLoading$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function hideLoading(context = {}) {
  sendEvent({
    name: "hideLoading",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return hideLoading$3();
  } else if (currentInMPContainer()) {
    return hideLoading$2();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    hideLoading$1();
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function closeKeyboard(context = {}) {
  sendEvent({
    name: "closeKeyboard",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    closeKeyboard$1();
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function makeCall(context) {
  sendEvent({
    name: "makeCall",
    context: JSON.stringify(context)
  }).then();
  if (isObject(context)) {
    checker(context);
  }
  const { data = {} } = context;
  const { tel = "" } = data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return makeCall$3(context);
  } else if (currentInMPContainer()) {
    return makeCall$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    makeCall$1({ data: { tel } });
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function setCopyText(context) {
  sendEvent({
    name: "setCopyText",
    context: JSON.stringify(context)
  }).then();
  let content = "";
  if (typeof context === "string") {
    content = context;
  } else if (isObject(context)) {
    checker(context);
    const { data = {} } = context;
    content = data.content || "";
  }
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return setCopyText$3(context);
  } else if (currentInMPContainer()) {
    return setCopyText$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    setCopyText$1({ data: { content } });
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function pullRefresh(context) {
  sendEvent({
    name: "pullRefresh",
    context: JSON.stringify(context)
  }).then();
  if (isObject(context)) {
    checker(context);
  }
  const { data = {} } = context;
  const { type = "0" } = data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    pullRefresh$1({ data: { type } });
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function getAppInfo(context = {}) {
  sendEvent({
    name: "getAppInfo",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getAppInfo"]) {
      return Promise.resolve(window["mockData"]["getAppInfo"]);
    }
    if (mockData && mockData["getAppInfo"]) {
      return Promise.resolve(mockData["getAppInfo"]);
    }
    return Promise.resolve(mockJsbridgeForType("AppInfoResult"));
  } else if (currentInLiveContainer()) {
    return getAppInfo$3();
  } else if (currentInMPContainer()) {
    return getAppInfo$2();
  } else if (currentInLgContainer()) {
    const result = getAppInfo$1();
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await getAppInfo$4();
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function getBindMobileMP(context) {
  sendEvent({
    name: "getBindMobileMP",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType("BindMobileMPResult"));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return getBindMobileMP$1();
  } else {
    return currentNotSupport();
  }
}
function openCustomerServiceChatMP(context) {
  sendEvent({
    name: "openCustomerServiceChatMP",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType("OpenCustomerServiceChatMPResult"));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return openCustomerServiceChatMP$1(context);
  } else {
    return currentNotSupport();
  }
}
function getUserInfoForTitan(context) {
  sendEvent({
    name: "getUserInfoForTitan",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType("TitanUserInfoResult"));
  } else if (currentInLiveContainer()) {
    return getUserInfoForTitan$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  }
  return Promise.resolve(getUserInfoForTitan$1(context));
}
function toLoginForTitan(context) {
  sendEvent({
    name: "toLoginForTitan",
    context: JSON.stringify(context)
  }).then();
  if (currentInNioTitanAndroid()) {
    return Promise.resolve(toLoginForTitan$1(context));
  }
  return currentNotSupport();
}
function getOSInfo(context = {}) {
  sendEvent({
    name: "getOSInfo",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getOSInfo"]) {
      return Promise.resolve(window["mockData"]["getOSInfo"]);
    }
    if (mockData && mockData["getOSInfo"]) {
      return Promise.resolve(mockData["getOSInfo"]);
    }
    return Promise.resolve(mockJsbridgeForType("OSInfoResult"));
  } else if (currentInLiveContainer()) {
    return getOSInfo$3();
  } else if (currentInMPContainer()) {
    return getOSInfo$2();
  } else if (currentInLgContainer()) {
    const result = getOSInfo$1();
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await getOSInfo$4();
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
async function getVehicleInfo(context = {}) {
  sendEvent({
    name: "getVehicleInfo",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getVehicleInfo"]) {
      return Promise.resolve(window["mockData"]["getVehicleInfo"]);
    }
    if (mockData && mockData["getVehicleInfo"]) {
      return Promise.resolve(mockData["getVehicleInfo"]);
    }
    const result = await mockJsbridgeForType("GetVehicleInfoResult");
    return Promise.resolve(result);
  } else if (currentInLiveContainer()) {
    return getVehicleInfo$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      getVehicleInfo$1({
        callback(result) {
          if (!result.data) {
            result = {
              ...result,
              data: []
            };
          }
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function getModuleInfo(context = {}) {
  sendEvent({
    name: "getModuleInfo",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getModuleInfo"]) {
      return Promise.resolve(window["mockData"]["getModuleInfo"]);
    }
    if (mockData && mockData["getModuleInfo"]) {
      return Promise.resolve(mockData["getModuleInfo"]);
    }
    return Promise.resolve(mockJsbridgeForType("ModuleInfoResult"));
  } else if (currentInLiveContainer()) {
    return getModuleInfo$2();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer()) {
    const result = getModuleInfo$1();
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await getModuleInfo$3();
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function getDebugInfo(context = {}) {
  sendEvent({
    name: "getDebugInfo",
    context: JSON.stringify(context)
  }).then();
  if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLiveContainer()) {
    return getDebugInfo$2();
  } else if (currentInLgContainer()) {
    const result = getDebugInfo$1();
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = getDebugInfo$1();
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function getNotificationSettings(context) {
  sendEvent({
    name: "getNotificationSettings",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getNotificationSettings"]) {
      return Promise.resolve(window["mockData"]["getNotificationSettings"]);
    }
    if (mockData && mockData["getNotificationSettings"]) {
      return Promise.resolve(mockData["getNotificationSettings"]);
    }
    return Promise.resolve(mockJsbridgeForType("NotificationSettingsResult"));
  } else if (currentInLiveContainer()) {
    return getNotificationSettings$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      getNotificationSettings$1({
        callback: (result) => {
          if (currentInNioCNAndroid() || currentInNioEUAndroid() || currentInNioTitanAndroid() || currentInAlpsCNAndroid()) {
            result = {
              ...result,
              // Android 只返回了 一个 boolean 值, 转换兼容下
              data: {
                hasPermisstion: result.data
              }
            };
          }
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function getLocation(context = {}) {
  sendEvent({
    name: "getLocation",
    context: JSON.stringify(context)
  }).then();
  checker(context);
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getLocation"]) {
      return Promise.resolve(window["mockData"]["getLocation"]);
    }
    if (mockData && mockData["getLocation"]) {
      return Promise.resolve(mockData["getLocation"]);
    }
    return Promise.resolve(mockJsbridgeForType("LocationResult"));
  } else if (currentInLiveContainer()) {
    return getLocation$3(context);
  } else if (currentInMPContainer()) {
    return getLocation$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      getLocation$1({
        data: context.data,
        callback(result) {
          const { result_code } = result;
          if (result_code === "success") {
            const { data = {} } = result;
            const { latitude = "", longitude = "" } = data;
            if (latitude && longitude) {
              result.data = /**@type {any}*/
              {
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude)
              };
            }
          }
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function iosAllowsBackForwardNavigationGestures(context = {}) {
  sendEvent({
    name: "iosAllowsBackForwardNavigationGestures",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return iosAllowsBackForwardNavigationGestures$2();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    iosAllowsBackForwardNavigationGestures$1();
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function openMap(context = {}) {
  sendEvent({
    name: "openMap",
    context: JSON.stringify(context)
  }).then();
  const { data = {} } = context;
  const { latitude, longitude, addressName, poi_name, coord_type } = data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openMap$3(context);
  } else if (currentInMPContainer()) {
    return openMap$2(context);
  } else if (currentInCloudAppContainer()) {
    NioCloudAppJsBridge.openMap({
      data: {
        latitude,
        longitude,
        addressName,
        coord_type
      }
    });
    return currentExecSuccess();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    openMap$1({
      data: {
        latitude,
        longitude,
        addressName,
        poi_name,
        coord_type
      }
    });
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function iosDisableBackForwardNavigationGestures(context = {}) {
  sendEvent({
    name: "iosDisableBackForwardNavigationGestures",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return iosDisableBackForwardNavigationGestures$2();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    iosDisableBackForwardNavigationGestures$1();
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function iosDisableIOSSystemKeyboardObserver(context = {}) {
  sendEvent({
    name: "iosDisableIOSSystemKeyboardObserver",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    iosDisableIOSSystemKeyboardObserver$1();
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function openPDF(context) {
  sendEvent({
    name: "openPDF",
    context: JSON.stringify(context)
  }).then();
  const { data = {} } = context;
  const { url = "" } = data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openPDF$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    if (currentInNioCNAndroid()) {
      return new Promise((resolve) => {
        openPDF$1({
          data: { url },
          callback(result) {
            resolve(result);
          }
        });
      });
    } else {
      return currentNotSupport();
    }
  } else {
    return currentNotSupport();
  }
}
function showCountries(context) {
  sendEvent({
    name: "showCountries",
    context: JSON.stringify(context)
  }).then();
  const { data = {} } = context;
  const { content = "" } = data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType("CountriesResult"));
  } else if (currentInLiveContainer()) {
    return showCountries$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    if (currentInNioCNApp()) {
      return currentNotSupport();
    }
    return new Promise((resolve) => {
      showCountries$1({
        data: { content },
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function downloadVideo(context) {
  sendEvent({
    name: "downloadVideo",
    context: JSON.stringify(context)
  }).then();
  const { data = {} } = context;
  const { video_url = "" } = data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return downloadVideo$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      downloadVideo$1({
        data: { video_url },
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
async function imagePicker(context) {
  sendEvent({
    name: "imagePicker",
    context: JSON.stringify(context)
  }).then();
  const { data } = context;
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["imagePicker"]) {
      return Promise.resolve(window["mockData"]["imagePicker"]);
    }
    if (mockData && mockData["imagePicker"]) {
      return Promise.resolve(mockData["imagePicker"]);
    }
    const result = await mockJsbridgeForType("ImagePickerResult");
    return Promise.resolve(result);
  } else if (currentInLiveContainer()) {
    return imagePicker$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      imagePicker$1({
        data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function mediaPicker(context) {
  sendEvent({
    name: "mediaPicker",
    context: JSON.stringify(context)
  }).then();
  return imagePicker(context);
}
function selectImage(context) {
  sendEvent({
    name: "selectImage",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return selectImage$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      selectImage$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function saveImage(context) {
  sendEvent({
    name: "saveImage",
    context: JSON.stringify(context)
  }).then();
  checker(context);
  const { urls = [], base64Images = [], shouldShowToast = 1 } = context.data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return saveImage$3(context);
  } else if (currentInMPContainer()) {
    return saveImage$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      saveImage$1({
        data: { urls, base64Images, shouldShowToast },
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function previewPhoto(context) {
  sendEvent({
    name: "previewPhoto",
    context: JSON.stringify(context)
  }).then();
  checker(context);
  const { urls, position = 0 } = context.data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return previewPhoto$3(context);
  } else if (currentInMPContainer()) {
    return previewPhoto$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    previewPhoto$1({
      data: { urls, position },
      callback(result) {
        if (context.callback) {
          context.callback(result);
        }
      }
    });
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function scanQR(context) {
  sendEvent({
    name: "scanQR",
    context: JSON.stringify(context)
  }).then();
  checker(context);
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["scanQR"]) {
      return Promise.resolve(window["mockData"]["scanQR"]);
    }
    if (mockData && mockData["scanQR"]) {
      return Promise.resolve(mockData["scanQR"]);
    }
    return Promise.resolve(mockJsbridgeForType("ScanQRResult"));
  } else if (currentInLiveContainer()) {
    return scanQR$3(context);
  } else if (currentInMPContainer()) {
    return scanQR$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      scanQR$1({
        data: context.data,
        callback(res) {
          resolve(res);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function close(context = {}) {
  sendEvent({
    name: "close",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return close$2();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    close$1();
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function setHeaderOption(context) {
  sendEvent({
    name: "setHeaderOption",
    context: JSON.stringify(context)
  }).then();
  checker(context);
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return setHeaderOption$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    setHeaderOption$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function openLoginPage(context = {}) {
  sendEvent({
    name: "openLoginPage",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openLoginPage$2();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      openLoginPage$1({
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function openURL(context) {
  sendEvent({
    name: "openURL",
    context: JSON.stringify(context)
  }).then();
  const { data = {} } = context;
  const { url = "" } = data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openURL$3(context);
  } else if (currentInMPContainer()) {
    return openURL$2({ data: { url } });
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      openURL$1({
        data: { url },
        callback(res) {
          resolve(res);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function replace(context) {
  sendEvent({
    name: "replace",
    context: JSON.stringify(context)
  }).then();
  let url = isString(context) ? context : context.data.url;
  const newContext = { data: { url } };
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return replace$3(newContext);
  } else if (currentInMPContainer()) {
    return replace$2(newContext);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      replace$1({
        ...newContext,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function setPageIdentifier(context) {
  sendEvent({
    name: "setPageIdentifier",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return setPageIdentifier$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    setPageIdentifier$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function back(context) {
  sendEvent({
    name: "back",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    back$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function pay(context) {
  sendEvent({
    name: "pay",
    context: JSON.stringify(context)
  }).then();
  const { amount, merchantNo, payOrderNo } = context.data;
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return pay$3(context);
  } else if (currentInMPContainer()) {
    return pay$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      pay$1({
        data: { ...context.data, amount, merchantNo, payOrderNo },
        callback: (res) => {
          resolve(res);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function share(context) {
  sendEvent({
    name: "share",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return share$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      share$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function share2(context) {
  sendEvent({
    name: "share2",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return share2$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      share2$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function shareImage(context) {
  sendEvent({
    name: "shareImage",
    context: JSON.stringify(context)
  }).then();
  checker(context);
  const { url, type } = context.data;
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["shareImage"]) {
      return Promise.resolve(window["mockData"]["shareImage"]);
    }
    if (mockData && mockData["shareImage"]) {
      return Promise.resolve(mockData["shareImage"]);
    }
    return Promise.resolve(mockJsbridgeForType("ShareImageResult"));
  } else if (currentInLiveContainer()) {
    return shareImage$3(context);
  } else if (currentInMPContainer()) {
    return shareImage$2(context);
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return shareImage$1({ data: { url, type } });
  } else {
    return currentNotSupport();
  }
}
function openExternalBrowser(context) {
  sendEvent({
    name: "openExternalBrowser",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openExternalBrowser$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    openExternalBrowser$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function openNioInputEdit(context) {
  sendEvent({
    name: "openNioInputEdit",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openNioInputEdit$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      openNioInputEdit$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function openNioInputEdit2(context) {
  sendEvent({
    name: "openNioInputEdit2",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openNioInputEdit2$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      openNioInputEdit2$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function postUGC(context) {
  sendEvent({
    name: "postUGC",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return postUGC$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      postUGC$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function report(context) {
  sendEvent({
    name: "report",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return report$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      report$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function postNotificationFromHtmlToNative(context) {
  sendEvent({
    name: "postNotificationFromHtmlToNative",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return postNotificationFromHtmlToNative$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    postNotificationFromHtmlToNative$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function iosToggleBounces(context) {
  sendEvent({
    name: "iosToggleBounces",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return iosToggleBounces$1(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    iosToggleBounch({
      data: context.data
    });
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function getCurrencyFormat(context) {
  sendEvent({
    name: "getCurrencyFormat",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getCurrencyFormat"]) {
      return Promise.resolve(window["mockData"]["getCurrencyFormat"]);
    }
    if (mockData && mockData["getCurrencyFormat"]) {
      return Promise.resolve(mockData["getCurrencyFormat"]);
    }
    return Promise.resolve(mockJsbridgeForType("CurrencyFormatResult"));
  } else if (currentInLiveContainer()) {
    return getCurrencyFormat$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer()) {
    const result = getCurrencyFormat$1({ data: context.data });
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await getCurrencyFormat$3({ data: context.data });
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function getNumberFormat(context) {
  sendEvent({
    name: "getNumberFormat",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["getNumberFormat"]) {
      return Promise.resolve(window["mockData"]["getNumberFormat"]);
    }
    if (mockData && mockData["getNumberFormat"]) {
      return Promise.resolve(mockData["getNumberFormat"]);
    }
    return Promise.resolve(mockJsbridgeForType("NumberFormatResult"));
  } else if (currentInLiveContainer()) {
    return getNumberFormat$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer()) {
    const result = getNumberFormat$1({ data: context.data });
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await getNumberFormat$3({ data: context.data });
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function register(context) {
  sendEvent({
    name: "register",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    register$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function requestReward(context) {
  sendEvent({
    name: "requestReward",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return requestReward$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return requestReward$1({
      data: context.data
    });
  } else {
    return currentNotSupport();
  }
}
function imageLongPress(context) {
  sendEvent({
    name: "imageLongPress",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    if (currentInNioEUApp() || currentInAlpsCNApp()) {
      return currentNotSupport();
    }
    const { data = {} } = context;
    imageLongPress$1({
      data: data.url
    });
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function translate(context) {
  sendEvent({
    name: "translate",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    if (window["mockData"] && window["mockData"]["translate"]) {
      return Promise.resolve(window["mockData"]["translate"]);
    }
    if (mockData && mockData["translate"]) {
      return Promise.resolve(mockData["translate"]);
    }
    return Promise.resolve(mockJsbridgeForType("TranslateResult"));
  } else if (currentInLiveContainer()) {
    return translate$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise((resolve) => {
      translate$1({
        data: context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function setBackActionEnable(context) {
  sendEvent({
    name: "setBackActionEnable",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    setBackActionEnable$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function getScrambleId(context) {
  sendEvent({
    name: "getScrambleId",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return getScrambleId$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer()) {
    const { data = {} } = context;
    let result = getScrambleId$1({
      data: data.id
    });
    result = {
      ...result,
      data: {
        result: result.data
      }
    };
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const { data = {} } = context;
      const result = await getScrambleId$3({
        data: data.id
      });
      result.data = {
        result: result.data
      };
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function notificationAuthorizationStatus(context = {}) {
  sendEvent({
    name: "notificationAuthorizationStatus",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return notificationAuthorizationStatus$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    if (currentInNioCNAndroid() || currentInNioEUAndroid() || currentInAlpsCNAndroid() || currentInNioTitanAndroid()) {
      return currentNotSupport();
    }
    return new Promise((resolve) => {
      notificationAuthorizationStatus$1({
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
async function openAppSetting(context = {}) {
  sendEvent({ name: "openAppSetting", context: JSON.stringify(context) }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openAppSetting$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    if (currentInNioEUiOS() || currentInNioEUAndroid()) {
      openNotificationSetting$1();
    } else if (currentInNioCNAndroid()) {
      const result = await getAppInfo({});
      const { data = {} } = result;
      const { version: version2 = "" } = data;
      if (semverGte(version2, "5.19.0")) {
        openAppSetting$1({});
      } else {
        openNotificationSetting$1();
      }
    } else {
      openAppSetting$1({});
    }
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function openNotificationSetting(context = {}) {
  sendEvent({ name: "openNotificationSetting", context: JSON.stringify(context) }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return openNotificationSetting$2();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    openNotificationSetting$1();
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
function getInvoiceDetail(context) {
  sendEvent({
    name: "getInvoiceDetail",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return getInvoiceDetail$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    if (currentInNioCNApp()) {
      return new Promise((resolve) => {
        getInvoiceDetail$1({
          data: context.data,
          callback(result) {
            resolve(result);
          }
        });
      });
    } else {
      return currentNotSupport();
    }
  } else {
    return currentNotSupport();
  }
}
function addCalendarEvent(context) {
  sendEvent({
    name: "addCalendarEvent",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return addCalendarEvent$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    if (currentInNioCNiOS() || currentInAlpsCNiOS()) {
      return new Promise((resolve) => {
        addCalendarEvent$1({
          data: context.data,
          callback(result) {
            resolve(result);
          }
        });
      });
    } else {
      return currentNotSupport();
    }
  } else {
    return currentNotSupport();
  }
}
function touchSlopAndroid(context) {
  sendEvent({
    name: "touchSlopAndroid",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return touchSlopAndroid$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer()) {
    if (currentInNioCNAndroid()) {
      const result = touchSlopAndroid$1(context);
      return Promise.resolve(result);
    } else {
      return currentNotSupport();
    }
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await touchSlopAndroid$3(context);
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function requestEventAndroid(context) {
  sendEvent({
    name: "requestEventAndroid",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return requestEventAndroid$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer()) {
    const result = requestEventAndroid$1(context);
    return Promise.resolve(result);
  } else if (currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      const result = await requestEventAndroid$3(context);
      resolve(result);
    });
  } else {
    return currentNotSupport();
  }
}
function sendPOI(context) {
  sendEvent({
    name: "sendPOI",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return sendPOI$2(context);
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer() || currentInWebFContainer()) {
    return new Promise(async (resolve) => {
      sendPOI$1({
        ...context.data,
        callback(result) {
          resolve(result);
        }
      });
    });
  } else {
    return currentNotSupport();
  }
}
function setShareConfigMP(context) {
  sendEvent({
    name: "setShareConfigMP",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return setShareConfigMP$1(context);
  } else if (currentInLgContainer()) {
    return currentNotSupport();
  } else if (currentInWebFContainer()) {
    return currentNotSupport();
  } else {
    return currentNotSupport();
  }
}
function getGlobalDataMP(context) {
  sendEvent({
    name: "getGlobalDataMP",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return getGlobalDataMP$1(context);
  } else if (currentInLgContainer()) {
    return currentNotSupport();
  } else if (currentInWebFContainer()) {
    return currentNotSupport();
  } else {
    return currentNotSupport();
  }
}
function setGlobalDataMP(context) {
  sendEvent({
    name: "setGlobalDataMP",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return Promise.resolve(mockJsbridgeForType(""));
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return setGlobalDataMP$1(context);
  } else if (currentInLgContainer()) {
    return currentNotSupport();
  } else if (currentInWebFContainer()) {
    return currentNotSupport();
  } else {
    return currentNotSupport();
  }
}
function reLaunchMP(context) {
  sendEvent({
    name: "reLaunchMP",
    context: JSON.stringify(context)
  }).then();
  if (currentInMPContainer()) {
    return reLaunch(context);
  } else {
    return currentNotSupport();
  }
}
function getWXLoginCode(context) {
  sendEvent({
    name: "getWXLoginCode",
    context: JSON.stringify(context)
  }).then();
  if (currentInMPContainer()) {
    return getWXLoginCode$1(context);
  } else {
    return currentNotSupport();
  }
}
function setNavigationBarTitle(context) {
  sendEvent({
    name: "setNavigationBarTitle",
    context: JSON.stringify(context)
  }).then();
  if (currentInMPContainer()) {
    return setNavigationBarTitle$1(context);
  } else {
    return currentNotSupport();
  }
}
function switchBackActionControl(context) {
  sendEvent({
    name: "switchBackActionControl",
    context: JSON.stringify(context)
  }).then();
  if (currentInLgContainer()) {
    switchBackActionControl$1(context);
    return currentExecSuccess();
  } else {
    return currentNotSupport();
  }
}
async function changeStatusBarStyle(context) {
  sendEvent({
    name: "changeStatusBarStyle",
    context: JSON.stringify(context)
  }).then();
  if (currentInMockContainer()) {
    return currentExecSuccess();
  } else if (currentInLiveContainer()) {
    return currentNotSupport();
  } else if (currentInMPContainer()) {
    return currentNotSupport();
  } else if (currentInLgContainer()) {
    const result = await getAppInfo({});
    const { data = {} } = result;
    const { version: version2 = "" } = data;
    if (currentInNioCNAndroid()) {
      if (semverGte(version2, "5.18.0")) {
        return Promise.resolve(
          changeStatusBarStyle$1({
            data: context.data
          })
        );
      } else {
        return currentNotSupport();
      }
    } else if (currentInNioCNiOS()) {
      if (semverGte(version2, "5.14.0")) {
        return Promise.resolve(
          changeStatusBarStyle$1({
            data: context.data
          })
        );
      } else {
        return currentNotSupport();
      }
    } else {
      return currentNotSupport();
    }
  } else if (currentInWebFContainer())
    ;
  else {
    return currentNotSupport();
  }
}
async function applyJoinGroup(context = {}) {
  sendEvent({
    name: "applyJoinGroup",
    context: JSON.stringify(context)
  }).then();
  if (currentInLgContainer()) {
    const result = await getAppInfo({});
    const { data = {} } = result;
    const { version: version2 = "" } = data;
    if (currentInNioCNiOS()) {
      if (semverGte(version2, "5.18.0")) {
        return new Promise((resolve) => {
          applyJoinGroup$1({
            data: context.data,
            callback(result2) {
              resolve(result2);
            }
          });
        });
      } else {
        return currentNotSupport();
      }
    } else if (currentInNioCNAndroid()) {
      if (semverGte(version2, "5.18.0")) {
        return new Promise((resolve) => {
          applyJoinGroup$1({
            data: context.data,
            callback(result2) {
              if (result2.data && result2.data["nameValuePairs"]) {
                result2.data = result2.data["nameValuePairs"];
              }
              resolve(result2);
            }
          });
        });
      } else {
        return currentNotSupport();
      }
    }
  } else {
    return currentNotSupport();
  }
}
async function invokeAnonymousBridge(context) {
  return invokeAnonymousBridge$1(context);
}
const universalBridge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCalendarEvent,
  applyJoinGroup,
  back,
  changeStatusBarStyle,
  close,
  closeKeyboard,
  currentInAlpsCNApp,
  currentInAlpsCNiOS,
  currentInCloudAppContainer,
  currentInLgContainer,
  currentInLiveContainer,
  currentInMPContainer,
  currentInMockContainer,
  currentInNioCNAndroid,
  currentInNioCNApp,
  currentInNioCNiOS,
  currentInNioEUAndroid,
  currentInNioEUApp,
  currentInNioEUiOS,
  currentInNioTitanAndroid,
  currentInSWCContainer,
  currentInWebFContainer,
  downloadVideo,
  getAppInfo,
  getBindMobileMP,
  getBridgeJSONSchema,
  getCurrencyFormat,
  getDebugInfo,
  getGlobalDataMP,
  getInvoiceDetail,
  getLocation,
  getModuleInfo,
  getNotificationSettings,
  getNumberFormat,
  getOSInfo,
  getScrambleId,
  getUserInfo,
  getUserInfoForTitan,
  getVehicleInfo,
  getWSConnect,
  getWXLoginCode,
  hideLoading,
  imageLongPress,
  imagePicker,
  initMockData,
  invokeAnonymousBridge,
  iosAllowsBackForwardNavigationGestures,
  iosDisableBackForwardNavigationGestures,
  iosDisableIOSSystemKeyboardObserver,
  iosToggleBounces,
  makeCall,
  mediaPicker,
  monitorLiving,
  notificationAuthorizationStatus,
  openAppSetting,
  openCustomerServiceChatMP,
  openExternalBrowser,
  openLoginPage,
  openMap,
  openNioInputEdit,
  openNioInputEdit2,
  openNotificationSetting,
  openPDF,
  openURL,
  pay,
  postNotificationFromHtmlToNative,
  postUGC,
  previewPhoto,
  pullRefresh,
  reLaunchMP,
  register,
  replace,
  report,
  reportLiving,
  requestEventAndroid,
  requestReward,
  saveImage,
  scanQR,
  selectImage,
  sendPOI,
  setBackActionEnable,
  setCopyText,
  setGlobalDataMP,
  setHeaderOption,
  setNavigationBarTitle,
  setPageIdentifier,
  setShareConfigMP,
  share,
  share2,
  shareImage,
  showCountries,
  showLoading,
  showToast,
  startLiveModel,
  storage,
  switchBackActionControl,
  toLoginForTitan,
  touchSlopAndroid,
  translate
}, Symbol.toStringTag, { value: "Module" }));
let nextMonth = new Date((/* @__PURE__ */ new Date()).setMonth((/* @__PURE__ */ new Date()).getMonth() + 1));
let expire = nextMonth.getTime();
const universalStorage = {
  /**
   * 设置 key value
   *
   * 注意: Android 存 value: number 的时候, value 取出来会标成字符串.
   * eg: value:10, 取出来后变成了 value: '10', 这种情况可以用对象存, 可以规避这个问题.
   * eg: value:{id:10}, 取出来后还是 value:{id:10}
   *
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - 需要存储值对应的 key
   * @param {any}    context.data.value - 需要存储的值
   * @param {number} [context.data.expire] - 过期时间. (单位: 毫秒), 默认有效期: 1个月
   */
  async set(context) {
    checker(context);
    context.data.expire = new Date(context.data.expire || expire).getTime();
    const result = await getOSInfo();
    const { data = {} } = result;
    if (data.systemName.toLowerCase() === "ios") {
      context.data.expire = context.data.expire / 1e3;
    }
    getDsBridge$2().call("setStorageValue", context.data);
  },
  /**
   * 获取 key 对应的 value
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - key
   *
   * @return {Promise<import('../types').ExecuteResult<{key:string, value:any}>>} 存储的对象
   */
  async get(context) {
    var _a;
    checker(context);
    let result = getDsBridge$2().call("getStorageValue", context.data.key);
    const { result_code = "", display_message = "" } = result;
    if (result_code === "unkonw_error" && display_message === "Missing value in cache") {
      return {
        data: {
          value: "",
          key: context.data.key
        },
        result_code: "success"
      };
    }
    const osInfoResult = await getOSInfo();
    const { data = {} } = osInfoResult;
    if (data.systemName.toLowerCase() === "android") {
      let tmp = result.data;
      try {
        let formattedValue = JSON.parse(result.data);
        if (typeof formattedValue !== "object") {
          throw new Error("not valid");
        }
        result.data = {};
        result.data.value = formattedValue;
      } catch (e) {
        result.data = {};
        result.data.value = tmp;
      }
      result.data.key = context.data.key;
    } else {
      if ((_a = result.data) == null ? void 0 : _a.expire) {
        delete result.data.expire;
      }
    }
    return result;
  },
  /**
   * 删除 key 对应的 value
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - key
   * @param context
   */
  remove(context) {
    checker(context);
    getDsBridge$2().call("removeStorage", context.data.key);
  },
  /**
   * 删除 key 对应的 value
   * @param {object} context - context
   * @param {object} context.data - data
   * @param {string} context.data.key - key
   * @param context
   */
  delete(context) {
    checker(context);
    getDsBridge$2().call("removeStorage", context.data.key);
  },
  /**
   * @description 清除所有 慎用，会把app 存储没有 domain 概念会导致全部清除
   */
  clear() {
    getDsBridge$2().call("clearStorage", "");
  }
};
export {
  BRIDGE_CONSTANT as constant,
  universalBridge as nioJsBridge,
  storage,
  universalStorage
};



// WEBPACK FOOTER //
// ./node_modules/@nio-wad/universal-bridge-h5/dist/index.esm.js